/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** UserRole */
export enum UserRole {
  Investor = "investor",
  Issuer = "issuer",
  IssuerAdmin = "issuer_admin",
  SuperAdmin = "super_admin",
  ComplianceAdmin = "compliance_admin",
  ComplianceUser = "compliance_user",
  LoansAdmin = "loans_admin",
  LoansUser = "loans_user",
  AcademyUser = "academy_user",
  AcademyOrganisationAdmin = "academy_organisation_admin",
}

/** TransferShareholderType */
export enum TransferShareholderType {
  Exist = "exist",
  New = "new",
}

/** TransactionType */
export enum TransactionType {
  BuyBack = "buy_back",
  Drp = "drp",
  Redemption = "redemption",
  Subscription = "subscription",
  OpeningBalance = "opening_balance",
}

/** TransactionStatus */
export enum TransactionStatus {
  Pending = "pending",
  InvestorPending = "investor_pending",
  AwaitingPayment = "awaiting_payment",
  Completed = "completed",
  Unsuccessfull = "unsuccessfull",
  DividendPending = "dividend_pending",
}

/** SortedBy */
export enum SortedBy {
  RequestedAtDate = "requested_at_date",
  Status = "status",
}

/** SortBy */
export enum SortBy {
  Date = "date",
  AssetType = "asset_type",
  Alphabetical = "alphabetical",
  TotalAssetValue = "total_asset_value",
  TotalPortfolioValue = "total_portfolio_value",
}

/** ShareCertificateStatus */
export enum ShareCertificateStatus {
  Current = "current",
  Outdated = "outdated",
}

/** RoundingType */
export enum RoundingType {
  Up = "up",
  Down = "down",
}

/** RoundTo */
export enum RoundTo {
  Up = "up",
  Down = "down",
}

/** ReportType */
export enum ReportType {
  Transaction = "transaction",
  HoldingStatement = "holding_statement",
  Capital = "capital",
  CapitalMovement = "capital_movement",
  RegisterList = "register_list",
  SimpleRegisterList = "simple_register_list",
  RegisterValuation = "register_valuation",
  TopHolders = "top_holders",
  CommunicationsPreferences = "communications_preferences",
  Dividend = "dividend",
  DividendStatement = "dividend_statement",
  InvestorDistribution = "investor_distribution",
  Valuation = "valuation",
  DividendPayments = "dividend_payments",
  TaxReturn = "tax_return",
  SelfCustodyAssetReport = "self_custody_asset_report",
}

/** ReportStatus */
export enum ReportStatus {
  Generating = "generating",
  Completed = "completed",
  Failed = "failed",
  Stale = "stale",
}

/** ReportFormat */
export enum ReportFormat {
  Xlsx = "xlsx",
  Pdf = "pdf",
}

/** RegisterType */
export enum RegisterType {
  Company = "company",
  Fund = "fund",
}

/** PortfolioTransactionType */
export enum PortfolioTransactionType {
  TradeBuySettle = "trade_buy_settle",
  TradeBuyBook = "trade_buy_book",
  TradeSellSettle = "trade_sell_settle",
  TradeSellBook = "trade_sell_book",
  IncomeDividendCash = "income_dividend_cash",
  IncomeDividendReinvestment = "income_dividend_reinvestment",
  IncomeRental = "income_rental",
  IncomeCashInterest = "income_cash_interest",
  Fee = "fee",
  Revaluation = "revaluation",
  Split = "split",
  BrokerDeposit = "broker_deposit",
  BrokerWithdraw = "broker_withdraw",
  BrokerCurrencyConversion = "broker_currency_conversion",
}

/** PortfolioTransactionStatus */
export enum PortfolioTransactionStatus {
  Completed = "completed",
  Pending = "pending",
  Cancelled = "cancelled",
}

/** PaymentStatus */
export enum PaymentStatus {
  Pending = "pending",
  Completed = "completed",
  Unsuccessfull = "unsuccessfull",
}

/** PaymentDirection */
export enum PaymentDirection {
  FundToInvestor = "fund_to_investor",
  InvestorToFund = "investor_to_fund",
}

/** KeycloakRole */
export enum KeycloakRole {
  SrAdmin = "sr_admin",
  SrInvestor = "sr_investor",
  SrIssuer = "sr_issuer",
  SrIssuerAdmin = "sr_issuer_admin",
  ComplianceAdmin = "compliance_admin",
  ComplianceUser = "compliance_user",
  LoansAdmin = "loans_admin",
  LoansUser = "loans_user",
  AcademyUser = "academy_user",
  AcademyOrganisationAdmin = "academy_organisation_admin",
}

/** KeycloakIssuerRole */
export enum KeycloakIssuerRole {
  SrIssuer = "sr_issuer",
  SrIssuerAdmin = "sr_issuer_admin",
}

/** InvestorEditsStatus */
export enum InvestorEditsStatus {
  Rejected = "rejected",
  Approved = "approved",
  Pending = "pending",
  InProgress = "in_progress",
}

/** HolderSelectionMode */
export enum HolderSelectionMode {
  SelectedHolders = "selected_holders",
  AllHolders = "all_holders",
  NonZeroHolders = "non_zero_holders",
}

/** GicsIndustry */
export enum GicsIndustry {
  Energy = "Energy",
  Materials = "Materials",
  Industrials = "Industrials",
  ConsumerDiscretionary = "Consumer Discretionary",
  ConsumerStaples = "Consumer Staples",
  HealthCare = "Health Care",
  Financials = "Financials",
  InformationTechnology = "Information Technology",
  CommunicationServices = "Communication Services",
  Utilities = "Utilities",
  RealEstate = "Real Estate",
  Diversified = "Diversified",
}

/** EventLogType */
export enum EventLogType {
  EntityCreated = "entity_created",
  EntityAwaitedApproval = "entity_awaited_approval",
  EntityApproval = "entity_approval",
  EntityUnsuccessfull = "entity_unsuccessfull",
  EntityUpdated = "entity_updated",
  TransactionCreated = "transaction_created",
  TransactionExpired = "transaction_expired",
  TransactionAwaitingPayment = "transaction_awaiting_payment",
  TransactionApproval = "transaction_approval",
  TransactionUnsuccessfull = "transaction_unsuccessfull",
  TransactionDividendPending = "transaction_dividend_pending",
  TransactionArchived = "transaction_archived",
  TransferCreated = "transfer_created",
  TransferApproval = "transfer_approval",
  TransferUnsuccessfull = "transfer_unsuccessfull",
  TransferArchived = "transfer_archived",
  PaymentCreated = "payment_created",
  PaymentApproval = "payment_approval",
  PaymentUnsuccessfull = "payment_unsuccessfull",
  NavCreated = "nav_created",
  NavUpdated = "nav_updated",
  NavDeleted = "nav_deleted",
  HolderTaxReportByYearCreated = "holder_tax_report_by_year_created",
  HolderTaxReportByYearUpdated = "holder_tax_report_by_year_updated",
  RegisterTotalFundByYearCreated = "register_total_fund_by_year_created",
  RegisterTotalFundByYearUpdated = "register_total_fund_by_year_updated",
  CommunicationCreated = "communication_created",
  DocumentCreated = "document_created",
  DocumentDeleted = "document_deleted",
  DividendCreated = "dividend_created",
  DividendFinalized = "dividend_finalized",
  DividendArchived = "dividend_archived",
  BuybackArchived = "buyback_archived",
  CorrespondenceCreated = "correspondence_created",
  CorrespondenceReplyCreated = "correspondence_reply_created",
  HolderEditRequestCreated = "holder_edit_request_created",
  HolderEditRequestApproved = "holder_edit_request_approved",
  PortfolioTransactionAiFailed = "portfolio_transaction_ai_failed",
  InvestorAddedFromRegister = "investor_added_from_register",
}

/** EntityType */
export enum EntityType {
  Individual = "individual",
  Company = "company",
  Trust = "trust",
  Partnership = "partnership",
  Association = "association",
  Smsf = "smsf",
}

/** EntityStatus */
export enum EntityStatus {
  EntityCreation = "entity_creation",
  EntityAwaitingApproval = "entity_awaiting_approval",
  EntityApproved = "entity_approved",
  EntityUnsuccessfull = "entity_unsuccessfull",
  PermanentlyRejected = "permanently_rejected",
}

/** EntityPreferredContactWay */
export enum EntityPreferredContactWay {
  Email = "email",
  PhysicalMail = "physical_mail",
}

/** EntitiesRegistrationType */
export enum EntitiesRegistrationType {
  Manual = "manual",
  SelfRegistered = "self_registered",
}

/** EntitiesPaymentInfoStatus */
export enum EntitiesPaymentInfoStatus {
  Verified = "verified",
  Unverified = "unverified",
}

/** DocumentOperationType */
export enum DocumentOperationType {
  Transfer = "transfer",
  Transaction = "transaction",
}

/** DividendType */
export enum DividendType {
  Franked = "Franked",
  Regular = "Regular",
}

/** DividendStatus */
export enum DividendStatus {
  Pending = "pending",
  Completed = "completed",
}

/** CurrencyEnum */
export enum CurrencyEnum {
  Usd = "usd",
  Eur = "eur",
  Gbp = "gbp",
  Jpy = "jpy",
  Aud = "aud",
  Cad = "cad",
  Chf = "chf",
  Cny = "cny",
  Hkd = "hkd",
  Nzd = "nzd",
  Sek = "sek",
  Nok = "nok",
  Dkk = "dkk",
  Pln = "pln",
  Czk = "czk",
  Rub = "rub",
  Uah = "uah",
  Try = "try",
  Huf = "huf",
  Ron = "ron",
  Sgd = "sgd",
  Thb = "thb",
  Idr = "idr",
  Myr = "myr",
  Php = "php",
  Krw = "krw",
  Inr = "inr",
  Mxn = "mxn",
  Brl = "brl",
  Clp = "clp",
  Ars = "ars",
  Cop = "cop",
  Pen = "pen",
  Zar = "zar",
  Aed = "aed",
  Ils = "ils",
  Sar = "sar",
  Egp = "egp",
  Ngn = "ngn",
}

/** CountryCodeEnum */
export enum CountryCodeEnum {
  AUS = "AUS",
  NZL = "NZL",
  USA = "USA",
  CHN = "CHN",
  AFG = "AFG",
  ALA = "ALA",
  ALB = "ALB",
  DZA = "DZA",
  ASM = "ASM",
  AND = "AND",
  AGO = "AGO",
  AIA = "AIA",
  ATA = "ATA",
  ATG = "ATG",
  ARG = "ARG",
  ARM = "ARM",
  ABW = "ABW",
  AUT = "AUT",
  AZE = "AZE",
  BHS = "BHS",
  BHR = "BHR",
  BGD = "BGD",
  BRB = "BRB",
  BLR = "BLR",
  BEL = "BEL",
  BLZ = "BLZ",
  BEN = "BEN",
  BMU = "BMU",
  BTN = "BTN",
  BOL = "BOL",
  BES = "BES",
  BIH = "BIH",
  BWA = "BWA",
  BVT = "BVT",
  BRA = "BRA",
  IOT = "IOT",
  UMI = "UMI",
  VGB = "VGB",
  VIR = "VIR",
  BRN = "BRN",
  BGR = "BGR",
  BFA = "BFA",
  BDI = "BDI",
  KHM = "KHM",
  CMR = "CMR",
  CAN = "CAN",
  CPV = "CPV",
  CYM = "CYM",
  CAF = "CAF",
  TCD = "TCD",
  CHL = "CHL",
  CXR = "CXR",
  CCK = "CCK",
  COL = "COL",
  COM = "COM",
  COD = "COD",
  COG = "COG",
  COK = "COK",
  CRI = "CRI",
  CIV = "CIV",
  HRV = "HRV",
  CUB = "CUB",
  CUW = "CUW",
  CYP = "CYP",
  CZE = "CZE",
  DNK = "DNK",
  DJI = "DJI",
  DMA = "DMA",
  DOM = "DOM",
  ECU = "ECU",
  EGY = "EGY",
  SLV = "SLV",
  GNQ = "GNQ",
  ERI = "ERI",
  EST = "EST",
  ETH = "ETH",
  FLK = "FLK",
  FRO = "FRO",
  FJI = "FJI",
  FIN = "FIN",
  FRA = "FRA",
  GUF = "GUF",
  PYF = "PYF",
  ATF = "ATF",
  GAB = "GAB",
  GMB = "GMB",
  GEO = "GEO",
  DEU = "DEU",
  GHA = "GHA",
  GIB = "GIB",
  GRC = "GRC",
  GRL = "GRL",
  GRD = "GRD",
  GLP = "GLP",
  GUM = "GUM",
  GTM = "GTM",
  GGY = "GGY",
  GIN = "GIN",
  GNB = "GNB",
  GUY = "GUY",
  HTI = "HTI",
  HMD = "HMD",
  VAT = "VAT",
  HND = "HND",
  HKG = "HKG",
  HUN = "HUN",
  ISL = "ISL",
  IND = "IND",
  IDN = "IDN",
  IRN = "IRN",
  IRQ = "IRQ",
  IRL = "IRL",
  IMN = "IMN",
  ISR = "ISR",
  ITA = "ITA",
  JAM = "JAM",
  JPN = "JPN",
  JEY = "JEY",
  JOR = "JOR",
  KAZ = "KAZ",
  KEN = "KEN",
  KIR = "KIR",
  KWT = "KWT",
  KGZ = "KGZ",
  LAO = "LAO",
  LVA = "LVA",
  LBN = "LBN",
  LSO = "LSO",
  LBR = "LBR",
  LBY = "LBY",
  LIE = "LIE",
  LTU = "LTU",
  LUX = "LUX",
  MAC = "MAC",
  MKD = "MKD",
  MDG = "MDG",
  MWI = "MWI",
  MYS = "MYS",
  MDV = "MDV",
  MLI = "MLI",
  MLT = "MLT",
  MHL = "MHL",
  MTQ = "MTQ",
  MRT = "MRT",
  MUS = "MUS",
  MYT = "MYT",
  MEX = "MEX",
  FSM = "FSM",
  MDA = "MDA",
  MCO = "MCO",
  MNG = "MNG",
  MNE = "MNE",
  MSR = "MSR",
  MAR = "MAR",
  MOZ = "MOZ",
  MMR = "MMR",
  NAM = "NAM",
  NRU = "NRU",
  NPL = "NPL",
  NLD = "NLD",
  NCL = "NCL",
  NIC = "NIC",
  NER = "NER",
  NGA = "NGA",
  NIU = "NIU",
  NFK = "NFK",
  PRK = "PRK",
  MNP = "MNP",
  NOR = "NOR",
  OMN = "OMN",
  PAK = "PAK",
  PLW = "PLW",
  PSE = "PSE",
  PAN = "PAN",
  PNG = "PNG",
  PRY = "PRY",
  PER = "PER",
  PHL = "PHL",
  PCN = "PCN",
  POL = "POL",
  PRT = "PRT",
  PRI = "PRI",
  QAT = "QAT",
  KOR = "KOR",
  ROU = "ROU",
  RUS = "RUS",
  RWA = "RWA",
  BLM = "BLM",
  SHN = "SHN",
  KNA = "KNA",
  LCA = "LCA",
  MAF = "MAF",
  SPM = "SPM",
  VCT = "VCT",
  WSM = "WSM",
  SMR = "SMR",
  STP = "STP",
  SAU = "SAU",
  SEN = "SEN",
  SRB = "SRB",
  SYC = "SYC",
  SLE = "SLE",
  SGP = "SGP",
  SXM = "SXM",
  SVK = "SVK",
  SVN = "SVN",
  SLB = "SLB",
  SOM = "SOM",
  ZAF = "ZAF",
  SGS = "SGS",
  SSD = "SSD",
  ESP = "ESP",
  LKA = "LKA",
  SDN = "SDN",
  SUR = "SUR",
  SJM = "SJM",
  SWZ = "SWZ",
  SWE = "SWE",
  CHE = "CHE",
  SYR = "SYR",
  TWN = "TWN",
  TJK = "TJK",
  TZA = "TZA",
  THA = "THA",
  TLS = "TLS",
  TGO = "TGO",
  TKL = "TKL",
  TON = "TON",
  TTO = "TTO",
  TUN = "TUN",
  TUR = "TUR",
  TKM = "TKM",
  TCA = "TCA",
  TUV = "TUV",
  UGA = "UGA",
  UKR = "UKR",
  ARE = "ARE",
  GBR = "GBR",
  URY = "URY",
  UZB = "UZB",
  VUT = "VUT",
  VEN = "VEN",
  VNM = "VNM",
  WLF = "WLF",
  ESH = "ESH",
  YEM = "YEM",
  ZMB = "ZMB",
  ZWE = "ZWE",
}

/** CorrespondenceCommunicationStatus */
export enum CorrespondenceCommunicationStatus {
  Incompleted = "incompleted",
  Completed = "completed",
  Received = "received",
}

/** CommunicationType */
export enum CommunicationType {
  Communication = "communication",
  External = "external",
}

/** CommunicationStatus */
export enum CommunicationStatus {
  Incompleted = "incompleted",
  Completed = "completed",
}

/** CashMovementType */
export enum CashMovementType {
  FundToInvestor = "fund_to_investor",
  InvestorToFund = "investor_to_fund",
  BankToBank = "bank_to_bank",
  CashInToPortfolio = "cash_in_to_portfolio",
  CashOutOfPortfolio = "cash_out_of_portfolio",
}

/** BulkReportType */
export enum BulkReportType {
  Transaction = "transaction",
  HoldingStatement = "holding_statement",
  Valuation = "valuation",
  DividendStatement = "dividend_statement",
  InvestorDistribution = "investor_distribution",
  TaxReturn = "tax_return",
}

/** BankTypeEnum */
export enum BankTypeEnum {
  Redemption = "redemption",
  Dividend = "dividend",
  Subscription = "subscription",
  Portfolio = "portfolio",
}

/** AssociatedPeopleRoleType */
export enum AssociatedPeopleRoleType {
  Trustee = "trustee",
  Shareholder = "shareholder",
  Director = "director",
  Settlor = "settlor",
  Beneficiary = "beneficiary",
  Stakeholder = "stakeholder",
  Officer = "officer",
  Adviser = "adviser",
}

/** AssetType */
export enum AssetType {
  ListedSharesAU = "Listed shares (AU)",
  ListedSharesOverseas = "Listed shares (Overseas)",
  ListedOptions = "Listed Options",
  ListedWarrants = "Listed Warrants",
  ListedFunds = "Listed Funds",
  UnlistedSharesAU = "Unlisted shares (AU)",
  UnlistedSharesOverseas = "Unlisted shares (Overseas)",
  UnlistedOptions = "Unlisted Options",
  UnlistedWarrants = "Unlisted Warrants",
  UnlistedFund = "Unlisted Fund",
  PartnershipInterest = "Partnership interest",
  CashCMT = "Cash / CMT",
  TermDepositsCD = "Term Deposits / CD",
  CryptoAsset = "Crypto asset",
  CollectibleAsset = "Collectible asset",
  BondsGovCorpMuni = "Bonds (gov., corp., muni)",
  ConvertibleNotes = "Convertible notes",
  VariableLoan = "Variable Loan",
  FixedLoan = "Fixed Loan",
  SettlementAC = "Settlement A/C",
  SuspenseAC = "Suspense A/C",
  ReceivableAC = "Receivable A/C",
  ETF = "ETF",
  ListedDerivatives = "Listed derivatives",
  PrivateDebt = "Private debt",
  PrivateEquity = "Private equity",
  VentureCapital = "Venture capital",
  RealProperty = "Real Property",
  OTCDerivativesSwapsFwd = "OTC derivatives (swaps, fwd)",
  StructuredProducts = "Structured products",
  InfrastructureAssets = "Infrastructure assets",
  NaturalResources = "Natural resources",
  HedgeFundInvestments = "Hedge fund investments",
  CollectiblesArtWineEtc = "Collectibles (art, wine, etc.)",
  ManagedFundUnitsUnitTrusts = "Managed fund units / unit trusts",
  LPInterestsInFunds = "LP interests in funds",
  ReceivablesAndAccruedIncome = "Receivables and accrued income",
  CollateralAssets = "Collateral assets",
}

/** ActivitiesType */
export enum ActivitiesType {
  Subscription = "subscription",
  Redemption = "redemption",
  Drp = "drp",
  FundToInvestor = "fund_to_investor",
  InvestorToFund = "investor_to_fund",
  Transfer = "transfer",
  OpeningBalance = "opening_balance",
}

/** ActivitiesStatus */
export enum ActivitiesStatus {
  Pending = "pending",
  AwaitingPayment = "awaiting_payment",
  Completed = "completed",
  Unsuccessfull = "unsuccessfull",
}

/** ActivitiesPaginateResponse */
export interface ActivitiesPaginateResponse {
  /** Id */
  id: number;
  /** From Entity Id */
  from_entity_id?: number;
  /** To Entity Id */
  to_entity_id?: number;
  /** From Entity Name */
  from_entity_name?: string;
  /** To Entity Name */
  to_entity_name?: string;
  /** Type */
  type?: string;
  /** Status */
  status?: string;
  /** Quantity */
  quantity: number;
  /** Amount */
  amount: number;
  /** Memo */
  memo?: string;
  /** Register Class Name */
  register_class_name?: string;
  /** Register Class Id */
  register_class_id?: number;
  /** Register Id */
  register_id?: number;
  /** From User Name */
  from_user_name: string;
  /** To User Name */
  to_user_name: string;
  /** Transaction Id */
  transaction_id?: number;
  /** Payment Id */
  payment_id?: number;
  /** Price Per Share */
  price_per_share?: number;
  /** Completion Date */
  completion_date?: string;
  /** Requested At Date */
  requested_at_date?: string;
  /** Payment Direction */
  payment_direction?: string;
  /** Payment Status */
  payment_status?: string;
  /** Payment Amount */
  payment_amount?: number;
  /** Payment Memo */
  payment_memo?: string;
  /** Payment Dividend Event Id */
  payment_dividend_event_id?: number;
  /** Source */
  source: string;
  /** Register Bank Account Bsb */
  register_bank_account_bsb?: string;
  /** Register Bank Account Name */
  register_bank_account_name?: string;
  /** Register Bank Account Number */
  register_bank_account_number?: string;
  /** Entity Bank Account Bsb */
  entity_bank_account_bsb?: string;
  /** Entity Bank Account Name */
  entity_bank_account_name?: string;
  /** Entity Bank Account Number */
  entity_bank_account_number?: string;
  /** Register Name */
  register_name: string;
  /** Buy Back Open Event Date */
  buy_back_open_event_date?: string;
  /** Buy Back Close Event Date */
  buy_back_close_event_date?: string;
  /** Reject Reason */
  reject_reason?: string;
  payment_info_status?: EntitiesPaymentInfoStatus;
  /**
   * Payment Info Updated At
   * @format date-time
   */
  payment_info_updated_at?: string;
  /**
   * Payment Info Requested At
   * @format date-time
   */
  payment_info_requested_at?: string;
  /** Total */
  total?: number;
  entity_status?: EntityStatus;
  /** Current Price Per Share */
  current_price_per_share?: number;
}

/** AddExistingInvestorToRegisterRequest */
export interface AddExistingInvestorToRegisterRequest {
  /**
   * Source Register Id
   * Source register ID
   * @exclusiveMin 0
   */
  source_register_id: number;
  /**
   * Target Register Id
   * Target register ID
   * @exclusiveMin 0
   */
  target_register_id: number;
  /**
   * Investor User Id
   * Investor user ID
   * @exclusiveMin 0
   */
  investor_user_id: number;
}

/** AddExistingInvestorToRegisterResponse */
export interface AddExistingInvestorToRegisterResponse {
  /** Shareholders */
  shareholders: ShareholderResponse[];
}

/** AddNewIssuerRequest */
export interface AddNewIssuerRequest {
  /**
   * The first name of the user
   * @minLength 3
   * @maxLength 255
   */
  first_name: string;
  /**
   * The last name of the user
   * @minLength 3
   * @maxLength 255
   */
  last_name: string;
  /**
   * The email of the user
   * @format email
   */
  email: string;
  /** The role of the user */
  role: KeycloakIssuerRole;
  /**
   * Register ID
   * @minItems 1
   */
  register_ids: number[];
  /** Redirect URL */
  redirect_url?: string;
  /**
   * Register Permission
   * @default false
   */
  register_permission?: boolean;
  /**
   * Communication Permission
   * @default true
   */
  communication_permission?: boolean;
  /**
   * Holder Details Permission
   * @default false
   */
  holder_details_permission?: boolean;
}

/** AddNewIssuerResponse */
export interface AddNewIssuerResponse {
  user: UserResponse;
}

/** AddOrganizationRoleRequest */
export interface AddOrganizationRoleRequest {
  /** Register Id */
  register_id: number;
  /**
   * Allow Missing User Register
   * @default false
   */
  allow_missing_user_register?: boolean;
}

/** AddOrganizationRoleResponse */
export interface AddOrganizationRoleResponse {
  /** Success */
  success: boolean;
}

/** AdminDeleteRegisterIssuerResponse */
export interface AdminDeleteRegisterIssuerResponse {
  /** Status */
  status: string;
}

/** AdviserDetails */
export interface AdviserDetails {
  /** Name Of Adviser */
  name_of_adviser?: string;
  /** Afsl Number */
  afsl_number?: string;
  /** Dealer Group */
  dealer_group?: string;
  /** Name Of Advisory Firm */
  name_of_advisory_firm?: string;
  /** Postal Address */
  postal_address?: string;
  /** Suburb */
  suburb?: string;
  /** Postcode */
  postcode?: string;
  /** Email Address */
  email_address?: string;
}

/** ApplicationOverTimeChart */
export interface ApplicationOverTimeChart {
  /** Count */
  count: number;
  /**
   * Date
   * @format date
   */
  date: string;
}

/** ApplicationSummary */
export interface ApplicationSummary {
  /** Paid Application */
  paid_application: number;
  /** Top Up Application */
  top_up_application: number;
  /** Initial Application */
  initial_application: number;
  /** Switch In Application */
  switch_in_application: number;
  /** Unpaid Application */
  unpaid_application: number;
}

/** ApplicationSummaryResponse */
export interface ApplicationSummaryResponse {
  /**
   * Date
   * @format date
   */
  date: string;
  /** Pending */
  pending: number;
  /** Awaiting Payment */
  awaiting_payment: number;
  /** Kyc Pending */
  kyc_pending: number;
  /** Incomplete */
  incomplete: number;
}

/** ArchiveBuyBackByIdResponse */
export interface ArchiveBuyBackByIdResponse {
  /** Success */
  success: boolean;
}

/** ArchiveDividendEventResponse */
export interface ArchiveDividendEventResponse {
  /** Success */
  success: boolean;
}

/** ArchivePaymentByIdResponse */
export interface ArchivePaymentByIdResponse {
  /** Success */
  success: boolean;
}

/** ArchiveTransactionByIdResponse */
export interface ArchiveTransactionByIdResponse {
  /** Success */
  success: boolean;
}

/** ArchiveTransferByIdResponse */
export interface ArchiveTransferByIdResponse {
  /** Success */
  success: boolean;
}

/** Asset */
export interface Asset {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Portfolio Id */
  portfolio_id: number;
  asset_type?: AssetType;
  /** Broker Id */
  broker_id?: number;
  /** Broker Inner Id */
  broker_inner_id?: string;
  /** Price Per Share */
  price_per_share: number;
  currency: CurrencyEnum;
  /**
   * Created With Ai
   * @default false
   */
  created_with_ai?: boolean;
  /**
   * Price Updated At
   * @format date-time
   */
  price_updated_at?: string;
  industry?: GicsIndustry;
}

/** AssetBreakdownChartData */
export interface AssetBreakdownChartData {
  /** Asset Id */
  asset_id?: number;
  /** Broker Id */
  broker_id?: number;
  currency: CurrencyEnum;
  /** Name */
  name: string;
  /** Data */
  data: OvertimeData[];
}

/** AssetExtended */
export interface AssetExtended {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Portfolio Id */
  portfolio_id: number;
  asset_type?: AssetType;
  /** Broker Id */
  broker_id?: number;
  /** Broker Inner Id */
  broker_inner_id?: string;
  /** Price Per Share */
  price_per_share?: number;
  currency: CurrencyEnum;
  /**
   * Created With Ai
   * @default false
   */
  created_with_ai?: boolean;
  /**
   * Price Updated At
   * @format date-time
   */
  price_updated_at?: string;
  industry?: GicsIndustry;
  broker?: Broker;
  portfolio: Portfolio;
  /**
   * Quantity
   * @default "0.00"
   */
  quantity?: number;
  /**
   * Total Asset Value
   * @default "0.00"
   */
  total_asset_value?: number;
  /**
   * Portfolio Value
   * @default "0.00"
   */
  portfolio_value?: number;
  /**
   * Percent Portfolio Value
   * @default "0.00"
   */
  percent_portfolio_value?: number;
  /**
   * Pnl
   * @default "0.00"
   */
  pnl?: number;
  /**
   * Pnl Ratio
   * @default "0.00"
   */
  pnl_ratio?: number;
  /**
   * Is Broker
   * @default false
   */
  is_broker?: boolean;
}

/** AssetWithQuantity */
export interface AssetWithQuantity {
  /** Id */
  id: number;
  /** Name */
  name: string;
  asset_type: AssetType;
  /** Price Per Share */
  price_per_share: number;
  currency: CurrencyEnum;
  /** Quantity */
  quantity: number;
  /**
   * Price Updated At
   * @format date-time
   */
  price_updated_at: string;
}

/** AssociatedPeople */
export interface AssociatedPeople {
  /**
   * Of
   * @default ""
   */
  of?: string;
  /**
   * Name
   * @default ""
   */
  name?: string;
  role: AssociatedPeopleRoleType;
}

/** AssociationEntityDetails */
export interface AssociationEntityDetails {
  /** Country */
  country: string;
  /** Abn */
  abn?: string;
  /** Registered Office */
  registered_office?: string;
  /** Shareholders */
  shareholders: IndividualEntityDetails[];
  /** Officers */
  officers: IndividualEntityDetails[];
  /** Association Number */
  association_number?: string;
  /** Website */
  website?: string;
  /** Company Name */
  company_name: string;
  /** Is Advisor */
  is_advisor?: boolean;
  /** Is Not Authorized Representative */
  is_not_authorized_representative?: boolean;
  /** Is Not Copies */
  is_not_copies?: boolean;
  /** Is Only Authorized Representative */
  is_only_authorized_representative?: boolean;
  /** Is Financial Adviser Operate */
  is_financial_adviser_operate?: boolean;
  /** Is Authorized Representative */
  is_authorized_representative?: boolean;
  /** Name Authorized Representative */
  name_authorized_representative?: string;
  /** Role Held With Investor */
  role_held_with_investor?: string;
  /** Is Financial Adviser Nominated By Investor */
  is_financial_adviser_nominated_by_investor?: boolean;
  /** Is Investor Received Advise */
  is_investor_received_advise?: boolean;
  adviser?: AdviserDetails;
  /** Documents */
  documents?: string[];
  /** Is Wholesale */
  is_wholesale?: boolean;
  /** Wholesale Type */
  wholesale_type?: string;
  /**
   * Type Literal
   * @default "association"
   */
  type_literal?: "association";
  /** Business Name Trustee */
  business_name_trustee?: string;
}

/** AuthDetailsModel */
export interface AuthDetailsModel {
  /** Realmid */
  realmId?: string;
  /** Clientid */
  clientId?: string;
  /** Userid */
  userId?: string;
  /** Ipaddress */
  ipAddress?: string;
  /** Username */
  username?: string;
  /** Sessionid */
  sessionId?: string;
}

/** BackChannelLogoutRequest */
export interface BackChannelLogoutRequest {
  /** Time */
  time?: number;
  /** Realmid */
  realmId?: string;
  /** Uid */
  uid?: string;
  authDetails?: AuthDetailsModel;
  /** Details */
  details?: object;
  /** Type */
  type?: string;
}

/** BackChannelLogoutResponse */
export interface BackChannelLogoutResponse {
  /** Success */
  success: boolean;
}

/** ClearNewHolderOnboardedNotificationResponse */
export interface ClearNewHolderOnboardedNotificationResponse {
  /** Success */
  success: boolean;
}

/** BankBalanceCash */
export interface BankBalanceCash {
  /** Id */
  id: number;
  /** Bank Name */
  bank_name: string;
  /** Bank Account Name */
  bank_account_name: string;
  currency: CurrencyEnum;
  /**
   * Total Available Cash
   * @default "0"
   */
  total_available_cash?: number;
  /**
   * Portion Of Portfolio Value
   * @default "0"
   */
  portion_of_portfolio_value?: number;
  /**
   * Percent Of Portfolio Value
   * @default "0"
   */
  percent_of_portfolio_value?: number;
}

/** BankModel */
export interface BankModel {
  /** Id */
  id?: number;
  /**
   * Bank Account Name
   * @minLength 1
   * @maxLength 50
   */
  bank_account_name: string;
  /**
   * Bank Account Bsb
   * @minLength 1
   * @maxLength 7
   */
  bank_account_bsb: string;
  /**
   * Bank Account Number
   * @minLength 1
   * @maxLength 9
   */
  bank_account_number: string;
  /**
   * Bank Name
   * @minLength 3
   * @maxLength 3
   */
  bank_name: string;
  /** Bank Types */
  bank_types: BankTypeEnum[];
  bank_currency: CurrencyEnum;
  /** Bank Classes */
  bank_classes?: number[];
  /** Portfolio Id */
  portfolio_id?: number;
}

/** BlockchainEvent */
export interface BlockchainEvent {
  /** Registerid */
  registerId: number;
  /** Idfromtable */
  idFromTable: number;
  /** Entityid */
  entityId: string;
  /** Entityidstr */
  entityIdStr: string;
  /** Tabletype */
  tableType: string;
  /** Encrypteddata */
  encryptedData: string;
  /** Decrypteddata */
  decryptedData: string;
  /** Encryptednotificationdata */
  encryptedNotificationData: string;
  /** Decryptednotificationdata */
  decryptedNotificationData: string;
  /** Transactiondate */
  transactionDate: number;
  /** Eventtype */
  eventType: string;
  /** Blockchaintransactionid */
  blockchainTransactionId: string;
  /** Rowstatus */
  rowStatus: number;
}

/** Broker */
export interface Broker {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Portfolio Id */
  portfolio_id: number;
}

/** BrokerBalances */
export interface BrokerBalances {
  currency: CurrencyEnum;
  /** Value */
  value: number;
}

/** BronIDFollowUpRequest */
export interface BronIDFollowUpRequest {
  /** Entity Id */
  entity_id: number;
  /**
   * Requested Actions
   * @minItems 1
   */
  requested_actions: (
    | BronIDRequestedActionsDocument
    | BronIDRequestedActionsIndividual
  )[];
}

/** BronIDFollowUpResponse */
export interface BronIDFollowUpResponse {
  entity: EntityResponse;
}

/** BronIDGetVerificationStatusResponse */
export interface BronIDGetVerificationStatusResponse {
  data: BronIDVerificationStatusResponse;
}

/** BronIDIndividual */
export interface BronIDIndividual {
  /** Country */
  country: string;
  /** Firstname */
  firstName: string;
  /** Lastname */
  lastName: string;
  /** Middlename */
  middleName: string;
  /** Gender */
  gender: string;
  /**
   * Dateofbirth
   * @format date
   */
  dateOfBirth: string;
  /** Unitnumber */
  unitNumber: string;
  /** Streetnumber */
  streetNumber: string;
  /** Streetname */
  streetName: string;
  /** Streettype */
  streetType: string;
  /** Suburb */
  suburb: string;
  /** Postcode */
  postcode: string;
  /** State */
  state: string;
  /** Driverslicenceimagefront */
  driversLicenceImageFront?: string;
  /** Driverslicenceimageback */
  driversLicenceImageBack?: string;
  /** Driverslicencenumber */
  driversLicenceNumber?: string;
  /** Driverslicencecardnumber */
  driversLicenceCardNumber?: string;
  /** Driverslicencestate */
  driversLicenceState?: string;
  /** Passportimage */
  passportImage?: string;
  /** Passportnumber */
  passportNumber?: string;
  /** Passportcountryofissue */
  passportCountryOfIssue?: string;
  /** Documenttype */
  documentType?: string;
}

/** BronIDLookupResponse */
export interface BronIDLookupResponse {
  data: BronIdLookUpResponse;
}

/** BronIDRequestedActionsDocument */
export interface BronIDRequestedActionsDocument {
  /** Type */
  type: string;
  /** Id */
  id: string;
  /** Extracttype */
  extractType: string;
  /** Documentbase64 */
  documentBase64: string;
}

/** BronIDRequestedActionsIndividual */
export interface BronIDRequestedActionsIndividual {
  /** Type */
  type: string;
  /** Role */
  role: string;
  /** Id */
  id: string;
  fields: BronIDIndividual;
}

/** BronIDVerificationStatusResponse */
export interface BronIDVerificationStatusResponse {
  /** Entity Type */
  entity_type?: string;
  idvRiskScore?: IDVRiskScore;
  /** Name */
  name?: string;
  /**
   * Out Of Watch List
   * @default []
   */
  out_of_watch_list?: OutWatch[];
  signature?: BronIdSignature;
  /**
   * Stakeholders
   * @default []
   */
  stakeholders?: BronIdStakeholder[];
  /** Submission Id */
  submission_id?: string;
  /** Submission Status */
  submission_status?: string;
  /** Timestamp */
  timestamp?: string;
  /** Trace */
  trace?: string;
  /** User Id */
  user_id?: string;
  /** Verification Status */
  verification_status?: string;
  /** Verification Uuid */
  verification_uuid?: string;
  /**
   * Webhook Response
   * @default []
   */
  webhook_response?: BronIDWebhookResponse[];
  /**
   * Requested Actions
   * @default []
   */
  requested_actions?: RequestedAction[];
}

/** BronIDWebhookResponse */
export interface BronIDWebhookResponse {
  /** Status */
  status?: string;
  /** Status Code */
  status_code?: string;
  /** Url */
  url?: string;
}

/** BronIdLookUpResponse */
export interface BronIdLookUpResponse {
  /** Name */
  name?: string;
  /** Business Names */
  business_names?: string[];
  /** Trading Names */
  trading_names?: string[];
  /** Entitynumber */
  entityNumber?: string;
  /** Abn */
  abn?: string;
  /** Acn */
  acn?: string;
  /** Entity Status */
  entity_status?: string;
  /** Entity Type Abn */
  entity_type_abn?: string;
  /** Entity Type Bron Id */
  entity_type_bron_id?: string;
  /** Entity Type Vestra */
  entity_type_vestra?: string;
  /** Address Text */
  address_text?: string;
  /** Address State */
  address_state?: string;
  /** Address Postcode */
  address_postcode?: string;
}

/** BronIdSignature */
export interface BronIdSignature {
  /** Keccak256 */
  keccak256?: string;
  /** Sha256 */
  sha256?: string;
  /** Version */
  version?: string;
}

/** BronIdStakeholder */
export interface BronIdStakeholder {
  /** Id */
  id?: string;
  idv_risk_scope?: IDVRiskScore;
  /** Name */
  name?: string;
  /** Role */
  role?: string;
  /** Submission Status */
  submission_status?: string;
  /** Verification Status */
  verification_status?: string;
}

/** BulkCommunicationCertificateConfig */
export interface BulkCommunicationCertificateConfig {
  /** Register Class Ids */
  register_class_ids: number[];
  /** @default "pdf" */
  file_type?: ReportFormat;
}

/** BulkCommunicationReportConfig */
export interface BulkCommunicationReportConfig {
  report_type: BulkReportType;
  /** Register Class Ids */
  register_class_ids?: number[];
  /**
   * Start Date
   * @format date
   */
  start_date?: string;
  /**
   * End Date
   * @format date
   */
  end_date?: string;
  /** Financial Year */
  financial_year?: number;
  /** Dividend Event Id */
  dividend_event_id?: number;
  file_type: ReportFormat;
}

/** BulkCompleteDrpRequest */
export interface BulkCompleteDrpRequest {
  /** Transactions */
  transactions: TransactionSetAwaitPaymentStatusRequest[];
}

/** BulkCompleteDrpResponse */
export interface BulkCompleteDrpResponse {
  /** Success */
  success: boolean;
}

/** BulkGenerateReportRequest */
export interface BulkGenerateReportRequest {
  type: BulkReportType;
  /**
   * Register Id
   * @exclusiveMin 0
   */
  register_id: number;
  /**
   * Register Class Ids
   * @minItems 1
   */
  register_class_ids?: number[];
  format: ReportFormat;
  /** File name */
  filename: string;
  /**
   * Starting from this date
   * @format date
   */
  start_date?: string;
  /**
   * Ending at this date
   * @format date
   */
  end_date?: string;
  /**
   * Dividend Event Id
   * @exclusiveMin 0
   */
  dividend_event_id?: number;
  /**
   * Financial Year
   * @min 0
   * @max 9999
   */
  financial_year?: number;
  holder_selection_mode: HolderSelectionMode;
  /**
   * Entity Ids
   * @minItems 1
   */
  entity_ids?: number[];
}

/** BulkPaymentFileGeneratorResponse */
export interface BulkPaymentFileGeneratorResponse {
  /** Payment File */
  payment_file?: string;
}

/** BulkPaymentSetCompletedStatusRequest */
export interface BulkPaymentSetCompletedStatusRequest {
  /** Payments */
  payments: PaymentSetCompletedStatusRequest[];
  /** Dividend Event Id */
  dividend_event_id?: number;
}

/** BulkPaymentSetCompletedStatusResponse */
export interface BulkPaymentSetCompletedStatusResponse {
  /** Success */
  success: boolean;
}

/** BuyBackEvent */
export interface BuyBackEvent {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** Register Id */
  register_id: number;
  /** Register Class Id */
  register_class_id: number;
  /** Price Per Share */
  price_per_share: number;
  /** Total Buy Back Offer */
  total_buy_back_offer: number;
  /**
   * Open Event Date
   * @format date-time
   */
  open_event_date: string;
  /**
   * Close Event Date
   * @format date-time
   */
  close_event_date: string;
  /** Memo */
  memo?: string;
  /** Bank Id */
  bank_id?: number;
}

/** BuyBackEventCalculateResponse */
export interface BuyBackEventCalculateResponse {
  /** Id */
  id: number;
  /** Register Id */
  register_id: number;
  /** Register Class Id */
  register_class_id: number;
  /** Price Per Share */
  price_per_share: number;
  /** Total Buy Back Offer */
  total_buy_back_offer: number;
  /** Current Buy Back Offer */
  current_buy_back_offer?: number;
  /** Current Shareholder Quantity */
  current_shareholder_quantity?: number;
  /** Total Holder Quantity */
  total_holder_quantity?: number;
  /** Current Holder Quantity */
  current_holder_quantity?: number;
  /**
   * Open Event Date
   * @format date-time
   */
  open_event_date?: string;
  /**
   * Close Event Date
   * @format date-time
   */
  close_event_date?: string;
  /** Memo */
  memo?: string;
  register_class?: RegisterClass;
}

/** BuyBackEventResponse */
export interface BuyBackEventResponse {
  /** Id */
  id: number;
  /** Register Id */
  register_id: number;
  /** Register Class Id */
  register_class_id: number;
  /** Price Per Share */
  price_per_share: number;
  /** Total Buy Back Offer */
  total_buy_back_offer: number;
  /**
   * Open Event Date
   * @format date-time
   */
  open_event_date: string;
  /**
   * Close Event Date
   * @format date-time
   */
  close_event_date: string;
  /** Memo */
  memo?: string;
}

/** CapitalGainsSchema */
export interface CapitalGainsSchema {
  /** Capital */
  capital: string;
  /** Discounted */
  discounted: string;
  /** Other */
  other: string;
  /** Gross */
  gross: string;
  /** Losses Applied */
  losses_applied: string;
  /** Discounts Applied */
  discounts_applied: string;
  /** Small Business Concessions */
  small_business_concessions: string;
  /** Ncmi Capital Gains */
  ncmi_capital_gains: string;
  /** Excluded Ncmi Capital Gains */
  excluded_ncmi_capital_gains: string;
  /** Capital Allocation Method */
  capital_allocation_method: "manual" | "auto";
  /** Capital Total Fund */
  capital_total_fund: string;
  /** Capital Total Value */
  capital_total_value: string;
  /** Discounted Allocation Method */
  discounted_allocation_method: "manual" | "auto";
  /** Discounted Total Fund */
  discounted_total_fund: string;
  /** Discounted Total Value */
  discounted_total_value: string;
  /** Other Allocation Method */
  other_allocation_method: "manual" | "auto";
  /** Other Total Fund */
  other_total_fund: string;
  /** Other Total Value */
  other_total_value: string;
  /** Gross Allocation Method */
  gross_allocation_method: "manual" | "auto";
  /** Gross Total Fund */
  gross_total_fund: string;
  /** Gross Total Value */
  gross_total_value: string;
  /** Losses Applied Allocation Method */
  losses_applied_allocation_method: "manual" | "auto";
  /** Losses Applied Total Fund */
  losses_applied_total_fund: string;
  /** Losses Applied Total Value */
  losses_applied_total_value: string;
  /** Discounts Applied Allocation Method */
  discounts_applied_allocation_method: "manual" | "auto";
  /** Discounts Applied Total Fund */
  discounts_applied_total_fund: string;
  /** Discounts Applied Total Value */
  discounts_applied_total_value: string;
  /** Small Business Concessions Allocation Method */
  small_business_concessions_allocation_method: "manual" | "auto";
  /** Small Business Concessions Total Fund */
  small_business_concessions_total_fund: string;
  /** Small Business Concessions Total Value */
  small_business_concessions_total_value: string;
  /** Ncmi Capital Gains Allocation Method */
  ncmi_capital_gains_allocation_method: "manual" | "auto";
  /** Ncmi Capital Gains Total Fund */
  ncmi_capital_gains_total_fund: string;
  /** Ncmi Capital Gains Total Value */
  ncmi_capital_gains_total_value: string;
  /** Excluded Ncmi Capital Gains Allocation Method */
  excluded_ncmi_capital_gains_allocation_method: "manual" | "auto";
  /** Excluded Ncmi Capital Gains Total Fund */
  excluded_ncmi_capital_gains_total_fund: string;
  /** Excluded Ncmi Capital Gains Total Value */
  excluded_ncmi_capital_gains_total_value: string;
  [key: string]: any;
}

/** CapitalSummarySection */
export interface CapitalSummarySection {
  /** Type */
  type: string;
  /** Value */
  value?: number;
}

/** CashInOutChartData */
export interface CashInOutChartData {
  /** Cash In */
  cash_in: number;
  /** Cash Out */
  cash_out: number;
  /**
   * Date
   * @format date
   */
  date: string;
}

/** CommunicationAttachmentPreviewClassRow */
export interface CommunicationAttachmentPreviewClassRow {
  /** Class Id */
  class_id?: number;
  /** Class Name */
  class_name: string;
  /** Holder Has Units */
  holder_has_units?: boolean;
  /** Reports */
  reports?: CommunicationAttachmentPreviewItem[];
  /** Certificates */
  certificates?: CommunicationAttachmentPreviewItem[];
}

/** CommunicationAttachmentPreviewItem */
export interface CommunicationAttachmentPreviewItem {
  /** Type */
  type: "report" | "certificate";
  /** Label */
  label: string;
  file_type?: ReportFormat;
  report_type?: BulkReportType;
  /** Class Id */
  class_id?: number;
  /** Class Name */
  class_name?: string;
  /**
   * Applicable
   * @default true
   */
  applicable?: boolean;
  /** Unavailable Reason */
  unavailable_reason?: string;
}

/** CommunicationAttachmentPreviewRecipient */
export interface CommunicationAttachmentPreviewRecipient {
  /** Shareholder Id */
  shareholder_id: number;
  /** Entity Id */
  entity_id?: number;
  /** Holder Name */
  holder_name: string;
  /** Holder External Id */
  holder_external_id?: string;
  /** Email */
  email?: string;
  /** Additional Emails */
  additional_emails?: string[];
  /**
   * Outgoing Email Count
   * @default 0
   */
  outgoing_email_count?: number;
  /** Classes */
  classes?: CommunicationAttachmentPreviewClassRow[];
  /**
   * Skipped
   * @default false
   */
  skipped?: boolean;
  /** Skipped Reasons */
  skipped_reasons?: string[];
}

/** CommunicationAttachmentPreviewResponse */
export interface CommunicationAttachmentPreviewResponse {
  /** Recipients */
  recipients: CommunicationAttachmentPreviewRecipient[];
}

/** CommunicationPreferenceChart */
export interface CommunicationPreferenceChart {
  email?: TotalPercentageData;
  physical?: TotalPercentageData;
}

/** CommunicationResponse */
export interface CommunicationResponse {
  /** Id */
  id: number;
  /** Register Id */
  register_id: number;
  /** Subject */
  subject: string;
  /** Text */
  text: string;
  /** Recipients Number */
  recipients_number: number;
  status: CommunicationStatus;
  /** Bounces */
  bounces?: number;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Reports */
  reports?: ReportWithUrlResponse[];
  /** Shareholders */
  shareholders?: CommunicationShareholderExtend[];
}

/** CommunicationShareholderExtend */
export interface CommunicationShareholderExtend {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** Register Id */
  register_id: number;
  /** Entity Id */
  entity_id: number;
  /** Email */
  email?: string;
  /** Phone Number */
  phone_number?: string;
  /** Additional Emails */
  additional_emails?: string[];
  entity: ShareholderEntity;
}

/** CompanyEntityDetails */
export interface CompanyEntityDetails {
  /** Company Name */
  company_name?: string;
  /** Type */
  type?: string;
  /**
   * Type Literal
   * @default "company"
   */
  type_literal?: "company";
  /** Acn */
  acn?: string;
  /** Abn */
  abn?: string;
  /** Nzbn */
  nzbn?: string;
  /** Country */
  country?: string;
  /** Registered Office */
  registered_office?: string;
  /** Principal Place Of Business */
  principal_place_of_business?: string;
  /** Shareholders */
  shareholders: (
    | ({
        type_literal: "company";
      } & CompanyEntityDetails)
    | ({
        type_literal: "individual";
      } & IndividualEntityDetails)
  )[];
  /** Directors */
  directors: IndividualEntityDetails[];
  adviser?: AdviserDetails;
  /** Business Name Trustee */
  business_name_trustee?: string;
}

/** CorrespondenceCommunicationActivityItem */
export interface CorrespondenceCommunicationActivityItem {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  type: CommunicationType;
  /** Subject */
  subject?: string;
  /** Text */
  text?: string;
  /** Recipients Number */
  recipients_number?: number;
  status?: CorrespondenceCommunicationStatus;
  /** Bounces */
  bounces?: number;
  /** Reports */
  reports?: ReportList[];
  /** Ai Extracted */
  ai_extracted?: string;
  /** Sender Name */
  sender_name?: string;
  /** Sender Email */
  sender_email?: string;
  sender_shareholder?: CorrespondenceHolder;
  /** Thread Root Id */
  thread_root_id?: number;
  /** Thread Root */
  thread_root?: string;
  /** Has More */
  has_more?: boolean;
  /** Recipients */
  recipients?: CorrespondenceHolder[];
}

/** CorrespondenceCommunicationMessages */
export interface CorrespondenceCommunicationMessages {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** Sender Name */
  sender_name?: string;
  /** Sender Email */
  sender_email?: string;
  sender_shareholder?: CorrespondenceHolder;
  /** Subject */
  subject?: string;
  /** Ai Extracted */
  ai_extracted?: string;
  /** Content */
  content?: string;
  /**
   * Date
   * @format date-time
   */
  date?: string;
  /** Message Id */
  message_id?: string;
  /** To Holders */
  to_holders?: CorrespondenceHolder[];
  /** Cc Holders */
  cc_holders?: CorrespondenceHolder[];
  /** Documents */
  documents?: CorrespondenceDocuments[];
}

/** CorrespondenceDocumentResponse */
export interface CorrespondenceDocumentResponse {
  /** Document Storage Item Url */
  document_storage_item_url?: string;
  /** Object Key */
  object_key?: string;
  /** File Name */
  file_name?: string;
  /** Original File Name */
  original_file_name?: string;
}

/** CorrespondenceDocuments */
export interface CorrespondenceDocuments {
  /** Is Report */
  is_report: boolean;
  report?: ReportList;
  document?: CorrespondenceDocumentResponse;
}

/** CorrespondenceHolder */
export interface CorrespondenceHolder {
  shareholder?: CommunicationShareholderExtend;
  /** Recipient Email */
  recipient_email: string;
}

/** CorrespondenceSummary */
export interface CorrespondenceSummary {
  /** Id */
  id: number;
  /** Subject */
  subject?: string;
  /** Sender Email */
  sender_email?: string;
  /**
   * Date
   * @format date-time
   */
  date?: string;
}

/** CreateAssetRequest */
export interface CreateAssetRequest {
  /** Name */
  name: string;
  /** Portfolio Id */
  portfolio_id: number;
  asset_type?: AssetType;
  /** Broker Id */
  broker_id?: number;
  /** Broker Inner Id */
  broker_inner_id?: string;
  /** Price Per Share */
  price_per_share: number;
  /** @default "aud" */
  currency?: CurrencyEnum;
  /**
   * Confirmation Date
   * @format date-time
   */
  confirmation_date?: string;
  /**
   * Created With Ai
   * @default false
   */
  created_with_ai?: boolean;
  industry?: GicsIndustry;
}

/** CreateBrokerRequest */
export interface CreateBrokerRequest {
  /** Name */
  name: string;
  /**
   * Portfolio ID
   * @exclusiveMin 0
   */
  portfolio_id: number;
}

/** CreateBrokerResponse */
export interface CreateBrokerResponse {
  data: Broker;
}

/** CreateBuyBackEventRequest */
export interface CreateBuyBackEventRequest {
  /** Register Class Id */
  register_class_id: number;
  /** Price Per Share */
  price_per_share: number;
  /** Total Buy Back Offer */
  total_buy_back_offer: number;
  /**
   * Open Event Date
   * @format date-time
   */
  open_event_date: string;
  /**
   * Close Event Date
   * @format date-time
   */
  close_event_date: string;
  /** Memo */
  memo?: string;
  /** Shareholder Ids */
  shareholder_ids?: number[];
  /** Bank Id */
  bank_id: number;
}

/** CreateBuyBackEventResponse */
export interface CreateBuyBackEventResponse {
  buy_back_event: BuyBackEventResponse;
}

/** CreateCommunicationRequest */
export interface CreateCommunicationRequest {
  /** Subject */
  subject: string;
  /** Text */
  text: string;
  /** Shareholder Ids */
  shareholder_ids: number[];
  /** Report Ids */
  report_ids?: number[];
  /** Certificate Ids */
  certificate_ids?: number[];
  /**
   * Bulk Generate Attachments
   * @default false
   */
  bulk_generate_attachments?: boolean;
  bulk_report_config?: BulkCommunicationReportConfig;
  bulk_certificate_config?: BulkCommunicationCertificateConfig;
}

/** CreateCommunicationResponse */
export interface CreateCommunicationResponse {
  communication: CommunicationResponse;
}

/** CreateDividendEventRequest */
export interface CreateDividendEventRequest {
  /**
   * Register Class Id
   * @exclusiveMin 0
   */
  register_class_id: number;
  /**
   * Date
   * @format date-time
   */
  date: string;
  /** Amount Per Share */
  amount_per_share: number;
  type: DividendType;
  /** Memo */
  memo: string;
  /**
   * Is Preview Distribution
   * @default false
   */
  is_preview_distribution?: boolean;
  /**
   * Is Create Report
   * @default true
   */
  is_create_report?: boolean;
  /** Name */
  name: string;
  /** Bank Id */
  bank_id: number;
}

/** CreateDividendEventResponse */
export interface CreateDividendEventResponse {
  divided_event: DividendEventResponse;
}

/** CreateEntityRequest */
export interface CreateEntityRequest {
  /** The entity type */
  type?: EntityType;
  /** The entity bank account name */
  bank_account_name?: string;
  /** The entity bank account bsb */
  bank_account_bsb?: string;
  /** The entity bank account number */
  bank_account_number?: string;
  /** The entity bank name */
  bank_name?: string;
  /**
   * The entity email
   * @format email
   */
  email?: string;
  /** The entity phone number */
  phone_number?: string;
  /** The entity address */
  address?: string;
  /** Entity additional emails */
  additional_emails?: string[];
  /** Entity name */
  entity_name?: string;
  /** Apply Register Id */
  apply_register_id?: number;
  /** The entity preferred contact way */
  preferred_contact_way?: EntityPreferredContactWay;
  /** Document data in base64 string */
  documents?: EntityDocumentItem[];
  /** The Individual entity details */
  individual_entity_details: object;
  /** The Company entity details */
  company_entity_details?: object;
  /** The Trust entity details */
  trust_entity_details?: object;
  /** The Partnership entity details */
  partnership_entity_details?: object;
  /** The Association entity details */
  association_entity_details_id?: object;
  /** The SMSF entity details */
  smsf_entity_details?: object;
  /**
   * Send investment information about other investments
   * @default true
   */
  send_information_about_other_investments?: boolean;
  /**
   * Entity additional address
   * @maxLength 255
   */
  additional_address?: string;
  /**
   * Entity suburb
   * @maxLength 50
   */
  suburb?: string;
  /**
   * Entity state
   * @maxLength 20
   */
  state?: string;
  /**
   * Entity postcode
   * @maxLength 20
   */
  postcode?: string;
  /** Entity country */
  country?: CountryCodeEnum;
  /**
   * Notifications Enabled
   * @default false
   */
  notifications_enabled?: boolean;
  /**
   * Is Issuer Creator
   * @default false
   */
  is_issuer_creator?: boolean;
  /**
   * Registration type
   * @default "self_registered"
   */
  registration_type?: EntitiesRegistrationType;
  /**
   * Is Create Documents
   * @default true
   */
  is_create_documents?: boolean;
}

/** CreateEntityResponse */
export interface CreateEntityResponse {
  entity: EntityResponse;
}

/** CreateHolderDetailsRequest */
export interface CreateHolderDetailsRequest {
  user_data?: UserDetailsData;
  /** If provided, we’ll do an update; if omitted, we’ll create a new investor. */
  shareholder_id?: number | null;
  entity_data: CreateEntityRequest | UpdateEntityRequest;
}

/** CreateHolderDetailsResponse */
export interface CreateHolderDetailsResponse {
  data: InvestorEditsExtend;
}

/** CreateNavRequest */
export interface CreateNavRequest {
  /** Register Class Id */
  register_class_id: number;
  /**
   * The price per share
   * @min 0
   */
  price_per_share: number;
  /**
   * Changes Date
   * @format date-time
   */
  changes_date: string;
  /** Justification */
  justification?: string;
  /**
   * Is From Portfolio
   * @default false
   */
  is_from_portfolio?: boolean;
  /**
   * Is From Portfolio Edited
   * @default false
   */
  is_from_portfolio_edited?: boolean;
}

/** CreateNavResponse */
export interface CreateNavResponse {
  data: NAVHistoryItem;
}

/** CreatePaymentRequest */
export interface CreatePaymentRequest {
  /**
   * Shareholder Id
   * @exclusiveMin 0
   */
  shareholder_id?: number;
  /** Transaction Id */
  transaction_id?: number;
  /**
   * Payment amount
   * @min 0
   */
  amount: number;
  /** Payment memo */
  memo?: string;
  /**
   * Dividend event id
   * @exclusiveMin 0
   */
  dividend_event_id?: number;
  /**
   * Is Preview Distribution
   * @default false
   */
  is_preview_distribution?: boolean;
  /** @default "pending" */
  status?: PaymentStatus;
  /** @default "investor_to_fund" */
  direction?: PaymentDirection;
  /**
   * Confirmation Date
   * @format date-time
   */
  confirmation_date?: string;
  /**
   * Requested At Date
   * @format date-time
   */
  requested_at_date?: string;
  /** From Bank Id */
  from_bank_id?: number;
  /** To Bank Id */
  to_bank_id?: number;
  /** Fx Rate */
  fx_rate?: number;
  /**
   * Do Not Notify Investor
   * @default false
   */
  do_not_notify_investor?: boolean;
  /**
   * Sync Transaction Status
   * @default true
   */
  sync_transaction_status?: boolean;
}

/** CreatePaymentResponse */
export interface CreatePaymentResponse {
  payment: PaymentResponse;
}

/** CreatePortfolioCashMovementRequest */
export interface CreatePortfolioCashMovementRequest {
  /**
   * Shareholder Id
   * @exclusiveMin 0
   */
  shareholder_id?: number;
  /** Transaction Id */
  transaction_id?: number;
  /**
   * Payment amount
   * @exclusiveMin 0
   */
  amount: number;
  /** Payment memo */
  memo?: string;
  /**
   * Dividend event id
   * @exclusiveMin 0
   */
  dividend_event_id?: number;
  /** Correspondence Id */
  correspondence_id?: number;
  /**
   * Is Preview Distribution
   * @default false
   */
  is_preview_distribution?: boolean;
  /** @default "pending" */
  status?: PaymentStatus;
  /** @default "bank_to_bank" */
  direction?: CashMovementType;
  /**
   * Confirmation Date
   * @format date-time
   */
  confirmation_date?: string;
  /**
   * Requested At Date
   * @format date-time
   */
  requested_at_date?: string;
  /** From Bank Id */
  from_bank_id?: number;
  /** To Bank Id */
  to_bank_id?: number;
  /** Fx Rate */
  fx_rate?: number;
  /** Payment Id */
  payment_id?: number;
  /** Portfolio Id */
  portfolio_id?: number;
  /** Portfolio Transaction Id */
  portfolio_transaction_id?: number;
}

/** CreatePortfolioCashMovementResponse */
export interface CreatePortfolioCashMovementResponse {
  payment: PortfolioCashMovementResponse;
}

/** CreatePortfolioNavsRequest */
export interface CreatePortfolioNavsRequest {
  /** Classes */
  classes: number[];
  /**
   * Nav
   * @exclusiveMin 0
   */
  nav: number;
  /**
   * Date
   * @format date-time
   */
  date: string;
  /**
   * Is From Portfolio Edited
   * @default false
   */
  is_from_portfolio_edited?: boolean;
}

/** CreatePortfolioNavsResponse */
export interface CreatePortfolioNavsResponse {
  /** Success */
  success: boolean;
}

/** CreatePortfolioRequest */
export interface CreatePortfolioRequest {
  /**
   * Name
   * @minLength 1
   * @maxLength 100
   */
  name: string;
}

/** CreatePortfolioResponse */
export interface CreatePortfolioResponse {
  portfolio: Portfolio;
}

/** CreatePortfolioTransactionRequest */
export interface CreatePortfolioTransactionRequest {
  /** Asset Id */
  asset_id?: number;
  transaction_type: PortfolioTransactionType;
  status: PortfolioTransactionStatus;
  /**
   * Confirmation Date
   * @format date-time
   */
  confirmation_date?: string;
  /**
   * Price Per Share
   * @default "0.00"
   */
  price_per_share?: number;
  /**
   * Quantity
   * @default "0.00"
   */
  quantity?: number;
  /** Correspondence Id */
  correspondence_id?: number;
  /** To Portfolio Bank Id */
  to_portfolio_bank_id?: number;
  /** From Portfolio Bank Id */
  from_portfolio_bank_id?: number;
  /** Ref Portfolio Transaction Id */
  ref_portfolio_transaction_id?: number;
  /** Memo */
  memo?: string;
  /** Is Complete Book */
  is_complete_book?: boolean;
  /**
   * Fee
   * @default "0.00"
   */
  fee?: number;
  /**
   * Amount
   * @default "0.00"
   */
  amount?: number;
  /** Portfolio Id */
  portfolio_id: number;
  /**
   * Fx Rate
   * @default "1.00"
   */
  fx_rate?: number;
  /**
   * Split Post Quantity
   * @default "0.00"
   */
  split_post_quantity?: number;
  /** Broker Id */
  broker_id?: number;
  from_currency?: CurrencyEnum;
  to_currency?: CurrencyEnum;
}

/** CreateRegisterBankRequest */
export interface CreateRegisterBankRequest {
  /** Bank Name */
  bank_name: string;
  /** Bank Account Name */
  bank_account_name: string;
  /** Bank Account Bsb */
  bank_account_bsb: string;
  /** Bank Account Number */
  bank_account_number: string;
  /** Bank Types */
  bank_types: BankTypeEnum[];
  bank_currency: CurrencyEnum;
  /** Bank Classes */
  bank_classes?: number[];
  /** Portfolio Id */
  portfolio_id?: number;
}

/** CreateRegisterBankResponse */
export interface CreateRegisterBankResponse {
  /** Success */
  success: boolean;
}

/** CreateRegisterClassRequest */
export interface CreateRegisterClassRequest {
  /**
   * The register class's name
   * @minLength 1
   * @maxLength 100
   */
  class_name: string;
  /**
   * The current price per share
   * @min 0
   */
  current_price_per_share: number;
  /**
   * The minimal value for investment
   * @min 0
   */
  min_investment: number;
  /** The transfer lock period */
  transfer_lock_period?: number;
  /**
   * The date of register class
   * @format date-time
   * @default "2026-06-30T15:24:00.002840"
   */
  date?: string;
}

/** CreateRegisterClassResponse */
export interface CreateRegisterClassResponse {
  register_class: RegisterClassResponse;
}

/** CreateRegisterRequest */
export interface CreateRegisterRequest {
  /** Country Code */
  country_code?: string;
  /** Registered Office */
  registered_office?: string;
  /** Acn */
  ACN: string;
  /** Email */
  email?: string;
  /** Phone */
  phone?: string;
  /** Website */
  website?: string;
  /** Abn */
  abn: string;
  /** Trustee */
  trustee?: string;
  /**
   * Allows Fractional Shares
   * @default false
   */
  allows_fractional_shares?: boolean;
  type: RegisterType;
  /**
   * Name
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  /**
   * Code
   * @minLength 1
   * @maxLength 100
   */
  code: string;
  /**
   * User Identification Number
   * @max 999999
   */
  user_identification_number?: number;
  /** Register Legal Name */
  register_legal_name?: string;
  /**
   * Hold Carried Forward
   * @default false
   */
  hold_carried_forward?: boolean;
  rounding_type?: RoundingType;
  /** Banks */
  banks: BankModel[];
  /** @default "aud" */
  currency?: CurrencyEnum;
}

/** CreateRegisterResponse */
export interface CreateRegisterResponse {
  register_obj: RegisterResponse;
  rounding_type?: RegisterSettingsResponse;
}

/** CreateShareholderRequest */
export interface CreateShareholderRequest {
  /**
   * Register Id
   * @exclusiveMin 0
   */
  register_id: number;
  /**
   * Entity Id
   * @exclusiveMin 0
   */
  entity_id: number;
  /**
   * Is Issuer Creator
   * @default false
   */
  is_issuer_creator?: boolean;
}

/** CreateShareholderResponse */
export interface CreateShareholderResponse {
  shareholder: ShareholderResponse;
}

/** CreateTransactionRequest */
export interface CreateTransactionRequest {
  /**
   * Register Class Id
   * @exclusiveMin 0
   */
  register_class_id: number;
  /**
   * Shareholder Id
   * @exclusiveMin 0
   */
  shareholder_id: number;
  type: TransactionType;
  /**
   * Quantity
   * @min 0
   */
  quantity: number;
  /**
   * Price Per Share
   * @min 0
   */
  price_per_share: number;
  /** Memo */
  memo: string;
  /** Dividend Reinvestment */
  dividend_reinvestment: boolean;
  /** Dividend Event Id */
  dividend_event_id?: number;
  /** Buy Back Event Id */
  buy_back_event_id?: number;
  /**
   * Issue Date
   * @format date-time
   */
  issue_date?: string;
  /**
   * Total
   * @min 0
   */
  total?: number;
  /**
   * Is Preview Distribution
   * @default false
   */
  is_preview_distribution?: boolean;
  /** Document Data */
  document_data?: string[];
  /** To Bank Id */
  to_bank_id?: number;
  status?: TransactionStatus;
  /**
   * Payment Issue Date
   * @format date-time
   */
  payment_issue_date?: string;
  /**
   * Do Not Notify Investor
   * @default false
   */
  do_not_notify_investor?: boolean;
  round_to?: RoundTo;
}

/** CreateTransactionResponse */
export interface CreateTransactionResponse {
  transaction: TransactionResponse;
}

/** CreateTransferRequest */
export interface CreateTransferRequest {
  /**
   * From Shareholder Id
   * @exclusiveMin 0
   */
  from_shareholder_id: number;
  /**
   * To Shareholder Id
   * @exclusiveMin 0
   */
  to_shareholder_id?: number;
  /**
   * Register Class Id
   * @exclusiveMin 0
   */
  register_class_id: number;
  /**
   * Requested At Date
   * @format date-time
   */
  requested_at_date: string;
  /** Quantity */
  quantity: number;
  /** Price Per Share */
  price_per_share: number;
  /** Document Data */
  document_data: string[];
  /** Memo */
  memo: string;
  /**
   * The entity email
   * @default "exist"
   */
  recipient_shareholder_type?: TransferShareholderType;
  /**
   * The entity email
   * @format email
   */
  recipient_email?: string;
  /** Entity name */
  recipient_name?: string;
  /** User first name */
  recipient_user_first_name?: string;
  /** User last name */
  recipient_user_last_name?: string;
}

/** CreateTransferResponse */
export interface CreateTransferResponse {
  transfer: TransferResponse;
}

/** CreateUserRegisterRequest */
export interface CreateUserRegisterRequest {
  /**
   * User Id
   * @exclusiveMin 0
   */
  user_id: number;
  /**
   * Register Id
   * @exclusiveMin 0
   */
  register_id: number;
  role?: KeycloakRole;
  /**
   * Is Need Create Role
   * @default true
   */
  is_need_create_role?: boolean;
}

/** CreateUserRegisterResponse */
export interface CreateUserRegisterResponse {
  /** Status */
  status: string;
}

/** CreditsSchema */
export interface CreditsSchema {
  /** Credit Abn Not Quoted */
  credit_abn_not_quoted: string;
  /** Franked Distributions */
  franked_distributions: string;
  /** Franking Credit */
  franking_credit: string;
  /** Tfn Amounts Withheld */
  tfn_amounts_withheld: string;
  /** Share Tfn Withheld Trusts */
  share_tfn_withheld_trusts: string;
  /** Credit Foreign Resident Withholding */
  credit_foreign_resident_withholding: string;
  /** Share Foreign Resident Cgt Withholding */
  share_foreign_resident_cgt_withholding: string;
  /** Franking Credits Nz */
  franking_credits_nz: string;
  /** Credit Abn Not Quoted Allocation Method */
  credit_abn_not_quoted_allocation_method: "manual" | "auto";
  /** Credit Abn Not Quoted Total Fund */
  credit_abn_not_quoted_total_fund: string;
  /** Credit Abn Not Quoted Total Value */
  credit_abn_not_quoted_total_value: string;
  /** Franked Distributions Allocation Method */
  franked_distributions_allocation_method: "manual" | "auto";
  /** Franked Distributions Total Fund */
  franked_distributions_total_fund: string;
  /** Franked Distributions Total Value */
  franked_distributions_total_value: string;
  /** Franking Credit Allocation Method */
  franking_credit_allocation_method: "manual" | "auto";
  /** Franking Credit Total Fund */
  franking_credit_total_fund: string;
  /** Franking Credit Total Value */
  franking_credit_total_value: string;
  /** Tfn Amounts Withheld Allocation Method */
  tfn_amounts_withheld_allocation_method: "manual" | "auto";
  /** Tfn Amounts Withheld Total Fund */
  tfn_amounts_withheld_total_fund: string;
  /** Tfn Amounts Withheld Total Value */
  tfn_amounts_withheld_total_value: string;
  /** Share Tfn Withheld Trusts Allocation Method */
  share_tfn_withheld_trusts_allocation_method: "manual" | "auto";
  /** Share Tfn Withheld Trusts Total Fund */
  share_tfn_withheld_trusts_total_fund: string;
  /** Share Tfn Withheld Trusts Total Value */
  share_tfn_withheld_trusts_total_value: string;
  /** Credit Foreign Resident Withholding Allocation Method */
  credit_foreign_resident_withholding_allocation_method: "manual" | "auto";
  /** Credit Foreign Resident Withholding Total Fund */
  credit_foreign_resident_withholding_total_fund: string;
  /** Credit Foreign Resident Withholding Total Value */
  credit_foreign_resident_withholding_total_value: string;
  /** Share Foreign Resident Cgt Withholding Allocation Method */
  share_foreign_resident_cgt_withholding_allocation_method: "manual" | "auto";
  /** Share Foreign Resident Cgt Withholding Total Fund */
  share_foreign_resident_cgt_withholding_total_fund: string;
  /** Share Foreign Resident Cgt Withholding Total Value */
  share_foreign_resident_cgt_withholding_total_value: string;
  /** Franking Credits Nz Allocation Method */
  franking_credits_nz_allocation_method: "manual" | "auto";
  /** Franking Credits Nz Total Fund */
  franking_credits_nz_total_fund: string;
  /** Franking Credits Nz Total Value */
  franking_credits_nz_total_value: string;
  [key: string]: any;
}

/** CurrencyPairFxRate */
export interface CurrencyPairFxRate {
  from_currency: CurrencyEnum;
  to_currency: CurrencyEnum;
  /** Price */
  price: number;
  /**
   * Date
   * @format date
   */
  date: string;
}

/** DeleteAssetByIdResponse */
export interface DeleteAssetByIdResponse {
  /** Success */
  success: boolean;
}

/** DeleteBrokerByIdResponse */
export interface DeleteBrokerByIdResponse {
  /** Success */
  success: boolean;
}

/** DeleteDividendEventResponse */
export interface DeleteDividendEventResponse {
  /** Success */
  success: boolean;
}

/** DeleteEntityDocumentResponse */
export interface DeleteEntityDocumentResponse {
  /** Status */
  status: string;
}

/** DeleteEntityResponse */
export interface DeleteEntityResponse {
  /** Success */
  success: boolean;
}

/** DeleteIssuerResponse */
export interface DeleteIssuerResponse {
  /** Success */
  success: boolean;
}

/** DeleteNavByIdRequest */
export interface DeleteNavByIdRequest {
  /** Id */
  id: number;
  /** Justification */
  justification?: string;
}

/** DeleteNavByIdResponse */
export interface DeleteNavByIdResponse {
  /** Success */
  success: boolean;
}

/** DeletePortfolioByIdResponse */
export interface DeletePortfolioByIdResponse {
  /** Success */
  success: boolean;
}

/** DeletePortfolioTransactionByIdResponse */
export interface DeletePortfolioTransactionByIdResponse {
  /** Success */
  success: boolean;
}

/** DeleteRegisterBankResponse */
export interface DeleteRegisterBankResponse {
  /** Success */
  success: boolean;
}

/** DeleteRegisterClassResponse */
export interface DeleteRegisterClassResponse {
  /** Success */
  success: boolean;
}

/** DeleteRegisterResponse */
export interface DeleteRegisterResponse {
  /** Success */
  success: boolean;
}

/** DeleteReportResponse */
export interface DeleteReportResponse {
  /** Success */
  success: boolean;
}

/** DeleteUserAvatarResponse */
export interface DeleteUserAvatarResponse {
  /** Status */
  status: boolean;
}

/** DividendEvent */
export interface DividendEvent {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Register Id */
  register_id: number;
  /** Register Class Id */
  register_class_id: number;
  /**
   * Date
   * @format date-time
   */
  date: string;
  /** Amount Per Share */
  amount_per_share: number;
  type: DividendType;
  /** Memo */
  memo: string;
  /** Total Quantity */
  total_quantity?: number;
  /** Total Amount */
  total_amount?: number;
  status: DividendStatus;
  /** Payment Instruction Id */
  payment_instruction_id?: string;
  /**
   * Is Investor Distribution Generating
   * @default false
   */
  is_investor_distribution_generating?: boolean;
  /**
   * Investor Distribution Generation Started At
   * @format date-time
   */
  investor_distribution_generation_started_at?: string;
  /**
   * Investor Distribution Generation Completed At
   * @format date-time
   */
  investor_distribution_generation_completed_at?: string;
}

/** DividendEventExtendResponse */
export interface DividendEventExtendResponse {
  /** Name */
  name: string;
  /** Id */
  id: number;
  /** Register Class Id */
  register_class_id: number;
  /**
   * Date
   * @format date-time
   */
  date: string;
  /** Amount Per Share */
  amount_per_share: number;
  type: DividendType;
  /** Memo */
  memo: string;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Total Quantity */
  total_quantity?: number;
  /** Total Amount */
  total_amount?: number;
  register_obj: Register;
  register_class: RegisterClass;
  status: DividendStatus;
  /** Reports */
  reports?: ReportWithUrlResponse[];
  operation_statuses?: IsCompletedDividendEventOperations;
}

/** DividendEventResponse */
export interface DividendEventResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Register Class Id */
  register_class_id: number;
  /**
   * Date
   * @format date-time
   */
  date: string;
  /** Amount Per Share */
  amount_per_share: number;
  type: DividendType;
  /** Memo */
  memo: string;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Total Quantity */
  total_quantity?: number;
  /** Total Amount */
  total_amount?: number;
  status: DividendStatus;
  /** Report */
  report?: ReportWithUrl[];
}

/** DividendReinvestmentExtended */
export interface DividendReinvestmentExtended {
  /** Id */
  id: number;
  /** Register Class Name */
  register_class_name: string;
  /** Is Reinvest */
  is_reinvest: boolean;
}

/** DividendReinvestmentShareholder */
export interface DividendReinvestmentShareholder {
  /** Shareholder Id */
  shareholder_id: number;
  /** Dividend Reinvestment */
  dividend_reinvestment?: Record<string, boolean>;
}

/** DocumentWithUrl */
export interface DocumentWithUrl {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Belong Item Type */
  belong_item_type: string;
  /** File Storage Item Url */
  file_storage_item_url: string;
  /** Mimetype */
  mimetype: string;
  /** Size */
  size: number;
  /** Operation Document Id */
  operation_document_id?: number;
  /** File Name */
  file_name?: string;
  /** Operation Type */
  operation_type?: string;
  user?: UserShortModel;
  /**
   * Operation Document Date
   * @format date-time
   */
  operation_document_date?: string;
}

/** Entity */
export interface Entity {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** User Id */
  user_id: number;
  type?: EntityType;
  status: EntityStatus;
  /** Entity Id */
  entity_id: string;
  /** Entity Application Rejection Reason */
  entity_application_rejection_reason?: string;
  /** Bank Account Name */
  bank_account_name?: string;
  /** Bank Account Bsb */
  bank_account_bsb?: string;
  /** Bank Account Number */
  bank_account_number?: string;
  /** Bank Name */
  bank_name?: string;
  /** Email */
  email?: string;
  /** Phone Number */
  phone_number?: string;
  /** Address */
  address?: string;
  /** Entity Name */
  entity_name?: string;
  /** Apply Register Id */
  apply_register_id?: number;
  /** Additional Emails */
  additional_emails?: string[] | string;
  preferred_contact_way?: EntityPreferredContactWay;
  /** Individual Entity Details */
  individual_entity_details?: object;
  /** Company Entity Details */
  company_entity_details?: object;
  /** Trust Entity Details */
  trust_entity_details?: object;
  /** Partnership Entity Details */
  partnership_entity_details?: object;
  /** Association Entity Details Id */
  association_entity_details_id?: object;
  payment_info_status?: EntitiesPaymentInfoStatus;
  /**
   * Payment Info Updated At
   * @format date-time
   */
  payment_info_updated_at?: string;
  /**
   * Payment Info Requested At
   * @format date-time
   */
  payment_info_requested_at?: string;
  /** Smsf Entity Details */
  smsf_entity_details?: object;
  /** Send Information About Other Investments */
  send_information_about_other_investments?: boolean;
  /** Additional Address */
  additional_address?: string;
  /** Suburb */
  suburb?: string;
  /** State */
  state?: string;
  /** Postcode */
  postcode?: string;
  /** Country */
  country?: string;
  /** Notifications Enabled */
  notifications_enabled?: boolean;
}

/** EntityDetails */
export interface EntityDetails {
  /**
   * Associated People
   * @default []
   */
  associated_people?: AssociatedPeople[];
  tax?: TaxDetails;
  /** Investor Details */
  investor_details:
    | ({
        type_literal: "association";
      } & AssociationEntityDetails)
    | ({
        type_literal: "company";
      } & CompanyEntityDetails)
    | ({
        type_literal: "individual";
      } & IndividualEntityDetails)
    | ({
        type_literal: "partnership";
      } & PartnershipEntityDetails)
    | ({
        type_literal: "smsf";
      } & SMSFEntityDetails)
    | ({
        type_literal: "trust";
      } & TrustEntityDetails);
}

/** EntityDocumentItem */
export interface EntityDocumentItem {
  /** Data */
  data: string;
  /** Type */
  type: string;
  /** Index */
  index?: string;
}

/** EntityDocumentWithUrl */
export interface EntityDocumentWithUrl {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** Document Storage Item Id */
  document_storage_item_id: string;
  /** Entity Id */
  entity_id?: number;
  /** Type */
  type?: string;
  /** Url */
  url?: string;
  /** Index */
  index?: string;
  /** Issuer Edit Request Id */
  issuer_edit_request_id?: number;
}

/** EntityPaymentInfoVerifiedRequest */
export type EntityPaymentInfoVerifiedRequest = object;

/** EntityPaymentInfoVerifiedResponse */
export interface EntityPaymentInfoVerifiedResponse {
  /** Success */
  success: boolean;
}

/** EntityResponse */
export interface EntityResponse {
  /** Id */
  id: number;
  /** Entity Id */
  entity_id: string;
  /** User Id */
  user_id: number;
  type?: EntityType;
  status: EntityStatus;
  /** Entity Application Rejection Reason */
  entity_application_rejection_reason?: string;
  /** Bank Account Name */
  bank_account_name?: string;
  /** Bank Account Bsb */
  bank_account_bsb?: string;
  /** Bank Account Number */
  bank_account_number?: string;
  /** Bank Name */
  bank_name?: string;
  /** Email */
  email?: string;
  /** Additional Emails */
  additional_emails?: string[];
  /** Phone Number */
  phone_number?: string;
  /** Address */
  address?: string;
  /** Entity Name */
  entity_name?: string;
  /** Apply Register Id */
  apply_register_id?: number;
  preferred_contact_way?: EntityPreferredContactWay;
  /** Individual Entity Details */
  individual_entity_details?: object;
  /** Company Entity Details */
  company_entity_details?: object;
  /** Trust Entity Details */
  trust_entity_details?: object;
  /** Partnership Entity Details */
  partnership_entity_details?: object;
  /** Association Entity Details Id */
  association_entity_details_id?: object;
  /** Smsf Entity Details */
  smsf_entity_details?: object;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /** Send Information About Other Investments */
  send_information_about_other_investments?: boolean;
  /** Additional Address */
  additional_address?: string;
  /** Suburb */
  suburb?: string;
  /** State */
  state?: string;
  /** Postcode */
  postcode?: string;
  /** Country */
  country?: string;
  /** Notifications Enabled */
  notifications_enabled?: boolean;
}

/** EntitySetAwaitingApprovalRequest */
export interface EntitySetAwaitingApprovalRequest {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
}

/** EntitySetAwaitingApprovalResponse */
export interface EntitySetAwaitingApprovalResponse {
  entity: EntityResponse;
}

/** EntityWithDocumentResponse */
export interface EntityWithDocumentResponse {
  /** Id */
  id: number;
  /** User Id */
  user_id: number;
  /** Entity Id */
  entity_id: string;
  type?: EntityType;
  status?: EntityStatus;
  /** Entity Application Rejection Reason */
  entity_application_rejection_reason?: string;
  /** Bank Account Name */
  bank_account_name?: string;
  /** Bank Account Bsb */
  bank_account_bsb?: string;
  /** Bank Account Number */
  bank_account_number?: string;
  /** Bank Name */
  bank_name?: string;
  /** Email */
  email?: string;
  /** Additional Emails */
  additional_emails?: string[];
  /** Phone Number */
  phone_number?: string;
  /** Address */
  address?: string;
  /** Entity Name */
  entity_name?: string;
  preferred_contact_way?: EntityPreferredContactWay;
  /** Registers */
  registers?: Register[];
  /** Bron Id Verification Uuid */
  bron_id_verification_uuid?: string;
  /** Bron Id Requested Actions */
  bron_id_requested_actions?: any[];
  /** Individual Entity Details */
  individual_entity_details?: object;
  /** Company Entity Details */
  company_entity_details?: object;
  /** Trust Entity Details */
  trust_entity_details?: object;
  /** Partnership Entity Details */
  partnership_entity_details?: object;
  /** Association Entity Details Id */
  association_entity_details_id?: object;
  /** Document Files */
  document_files?: EntityDocumentWithUrl[];
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  user?: UserResponse;
  payment_info_status?: EntitiesPaymentInfoStatus;
  /**
   * Payment Info Updated At
   * @format date-time
   */
  payment_info_updated_at?: string;
  /**
   * Payment Info Requested At
   * @format date-time
   */
  payment_info_requested_at?: string;
  /** Smsf Entity Details */
  smsf_entity_details?: object;
  /** Send Information About Other Investments */
  send_information_about_other_investments?: boolean;
  /** Notifications Enabled */
  notifications_enabled?: boolean;
  /** Additional Address */
  additional_address?: string;
  /** Suburb */
  suburb?: string;
  /** State */
  state?: string;
  /** Postcode */
  postcode?: string;
  country?: CountryCodeEnum;
  /** Is Followup Sent */
  is_followup_sent?: boolean;
}

/** EventLogResponse */
export interface EventLogResponse {
  /** Id */
  id: number;
  /** Register Id */
  register_id?: number;
  /** Register Class Id */
  register_class_id?: number;
  /** Entity Id */
  entity_id?: number;
  /** Portfolio Id */
  portfolio_id?: number;
  /** Broker Id */
  broker_id?: number;
  type: EventLogType;
  /** Data */
  data: object;
  /** Is Read */
  is_read?: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Created By */
  created_by?: number;
  created_by_user?: UserResponse;
}

/** EventLogsIsReadRequest */
export interface EventLogsIsReadRequest {
  /** Ids */
  ids: number[];
  /** Read All */
  read_all?: boolean;
  /**
   * Is Deleted
   * If True, returns only soft-deleted records.
   * @default false
   */
  is_deleted?: boolean;
}

/** EventLogsIsReadResponse */
export interface EventLogsIsReadResponse {
  /** Status */
  status: boolean;
}

/** ExchangeUserTokenToEmbeddableTokenRequest */
export type ExchangeUserTokenToEmbeddableTokenRequest = object;

/** ExchangeUserTokenToEmbeddableTokenResponse */
export interface ExchangeUserTokenToEmbeddableTokenResponse {
  /** Access Token */
  access_token: string;
}

/** Fields */
export interface Fields {
  /** Country */
  country?: string;
  /** First Name */
  first_name?: string;
  /** Last Name */
  last_name?: string;
  /** Middle Name */
  middle_name?: string;
}

/** ForeignIncomeSchema */
export interface ForeignIncomeSchema {
  /** Attributed Foreign Income */
  attributed_foreign_income: string;
  /** Other Foreign Income */
  other_foreign_income: string;
  /** Foreign Tax Offset */
  foreign_tax_offset: string;
  /** Attributed Foreign Income Allocation Method */
  attributed_foreign_income_allocation_method: "manual" | "auto";
  /** Attributed Foreign Income Total Fund */
  attributed_foreign_income_total_fund: string;
  /** Attributed Foreign Income Total Value */
  attributed_foreign_income_total_value: string;
  /** Other Foreign Income Allocation Method */
  other_foreign_income_allocation_method: "manual" | "auto";
  /** Other Foreign Income Total Fund */
  other_foreign_income_total_fund: string;
  /** Other Foreign Income Total Value */
  other_foreign_income_total_value: string;
  /** Foreign Tax Offset Allocation Method */
  foreign_tax_offset_allocation_method: "manual" | "auto";
  /** Foreign Tax Offset Total Fund */
  foreign_tax_offset_total_fund: string;
  /** Foreign Tax Offset Total Value */
  foreign_tax_offset_total_value: string;
  [key: string]: any;
}

/** GenerateBulkReportsResponse */
export interface GenerateBulkReportsResponse {
  report: Report;
}

/** GenerateCertificatesForRegisterRequest */
export interface GenerateCertificatesForRegisterRequest {
  /** Register Id */
  register_id: number;
}

/** GenerateCertificatesForRegisterResponse */
export interface GenerateCertificatesForRegisterResponse {
  /** Success */
  success: boolean;
}

/** GenerateInvestorDistributionReportsResponse */
export interface GenerateInvestorDistributionReportsResponse {
  /** Success */
  success: boolean;
  /**
   * Deleted Reports Count
   * @default 0
   */
  deleted_reports_count?: number;
}

/** GenerateRedemptionRequestPdfRequest */
export interface GenerateRedemptionRequestPdfRequest {
  /**
   * Filename
   * @minLength 1
   */
  filename?: string;
}

/** GenerateReportRequest */
export interface GenerateReportRequest {
  type: ReportType;
  /**
   * Register Id
   * @exclusiveMin 0
   */
  register_id: number;
  /**
   * Entity Id
   * @exclusiveMin 0
   */
  entity_id?: number;
  /**
   * Portfolio Id
   * @exclusiveMin 0
   */
  portfolio_id?: number;
  /**
   * Register Class Ids
   * @minItems 1
   */
  register_class_ids: number[];
  /**
   * Dividend Event Id
   * @exclusiveMin 0
   */
  dividend_event_id?: number;
  /** File name */
  filename: string;
  format: ReportFormat;
  /**
   * Starting from this date
   * @format date
   */
  start_date?: string;
  /**
   * Ending at this date
   * @format date
   */
  end_date?: string;
  /**
   * Financial Year
   * @min 0
   * @max 9999
   */
  financial_year?: number;
  /**
   * Record limit
   * @default 0
   */
  limit?: number;
  /**
   * Is System
   * @default false
   */
  is_system?: boolean;
}

/** GenerateReportResponse */
export interface GenerateReportResponse {
  report: ReportResponse;
}

/** GetApplicationOverTimeChartResponse */
export interface GetApplicationOverTimeChartResponse {
  /** Data */
  data: ApplicationOverTimeChart[];
}

/** GetApplicationSummaryResponse */
export interface GetApplicationSummaryResponse {
  data: ApplicationSummary;
}

/** GetBalanceByDateResponse */
export interface GetBalanceByDateResponse {
  /** Balances */
  balances: TotalBalanceByDateResponse[];
}

/** GetBalanceStatisticsResponse */
export interface GetBalanceStatisticsResponse {
  /** Portfolio Value */
  portfolio_value: number;
  /** Performance */
  performance: number;
  /** Number Of Investments */
  number_of_investments: number;
  /** Dividends Received */
  dividends_received: number;
}

/** GetBlockchainEventResponse */
export interface GetBlockchainEventResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: BlockchainEvent[];
}

/** GetBlockchainInfoResponse */
export interface GetBlockchainInfoResponse {
  /** Encryption Key */
  encryption_key: string;
  /** Smart Contract Address */
  smart_contract_address: string;
  /** Link Explorer */
  link_explorer: string;
}

/** GetBulkReportChildrenResponse */
export interface GetBulkReportChildrenResponse {
  /** Data */
  data: ReportWithUrlResponse[];
}

/** GetBuyBackByIdExtendedResponse */
export interface GetBuyBackByIdExtendedResponse {
  data: BuyBackEvent;
}

/** GetBuyBackEventListResponse */
export interface GetBuyBackEventListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: BuyBackEventCalculateResponse[];
}

/** GetCommunicationCorrespondenceListResponse */
export interface GetCommunicationCorrespondenceListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: CorrespondenceCommunicationActivityItem[];
}

/** GetCommunicationListResponse */
export interface GetCommunicationListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: CommunicationResponse[];
}

/** GetCommunicationPreferenceChartResponse */
export interface GetCommunicationPreferenceChartResponse {
  data: CommunicationPreferenceChart;
}

/** GetCorrespondencesResponse */
export interface GetCorrespondencesResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: CorrespondenceCommunicationMessages[];
}

/** GetCurrencyHistoricalFXRateResponse */
export interface GetCurrencyHistoricalFXRateResponse {
  data: CurrencyPairFxRate;
}

/** GetCurrentUserActivitiesListResponse */
export interface GetCurrentUserActivitiesListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: ActivitiesPaginateResponse[];
}

/** GetCurrentUserResponse */
export interface GetCurrentUserResponse {
  user: UserResponse;
}

/** GetCurrentUserTransactionListResponse */
export interface GetCurrentUserTransactionListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: TransactionPaginateResponse[];
}

/** GetDividendByIdExtendedResponse */
export interface GetDividendByIdExtendedResponse {
  data: DividendEventExtendResponse;
}

/** GetDocumentsResponse */
export interface GetDocumentsResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: DocumentWithUrl[];
}

/** GetEntitiesListResponse */
export interface GetEntitiesListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: EntityWithDocumentResponse[];
}

/** GetEntitiesResponse */
export interface GetEntitiesResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: EntityWithDocumentResponse[];
}

/** GetEntityItemResponse */
export interface GetEntityItemResponse {
  entity: EntityWithDocumentResponse;
}

/** GetEntityShareholdersResponse */
export interface GetEntityShareholdersResponse {
  /** Shareholders */
  shareholders: ShareholderExtendResponse[];
  /** Register Settings */
  register_settings: RegisterSettingsResponse[];
}

/** GetEventLogListResponse */
export interface GetEventLogListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: EventLogResponse[];
}

/** GetHolderTaxReportByYearDataResponse */
export interface GetHolderTaxReportByYearDataResponse {
  /** Year */
  year: number;
  /** Id */
  id?: number;
  /** Entity Id */
  entity_id: number;
  /** Register Id */
  register_id: number;
  /** Tax Report Json */
  tax_report_json: TaxReportByYearDataSchema | object;
}

/** GetHolderTaxReportYearsByRegisterResponse */
export interface GetHolderTaxReportYearsByRegisterResponse {
  /** Data */
  data: HolderTaxReportYearItemResponse[];
}

/** GetInvestorCertificateListResponse */
export interface GetInvestorCertificateListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: ShareCertificateResponse[];
}

/** GetInvestorEditByIdResponse */
export interface GetInvestorEditByIdResponse {
  data: InvestorEditsExtend;
}

/** GetInvestorEditListResponse */
export interface GetInvestorEditListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: InvestorEditsExtend[];
}

/** GetIssuedCapitalChartResponse */
export interface GetIssuedCapitalChartResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: IssuedCapitalData[];
}

/** GetIssuedCapitalOvertimeChartBySecuritiesResponse */
export interface GetIssuedCapitalOvertimeChartBySecuritiesResponse {
  /** Data */
  data: IssuedCapitalOverTimeChartBySecurities[];
}

/** GetIssuedCapitalOvertimeChartResponse */
export interface GetIssuedCapitalOvertimeChartResponse {
  /** Data */
  data: IssuedCapitalOverTimeChart[];
}

/** GetIssuerActivitiesListResponse */
export interface GetIssuerActivitiesListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: ActivitiesPaginateResponse[];
}

/** GetIssuerCapitalSummarySectionResponse */
export interface GetIssuerCapitalSummarySectionResponse {
  /** Data */
  data: CapitalSummarySection[];
}

/** GetIssuerCertificateListResponse */
export interface GetIssuerCertificateListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: ShareCertificateResponse[];
}

/** GetIssuerDividendEventListResponse */
export interface GetIssuerDividendEventListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: DividendEventExtendResponse[];
}

/** GetIssuerListResponse */
export interface GetIssuerListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: IssuerResponse[];
}

/** GetIssuerRegisterClassListResponse */
export interface GetIssuerRegisterClassListResponse {
  /** Registers */
  registers: IssuerRegisterClassResponse[];
}

/** GetIssuerTopHoldersResponse */
export interface GetIssuerTopHoldersResponse {
  data: TopHoldersChart;
}

/** GetIssuerTransferListResponse */
export interface GetIssuerTransferListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: TransferPaginateResponse[];
}

/** GetIssuersByRegisterResponse */
export interface GetIssuersByRegisterResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: Issuer[];
}

/** GetMyInvestmentsResponse */
export interface GetMyInvestmentsResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: RegisterWithInvestmentResponse[];
}

/** GetNavsListEmbeddableResponse */
export interface GetNavsListEmbeddableResponse {
  /** Data */
  data: RegisterClassWithNAVResponse[];
}

/** GetNavsListResponse */
export interface GetNavsListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: NAVHistoryItemResponse[];
}

/** GetPaginatedNavsListEmbeddablesResponse */
export interface GetPaginatedNavsListEmbeddablesResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: NAVHistoryItemResponse[];
}

/** GetPaymentByIdExtendedResponse */
export interface GetPaymentByIdExtendedResponse {
  data: PaymentExtend;
}

/** GetPaymentElectionChartResponse */
export interface GetPaymentElectionChartResponse {
  /** Data */
  data: PaymentElectionChart[];
}

/** GetPaymentListResponse */
export interface GetPaymentListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: PaymentPaginateResponse[];
}

/** GetPendingApplicationChartResponse */
export interface GetPendingApplicationChartResponse {
  data: PendingApplicationChart;
}

/** GetPendingApplicationSummaryChartResponse */
export interface GetPendingApplicationSummaryChartResponse {
  /** Data */
  data: ApplicationSummaryResponse[];
}

/** GetPendingApplicationSummarySectionResponse */
export interface GetPendingApplicationSummarySectionResponse {
  /** Data */
  data: SummaryPendingApplicationSection[];
  /** Total Sum */
  total_sum: number;
}

/** GetPnlOvertimeChartResponse */
export interface GetPnlOvertimeChartResponse {
  /** Data */
  data: OvertimeData[];
}

/** GetPortfolioByIdResponse */
export interface GetPortfolioByIdResponse {
  portfolio: PortfolioExtended;
}

/** GetPortfolioCashMovementListResponse */
export interface GetPortfolioCashMovementListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: PortfolioCashMovementPaginateResponse[];
}

/** GetRegisterByIdResponse */
export interface GetRegisterByIdResponse {
  data: RegisterByIdResponse;
}

/** GetRegisterByPrivateIdResponse */
export interface GetRegisterByPrivateIdResponse {
  data: RegisterByPrivateIdResponse;
}

/** GetRegisterClassByIdResponse */
export interface GetRegisterClassByIdResponse {
  register_class: RegisterClassByIdResponse;
}

/** GetRegisterClassListResponse */
export interface GetRegisterClassListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: RegisterClassResponse[];
}

/** GetRegisterClassUnitsResponse */
export interface GetRegisterClassUnitsResponse {
  /** Data */
  data: IssuedUnitsData[];
}

/** GetRegisterClassesWithNAVResponse */
export interface GetRegisterClassesWithNAVResponse {
  /** Data */
  data: RegisterClassWithNAVResponse[];
}

/** GetRegisterListResponse */
export interface GetRegisterListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: RegisterWithJoinResponse[];
}

/** GetRegisterTotalFundByYearListResponse */
export interface GetRegisterTotalFundByYearListResponse {
  /** Year */
  year: number;
  /** Registers */
  registers: RegisterTotalFundByYearListItem[];
}

/** GetRegisterTotalFundByYearRegisterHoldersResponse */
export interface GetRegisterTotalFundByYearRegisterHoldersResponse {
  /** Register Id */
  register_id: number;
  /** Holders */
  holders: RegisterTotalFundByYearHolderItem[];
}

/** GetRegisterUsersResponse */
export interface GetRegisterUsersResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: RegisterUserItem[];
}

/** GetReportListResponse */
export interface GetReportListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: ReportWithUrlResponse[];
}

/** GetShareCertificateDataResponse */
export interface GetShareCertificateDataResponse {
  certificate: ShareCertificateDataResponse;
}

/** GetShareholderByEntityIdResponse */
export interface GetShareholderByEntityIdResponse {
  /** Data */
  data: ShareholderExtend[];
}

/** GetShareholdersByRegisterIdResponse */
export interface GetShareholdersByRegisterIdResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: ShareholderExtendResponse[];
}

/** GetShareholdersByRegisterResponse */
export interface GetShareholdersByRegisterResponse {
  /** Shareholders */
  shareholders: ShareholderExtendResponse[];
}

/** GetShareholdersSubscriptionsClassesResponse */
export interface GetShareholdersSubscriptionsClassesResponse {
  /** Shareholders */
  shareholders: ShareholderExtendWithSubscriptionClasses[];
}

/** GetTaxReportIncomeResponse */
export interface GetTaxReportIncomeResponse {
  /**
   * All Investors Distributions
   * Total sum of distributions for all investors in the system in the given period
   */
  all_investors_distributions: number;
  /**
   * All Other Investors Distributions
   * Total sum of distributions in the given period for all investors except the current one passed to the request
   */
  all_other_investors_distributions: number;
}

/** GetTotalCashInOutChartResponse */
export interface GetTotalCashInOutChartResponse {
  /** Data */
  data: CashInOutChartData[];
}

/** GetTotalIsReadValueResponse */
export interface GetTotalIsReadValueResponse {
  /** All Is Read */
  all_is_read: boolean;
}

/** GetTotalShareholderHistoryResponse */
export interface GetTotalShareholderHistoryResponse {
  /** Data */
  data: RegisterClassHistoryResponse[];
}

/** GetTransactionListResponse */
export interface GetTransactionListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: TransactionPaginateResponse[];
}

/** GetTransactionResponse */
export interface GetTransactionResponse {
  transaction: TransactionWithStorageItemUrl;
}

/** GetTransferResponse */
export interface GetTransferResponse {
  transfer: TransferPaginateResponse;
}

/** GetUserEntitiesResponse */
export interface GetUserEntitiesResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: EntityWithDocumentResponse[];
}

/** GetUserListResponse */
export interface GetUserListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: UserResponse[];
}

/** GetUserPermissionResponse */
export interface GetUserPermissionResponse {
  /** Data */
  data: UserPermission[];
}

/** GetUserRegistersResponse */
export interface GetUserRegistersResponse {
  /** Data */
  data: UserRegisterResponse[];
  /** Register Settings */
  register_settings: RegisterSettingsResponse[];
}

/** GetUserTransferListResponse */
export interface GetUserTransferListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: TransferPaginateResponse[];
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

/** HandleInvestorEditsRequest */
export interface HandleInvestorEditsRequest {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
  /** Must be 'approved' or 'rejected' */
  status: InvestorEditsStatus;
  /**
   * Description
   * Explanation for rejection (required when status is 'rejected')
   */
  description?: string;
}

/** HandleInvestorEditsResponse */
export interface HandleInvestorEditsResponse {
  investor_edit: InvestorEditResponse;
}

/** HolderTaxReportYearItemResponse */
export interface HolderTaxReportYearItemResponse {
  /** Year */
  year: number;
  /** Id */
  id: number;
  /** Entity Id */
  entity_id: number;
  /** Register Id */
  register_id: number;
  /** Register Name */
  register_name: string;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
}

/** IDVRiskScore */
export interface IDVRiskScore {
  /** Description */
  description?: string;
}

/** ImportOperationsRequest */
export interface ImportOperationsRequest {
  /** Register Id */
  register_id: number;
  /** Register Class Id */
  register_class_id: number;
  /** Transactions */
  transactions?: ImportTransaction[];
  /** Transfers */
  transfers?: ImportTransfers[];
  /**
   * The password for the new users
   * @format password
   * @minLength 1
   * @maxLength 300
   */
  password_for_new_entity?: string;
}

/** ImportOperationsResponse */
export interface ImportOperationsResponse {
  /** Success */
  success: boolean;
}

/** ImportTransaction */
export interface ImportTransaction {
  status: TransactionStatus;
  type: TransactionType;
  shareholder: ShareholderShortInfo;
  /**
   * Requested At Date
   * @format date-time
   */
  requested_at_date: string;
  /**
   * Issued Date
   * @format date-time
   */
  issued_date: string;
  /** Price Per Share */
  price_per_share: number;
  /** Quantity */
  quantity: number;
  /**
   * Dividend Reinvestment
   * @default false
   */
  dividend_reinvestment?: boolean;
  /** Memo */
  memo?: string;
}

/** ImportTransfers */
export interface ImportTransfers {
  status: TransactionStatus;
  from_shareholder: ShareholderShortInfo;
  to_shareholder: ShareholderShortInfo;
  /**
   * Requested At Date
   * @format date-time
   */
  requested_at_date: string;
  /**
   * Issued Date
   * @format date-time
   */
  issued_date: string;
  /** Price Per Share */
  price_per_share: number;
  /** Quantity */
  quantity: number;
  /** Memo */
  memo?: string;
  /** Document Id */
  document_id: string;
}

/** IndividualEntityDetails */
export interface IndividualEntityDetails {
  /** Country */
  country?: string;
  /** First Name */
  first_name?: string;
  /** Last Name */
  last_name?: string;
  /** Title */
  title?: string;
  /** Middle Name */
  middle_name?: string;
  /** Gender */
  gender?: string;
  /** Date Of Birth */
  date_of_birth?: string;
  /** Unit Number */
  unit_number?: string;
  /** Street Number */
  street_number?: string;
  /** Street Name */
  street_name?: string;
  /** Street Type */
  street_type?: string;
  /** Suburb */
  suburb?: string;
  /** State */
  state?: string;
  /** Postcode */
  postcode?: string;
  /** Locality */
  locality?: string;
  /** Country Of Issue */
  country_of_issue?: string;
  /** Account Holders Gin */
  account_holders_gin?: string;
  /** Sponsoring Entity Name */
  sponsoring_entity_name?: string;
  /** Tax Residence */
  tax_residence?: TaxResidence[];
  /** Is Us Person */
  is_us_person?: boolean;
  /** Non Us Person Certification */
  non_us_person_certification?: string;
  /** Is Wholesale */
  is_wholesale?: boolean;
  /** Type */
  type?: string;
  /**
   * Type Literal
   * @default "individual"
   */
  type_literal?: "individual";
  /** Business Name Trustee */
  business_name_trustee?: string;
}

/** InvestorDataExtractionRequest */
export interface InvestorDataExtractionRequest {
  /**
   * Register ID
   * @minItems 1
   */
  register_ids: number[];
}

/** InvestorDataExtractionResponse */
export interface InvestorDataExtractionResponse {
  /** Success */
  success: boolean;
}

/** InvestorEditResponse */
export interface InvestorEditResponse {
  /** Id */
  id: number;
  /** User Id */
  user_id: number;
  /** Register Id */
  register_id: number;
  /** Old Data */
  old_data: object;
  /** New Data */
  new_data: object;
  status: InvestorEditsStatus;
  /**
   * Requested At
   * @format date-time
   */
  requested_at: string;
  /** Description */
  description?: string;
}

/** InvestorEdits */
export interface InvestorEdits {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** User Id */
  user_id: number;
  /** Register Id */
  register_id: number;
  status: InvestorEditsStatus;
  /** Old Data */
  old_data: object;
  /** New Data */
  new_data: object;
  /**
   * Requested At
   * @format date-time
   */
  requested_at: string;
  /** Description */
  description?: string;
  /** Shareholder Id */
  shareholder_id?: number;
  /** Edited By */
  edited_by?: number;
}

/** InvestorEditsExtend */
export interface InvestorEditsExtend {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** User Id */
  user_id: number;
  /** Register Id */
  register_id: number;
  status: InvestorEditsStatus;
  /** Old Data */
  old_data: object;
  /** New Data */
  new_data: object;
  /**
   * Requested At
   * @format date-time
   */
  requested_at: string;
  /** Description */
  description?: string;
  /** Shareholder Id */
  shareholder_id?: number;
  shareholder?: ShareholderExtend;
  user?: ShareholderUser;
  /** Edited By */
  edited_by?: number;
  edited_by_user?: ShareholderUser;
}

/** IsCompletedDividendEventOperations */
export interface IsCompletedDividendEventOperations {
  /** Payments */
  payments: boolean;
  /** Drps */
  drps: boolean;
}

/** IssuedCapitalData */
export interface IssuedCapitalData {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Total */
  total: number;
  /** Percentage */
  percentage: number;
  /** Total Units */
  total_units: number;
}

/** IssuedCapitalOverTimeChart */
export interface IssuedCapitalOverTimeChart {
  /** Value */
  value: number;
  /**
   * Date
   * @format date
   */
  date: string;
}

/** IssuedCapitalOverTimeChartBySecurities */
export interface IssuedCapitalOverTimeChartBySecurities {
  security: RegisterClassChart;
  /** Data */
  data: IssuedCapitalOverTimeChart[];
}

/** IssuedUnitsData */
export interface IssuedUnitsData {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Total Units */
  total_units: number;
}

/** Issuer */
export interface Issuer {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /**
   * Email
   * @format email
   */
  email: string;
  /** Is Email Confirmed */
  is_email_confirmed: boolean;
  /**
   * Email Confirmation Token
   * @format password
   */
  email_confirmation_token?: string;
  /** Avatar Storage Item Id */
  avatar_storage_item_id?: string;
  /** Avatar Url */
  avatar_url?: string;
  /** Registers */
  registers?: RegisterParty[];
  /** User Registers */
  user_registers: UserRegister[];
  /** User Permissions */
  user_permissions?: IssuerPermission[];
  issuer_role?: KeycloakIssuerRole;
  /** Keycloak User Id */
  keycloak_user_id?: string;
}

/** IssuerAddNewIssuerRequest */
export interface IssuerAddNewIssuerRequest {
  /**
   * The first name of the user
   * @minLength 3
   * @maxLength 100
   */
  first_name: string;
  /**
   * The last name of the user
   * @minLength 3
   * @maxLength 100
   */
  last_name: string;
  /**
   * The email of the user
   * @format email
   */
  email: string;
  /**
   * Register ID
   * @minItems 1
   */
  register_ids: number[];
  /** The role of the user */
  role: KeycloakIssuerRole;
  /** Redirect URL */
  redirect_url?: string;
  /**
   * Register Permission
   * @default false
   */
  register_permission?: boolean;
  /**
   * Communication Permission
   * @default true
   */
  communication_permission?: boolean;
  /**
   * Holder Details Permission
   * @default false
   */
  holder_details_permission?: boolean;
}

/** IssuerAddNewIssuerResponse */
export interface IssuerAddNewIssuerResponse {
  user: UserResponse;
}

/** IssuerDeleteIssuersRegisterResponse */
export interface IssuerDeleteIssuersRegisterResponse {
  /** Status */
  status: string;
}

/** IssuerPermission */
export interface IssuerPermission {
  /** Register Id */
  register_id: number;
  /** Register Permission */
  register_permission: boolean;
  /** Communication Permission */
  communication_permission: boolean;
  /** Holder Details Permission */
  holder_details_permission: boolean;
}

/** IssuerRegisterClassResponse */
export interface IssuerRegisterClassResponse {
  /** Id */
  id: number;
  /** Class Name */
  class_name: string;
  /** Register Id */
  register_id: number;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /** Current Price Per Share */
  current_price_per_share: number;
  /** Transfer Lock Period */
  transfer_lock_period?: number;
  /** Min Investment */
  min_investment: number;
  /** Total Invested */
  total_invested: number;
  /** Total Holders */
  total_holders: number;
  register_obj?: RegisterResponse;
  /** Total Units */
  total_units: number;
  /**
   * Available Cash
   * @default "0.00"
   */
  available_cash?: number;
}

/** IssuerResponse */
export interface IssuerResponse {
  /** Id */
  id: number;
  /**
   * Email
   * @format email
   */
  email: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /** Avatar Storage Item Id */
  avatar_storage_item_id?: string;
  /** Avatar Url */
  avatar_url?: string;
  /** Registers */
  registers?: RegisterParty[];
  /** User Registers */
  user_registers?: UserRegister[];
  /** User Permissions */
  user_permissions?: IssuerPermission[];
}

/** MigrateDataToKeycloakRequest */
export type MigrateDataToKeycloakRequest = object;

/** MigrateDataToKeycloakResponse */
export interface MigrateDataToKeycloakResponse {
  /** Data */
  data: object;
}

/** NAVHistoryItem */
export interface NAVHistoryItem {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** Register Class Id */
  register_class_id: number;
  /** Price Per Share */
  price_per_share: number;
  /**
   * Changes Date
   * @format date-time
   */
  changes_date?: string;
  /**
   * Is Active
   * @default false
   */
  is_active?: boolean;
  /**
   * Is From Portfolio
   * @default false
   */
  is_from_portfolio?: boolean;
  /**
   * Is From Portfolio Edited
   * @default false
   */
  is_from_portfolio_edited?: boolean;
}

/** NAVHistoryItemResponse */
export interface NAVHistoryItemResponse {
  /** Id */
  id: number;
  /** Register Class Id */
  register_class_id: number;
  /** Price Per Share */
  price_per_share: number;
  /**
   * Changes Date
   * @format date-time
   */
  changes_date: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Is Active
   * @default false
   */
  is_active?: boolean;
  /**
   * Is From Portfolio
   * @default false
   */
  is_from_portfolio?: boolean;
  /**
   * Is From Portfolio Edited
   * @default false
   */
  is_from_portfolio_edited?: boolean;
}

/** NAVHistoryResponse */
export interface NAVHistoryResponse {
  /** Price Per Share */
  price_per_share: number;
  /**
   * Changes Date
   * @format date-time
   */
  changes_date: string;
}

/** OffsetsSchema */
export interface OffsetsSchema {
  /** Rental Affordability Scheme */
  rental_affordability_scheme: string;
  /** Exploration Credits */
  exploration_credits: string;
  /** Venture Capital Offset */
  venture_capital_offset: string;
  /** Early Stage Investor Offset */
  early_stage_investor_offset: string;
  /** Rental Affordability Scheme Allocation Method */
  rental_affordability_scheme_allocation_method: "manual" | "auto";
  /** Rental Affordability Scheme Total Fund */
  rental_affordability_scheme_total_fund: string;
  /** Rental Affordability Scheme Total Value */
  rental_affordability_scheme_total_value: string;
  /** Exploration Credits Allocation Method */
  exploration_credits_allocation_method: "manual" | "auto";
  /** Exploration Credits Total Fund */
  exploration_credits_total_fund: string;
  /** Exploration Credits Total Value */
  exploration_credits_total_value: string;
  /** Venture Capital Offset Allocation Method */
  venture_capital_offset_allocation_method: "manual" | "auto";
  /** Venture Capital Offset Total Fund */
  venture_capital_offset_total_fund: string;
  /** Venture Capital Offset Total Value */
  venture_capital_offset_total_value: string;
  /** Early Stage Investor Offset Allocation Method */
  early_stage_investor_offset_allocation_method: "manual" | "auto";
  /** Early Stage Investor Offset Total Fund */
  early_stage_investor_offset_total_fund: string;
  /** Early Stage Investor Offset Total Value */
  early_stage_investor_offset_total_value: string;
  [key: string]: any;
}

/** OperationDocument */
export interface OperationDocument {
  /** Transaction Id */
  transaction_id?: number;
  /** Transfer Id */
  transfer_id?: number;
  /** Document Id */
  document_id: string;
  /** User Id */
  user_id?: number;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
}

/** OperationDocumentResponse */
export interface OperationDocumentResponse {
  /** Transaction Id */
  transaction_id?: number;
  /** Transfer Id */
  transfer_id?: number;
  /** Document Id */
  document_id: string;
  /** User Id */
  user_id?: number;
  /** Document Storage Item Url */
  document_storage_item_url?: string;
  /** Size */
  size?: number;
  /** Mimetype */
  mimetype?: string;
  /** File Name */
  file_name?: string;
}

/** OtherDeductionsSchema */
export interface OtherDeductionsSchema {
  /** Tfn Amounts Withheld */
  tfn_amounts_withheld: string;
  /** Non Resident Amounts Withheld */
  non_resident_amounts_withheld: string;
  /** Other Expenses */
  other_expenses: string;
  /** Net Cash Distribution */
  net_cash_distribution: string;
  /** Tfn Amounts Withheld Allocation Method */
  tfn_amounts_withheld_allocation_method: "manual" | "auto";
  /** Tfn Amounts Withheld Total Fund */
  tfn_amounts_withheld_total_fund: string;
  /** Tfn Amounts Withheld Total Value */
  tfn_amounts_withheld_total_value: string;
  /** Non Resident Amounts Withheld Allocation Method */
  non_resident_amounts_withheld_allocation_method: "manual" | "auto";
  /** Non Resident Amounts Withheld Total Fund */
  non_resident_amounts_withheld_total_fund: string;
  /** Non Resident Amounts Withheld Total Value */
  non_resident_amounts_withheld_total_value: string;
  /** Other Expenses Allocation Method */
  other_expenses_allocation_method: "manual" | "auto";
  /** Other Expenses Total Fund */
  other_expenses_total_fund: string;
  /** Other Expenses Total Value */
  other_expenses_total_value: string;
  /** Net Cash Distribution Allocation Method */
  net_cash_distribution_allocation_method: "manual" | "auto";
  /** Net Cash Distribution Total Fund */
  net_cash_distribution_total_fund: string;
  /** Net Cash Distribution Total Value */
  net_cash_distribution_total_value: string;
  [key: string]: any;
}

/** OtherNonAssessableAmountsSchema */
export interface OtherNonAssessableAmountsSchema {
  /** Net Exempt Income */
  net_exempt_income: string;
  /** Non Assessable Non Exempt Amount */
  non_assessable_non_exempt_amount: string;
  /** Tax Free Amounts */
  tax_free_amounts: string;
  /** Tax Deferred Amounts */
  tax_deferred_amounts: string;
  /** Return Of Capital */
  return_of_capital: string;
  /** Gross Cash Distribution */
  gross_cash_distribution: string;
  /** Net Exempt Income Allocation Method */
  net_exempt_income_allocation_method: "manual" | "auto";
  /** Net Exempt Income Total Fund */
  net_exempt_income_total_fund: string;
  /** Net Exempt Income Total Value */
  net_exempt_income_total_value: string;
  /** Non Assessable Non Exempt Amount Allocation Method */
  non_assessable_non_exempt_amount_allocation_method: "manual" | "auto";
  /** Non Assessable Non Exempt Amount Total Fund */
  non_assessable_non_exempt_amount_total_fund: string;
  /** Non Assessable Non Exempt Amount Total Value */
  non_assessable_non_exempt_amount_total_value: string;
  /** Tax Free Amounts Allocation Method */
  tax_free_amounts_allocation_method: "manual" | "auto";
  /** Tax Free Amounts Total Fund */
  tax_free_amounts_total_fund: string;
  /** Tax Free Amounts Total Value */
  tax_free_amounts_total_value: string;
  /** Tax Deferred Amounts Allocation Method */
  tax_deferred_amounts_allocation_method: "manual" | "auto";
  /** Tax Deferred Amounts Total Fund */
  tax_deferred_amounts_total_fund: string;
  /** Tax Deferred Amounts Total Value */
  tax_deferred_amounts_total_value: string;
  /** Return Of Capital Allocation Method */
  return_of_capital_allocation_method: "manual" | "auto";
  /** Return Of Capital Total Fund */
  return_of_capital_total_fund: string;
  /** Return Of Capital Total Value */
  return_of_capital_total_value: string;
  /** Gross Cash Distribution Allocation Method */
  gross_cash_distribution_allocation_method: "manual" | "auto";
  /** Gross Cash Distribution Total Fund */
  gross_cash_distribution_total_fund: string;
  /** Gross Cash Distribution Total Value */
  gross_cash_distribution_total_value: string;
  [key: string]: any;
}

/** OutWatch */
export interface OutWatch {
  /** Country Name */
  country_name?: string;
  /** Description */
  description?: string;
  /** Link */
  link?: string;
  /** Name */
  name?: string;
}

/** OvertimeData */
export interface OvertimeData {
  /**
   * Date
   * @format date
   */
  date: string;
  /** Value */
  value: number;
}

/** PartnershipEntityDetails */
export interface PartnershipEntityDetails {
  /** Country */
  country?: string;
  /** Abn */
  abn?: string;
  /** Nzbn */
  nzbn?: string;
  /** Registered Office */
  registered_office?: string;
  /** Principal Place Of Business */
  principal_place_of_business?: string;
  /** Stakeholders */
  stakeholders: IndividualEntityDetails[];
  /** Entity Number */
  entity_number?: string;
  /** Partnership Type */
  partnership_type?: string;
  /** Company Name */
  company_name?: string;
  /** Is Advisor */
  is_advisor?: boolean;
  /** Is Wholesale */
  is_wholesale?: boolean;
  /**
   * Type Literal
   * @default "partnership"
   */
  type_literal?: "partnership";
  /** Business Name Trustee */
  business_name_trustee?: string;
}

/** PaymentElectionChart */
export interface PaymentElectionChart {
  /** Register Class Id */
  register_class_id: number;
  /** Class Name */
  class_name: string;
  drp?: TotalPercentageData;
  direct_credit?: TotalPercentageData;
}

/** PaymentExtend */
export interface PaymentExtend {
  /** Id */
  id: number;
  /** Register Id */
  register_id: number;
  /** Shareholder Id */
  shareholder_id: number;
  /**
   * Confirmation Date
   * @format date-time
   */
  confirmation_date?: string;
  /**
   * Requested At Date
   * @format date-time
   */
  requested_at_date: string;
  /** Transaction Id */
  transaction_id?: number;
  direction: PaymentDirection;
  status: PaymentStatus;
  /** Amount */
  amount: number;
  /** Memo */
  memo?: string;
  /** Dividend Event Id */
  dividend_event_id?: number;
  register_obj: Register;
  shareholder: Shareholder;
  transaction?: Transaction;
  dividend_event?: DividendEvent;
}

/** PaymentPaginateResponse */
export interface PaymentPaginateResponse {
  /** Id */
  id: number;
  /** Register Id */
  register_id: number;
  /** Shareholder Id */
  shareholder_id?: number;
  /**
   * Confirmation Date
   * @format date-time
   */
  confirmation_date?: string;
  /**
   * Requested At Date
   * @format date-time
   */
  requested_at_date: string;
  /** Transaction Id */
  transaction_id?: number;
  direction: PaymentDirection;
  status: PaymentStatus;
  /** Amount */
  amount: number;
  /** Memo */
  memo?: string;
  /** Dividend Event Id */
  dividend_event_id?: number;
  shareholder_user?: UserResponse;
  shareholder_entity?: Entity;
  register_obj: RegisterResponse;
  /** Price Per Share */
  price_per_share?: number;
  to_bank?: RegisterBankExtended;
  from_bank?: RegisterBankExtended;
  /** Fx Rate */
  fx_rate?: number;
}

/** PaymentResponse */
export interface PaymentResponse {
  /** Id */
  id: number;
  /** Register Id */
  register_id: number;
  /** Shareholder Id */
  shareholder_id?: number;
  /**
   * Confirmation Date
   * @format date-time
   */
  confirmation_date?: string;
  /**
   * Requested At Date
   * @format date-time
   */
  requested_at_date: string;
  /** Transaction Id */
  transaction_id?: number;
  direction: PaymentDirection;
  status: PaymentStatus;
  /** Amount */
  amount: number;
  /** Memo */
  memo?: string;
  /** Dividend Event Id */
  dividend_event_id?: number;
}

/** PaymentSetCompletedStatusRequest */
export interface PaymentSetCompletedStatusRequest {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
  /**
   * Amount
   * @min 0
   */
  amount?: number;
  /**
   * Confirmation Date
   * @format date-time
   */
  confirmation_date?: string;
  /** Memo */
  memo?: string;
  /** @default "down" */
  round_to?: RoundTo;
  /**
   * Is Need Complete
   * @default true
   */
  is_need_complete?: boolean;
  /**
   * Do Not Notify Investor
   * @default false
   */
  do_not_notify_investor?: boolean;
  /**
   * Sync Transaction Status
   * @default true
   */
  sync_transaction_status?: boolean;
}

/** PaymentSetCompletedStatusResponse */
export interface PaymentSetCompletedStatusResponse {
  payment: PaymentResponse;
}

/** PaymentSetRejectedStatusRequest */
export interface PaymentSetRejectedStatusRequest {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
  /** Memo */
  memo?: string;
}

/** PaymentSetRejectedStatusResponse */
export interface PaymentSetRejectedStatusResponse {
  payment: PaymentResponse;
}

/** PendingApplication */
export interface PendingApplication {
  paid?: PendingApplicationData;
  unpaid?: PendingApplicationData;
}

/** PendingApplicationChart */
export interface PendingApplicationChart {
  cash: PendingApplication;
  investor: PendingApplication;
}

/** PendingApplicationData */
export interface PendingApplicationData {
  /** Total */
  total: number;
  /** Percentage */
  percentage: number;
}

/** Portfolio */
export interface Portfolio {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** Name */
  name: string;
  /**
   * Balance
   * @default "0.00"
   */
  balance?: number;
  /** Register Id */
  register_id: number;
}

/** PortfolioCashMovementPaginateResponse */
export interface PortfolioCashMovementPaginateResponse {
  /** Id */
  id: number;
  /** Register Id */
  register_id: number;
  /** Shareholder Id */
  shareholder_id?: number;
  /**
   * Confirmation Date
   * @format date-time
   */
  confirmation_date?: string;
  /**
   * Requested At Date
   * @format date-time
   */
  requested_at_date: string;
  /** Transaction Id */
  transaction_id?: number;
  direction: CashMovementType;
  status: PaymentStatus;
  /** Amount */
  amount: number;
  /** Memo */
  memo?: string;
  /** Dividend Event Id */
  dividend_event_id?: number;
  /** Correspondence Id */
  correspondence_id?: number;
  shareholder_user?: UserResponse;
  shareholder_entity?: Entity;
  register_obj: RegisterResponse;
  /** Price Per Share */
  price_per_share?: number;
  to_bank?: RegisterBankExtended;
  from_bank?: RegisterBankExtended;
  /** Fx Rate */
  fx_rate?: number;
  transaction?: Transaction;
  dividend_event?: DividendEvent;
  portfolio_transaction?: PortfolioTransaction;
  /** Payment Id */
  payment_id?: number;
  correspondence?: CorrespondenceSummary;
}

/** PortfolioCashMovementResponse */
export interface PortfolioCashMovementResponse {
  /** Id */
  id: number;
  /** Register Id */
  register_id: number;
  /** Shareholder Id */
  shareholder_id?: number;
  /**
   * Confirmation Date
   * @format date-time
   */
  confirmation_date?: string;
  /**
   * Requested At Date
   * @format date-time
   */
  requested_at_date: string;
  /** Transaction Id */
  transaction_id?: number;
  direction: CashMovementType;
  status: PaymentStatus;
  /** Amount */
  amount: number;
  /** Memo */
  memo?: string;
  /** Dividend Event Id */
  dividend_event_id?: number;
  /** Correspondence Id */
  correspondence_id?: number;
  correspondence?: CorrespondenceSummary;
}

/** PortfolioExtended */
export interface PortfolioExtended {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Register Id */
  register_id: number;
  register_obj?: Register;
  /**
   * Portfolio Value
   * @default "0.00"
   */
  portfolio_value?: number;
  /**
   * Total Cash
   * @default "0.00"
   */
  total_cash?: number;
  /**
   * Total Asset Value
   * @default "0.00"
   */
  total_asset_value?: number;
  /**
   * Pnl Value
   * @default "0.00"
   */
  pnl_value?: number;
  /**
   * Pnl Ratio
   * @default "0.00"
   */
  pnl_ratio?: number;
  /**
   * Locked Balance
   * @default "0.00"
   */
  locked_balance?: number;
}

/** PortfolioModel */
export interface PortfolioModel {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Register Id */
  register_id: number;
  /**
   * Portfolio Classes
   * @default []
   */
  portfolio_classes?: RegisterClass[];
  /**
   * Portfolio Value
   * @default "0.00"
   */
  portfolio_value?: number;
  /**
   * Available Operational Balance
   * @default "0.00"
   */
  available_operational_balance?: number;
  /**
   * Total Asset Value
   * @default "0.00"
   */
  total_asset_value?: number;
  /**
   * Total Cash
   * @default "0.00"
   */
  total_cash?: number;
  /**
   * Pnl Value
   * @default "0.00"
   */
  pnl_value?: number;
  /**
   * Pnl Ratio
   * @default "0.00"
   */
  pnl_ratio?: number;
  /**
   * Locked Balance
   * @default "0.00"
   */
  locked_balance?: number;
}

/** PortfolioTransaction */
export interface PortfolioTransaction {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** Asset Id */
  asset_id?: number;
  transaction_type: PortfolioTransactionType;
  status: PortfolioTransactionStatus;
  /**
   * Confirmation Date
   * @format date-time
   */
  confirmation_date?: string;
  /** Price Per Share */
  price_per_share: number;
  /** Quantity */
  quantity: number;
  /** Correspondence Id */
  correspondence_id?: number;
  /** To Portfolio Bank Id */
  to_portfolio_bank_id?: number;
  /** From Portfolio Bank Id */
  from_portfolio_bank_id?: number;
  /** Ref Portfolio Transaction Id */
  ref_portfolio_transaction_id?: number;
  /** Memo */
  memo?: string;
  /** Fee */
  fee?: number;
  /** Amount */
  amount?: number;
  /** Portfolio Id */
  portfolio_id: number;
  /** Fx Rate */
  fx_rate?: number;
  /** Split Post Quantity */
  split_post_quantity?: number;
  from_currency?: CurrencyEnum;
  to_currency?: CurrencyEnum;
  /**
   * Is Conversion
   * @default false
   */
  is_conversion?: boolean;
  /**
   * Created With Ai
   * @default false
   */
  created_with_ai?: boolean;
}

/** PreDividendReportRequest */
export interface PreDividendReportRequest {
  /**
   * Register Class Id
   * @exclusiveMin 0
   */
  register_class_id: number;
  /** Name */
  name: string;
  /**
   * Date
   * @format date-time
   */
  date: string;
  /** Amount Per Share */
  amount_per_share: number;
  type: DividendType;
  /** Memo */
  memo: string;
  /** Bank Id */
  bank_id: number;
}

/** PreDividendReportResponse */
export interface PreDividendReportResponse {
  report: ReportResponse;
}

/** PreviewCommunicationGeneratedAttachmentsRequest */
export interface PreviewCommunicationGeneratedAttachmentsRequest {
  /** Subject */
  subject: string;
  /** Text */
  text: string;
  /** Shareholder Ids */
  shareholder_ids: number[];
  /** Report Ids */
  report_ids?: number[];
  /** Certificate Ids */
  certificate_ids?: number[];
  /**
   * Bulk Generate Attachments
   * @default false
   */
  bulk_generate_attachments?: boolean;
  bulk_report_config?: BulkCommunicationReportConfig;
  bulk_certificate_config?: BulkCommunicationCertificateConfig;
}

/** PreviewExistingBulkReportChildrenRequest */
export interface PreviewExistingBulkReportChildrenRequest {
  /**
   * Parent Report Id
   * @exclusiveMin 0
   */
  parent_report_id: number;
}

/** RegenerateBulkReportZipResponse */
export interface RegenerateBulkReportZipResponse {
  /** File Storage Item Url */
  file_storage_item_url: string;
}

/** RegisterBankExtended */
export interface RegisterBankExtended {
  /** Register Id */
  register_id: number;
  /** Bank Name */
  bank_name: string;
  /** Bank Account Name */
  bank_account_name: string;
  /** Bank Account Bsb */
  bank_account_bsb: string;
  /** Bank Account Number */
  bank_account_number: string;
  /** Bank Types */
  bank_types: BankTypeEnum[];
  bank_currency: CurrencyEnum;
  /** Bank Classes */
  bank_classes?: number[];
  /** Portfolio Id */
  portfolio_id?: number;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** Bank Classes Info */
  bank_classes_info?: RegisterClass[];
  /**
   * Total Available Cash
   * @default "0"
   */
  total_available_cash?: number;
  /**
   * Portion Of Portfolio Value
   * @default "0"
   */
  portion_of_portfolio_value?: number;
  /**
   * Percent Of Portfolio Value
   * @default "0"
   */
  percent_of_portfolio_value?: number;
}

/** RegisterByIdResponse */
export interface RegisterByIdResponse {
  /** Id */
  id: number;
  type: RegisterType;
  /** Name */
  name: string;
  /** Code */
  code: string;
  /**
   * Allows Fractional Shares
   * @default false
   */
  allows_fractional_shares?: boolean;
  /** Country Code */
  country_code?: string;
  /** Registered Office */
  registered_office?: string;
  /** Email */
  email: string;
  /** Phone */
  phone?: string;
  /** Website */
  website?: string;
  /** Abn */
  abn: string;
  /** Acn */
  ACN: string;
  /** Trustee */
  trustee: string;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** User Identification Number */
  user_identification_number?: number;
  /** Icon Url */
  icon_url?: string;
  /** Register Legal Name */
  register_legal_name?: string;
  rounding_type?: RoundingType;
  /**
   * Hold Carried Forward
   * @default false
   */
  hold_carried_forward?: boolean;
  /** Keycloak Organization Id */
  keycloak_organization_id?: string;
  /** Register Bank */
  register_bank?: RegisterBankExtended[];
  currency?: CurrencyEnum;
}

/** RegisterByPrivateIdResponse */
export interface RegisterByPrivateIdResponse {
  /** Id */
  id: number;
  type: RegisterType;
  /** Name */
  name: string;
}

/** RegisterClass */
export interface RegisterClass {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** Class Name */
  class_name: string;
  /** Register Id */
  register_id: number;
  /** Current Price Per Share */
  current_price_per_share: number;
  /** Min Investment */
  min_investment: number;
  /** Transfer Lock Period */
  transfer_lock_period?: number;
  /** Available Cash */
  available_cash?: number;
  /** Issued Shares */
  issued_shares?: number;
}

/** RegisterClassByIdResponse */
export interface RegisterClassByIdResponse {
  /** Id */
  id: number;
  /** Class Name */
  class_name: string;
  /** Register Id */
  register_id: number;
  /** Current Price Per Share */
  current_price_per_share: number;
  /** Min Investment */
  min_investment: number;
  /** Transfer Lock Period */
  transfer_lock_period?: number;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /**
   * Total Invested
   * @default 0
   */
  total_invested?: number;
  /**
   * Total Holders
   * @default 0
   */
  total_holders?: number;
  register_obj?: Register;
  /**
   * Total Units
   * @default "0"
   */
  total_units?: number;
}

/** RegisterClassChart */
export interface RegisterClassChart {
  /** Id */
  id: number;
  /** Class Name */
  class_name: string;
}

/** RegisterClassHistoryResponse */
export interface RegisterClassHistoryResponse {
  /** Register Class Id */
  register_class_id: number;
  /** Register Class Name */
  register_class_name: string;
  /** Histories */
  histories?: ShareholderHistoryDTO[];
}

/** RegisterClassResponse */
export interface RegisterClassResponse {
  /** Id */
  id: number;
  /** Class Name */
  class_name: string;
  /** Register Id */
  register_id: number;
  /** Current Price Per Share */
  current_price_per_share: number;
  /** Min Investment */
  min_investment: number;
  /** Transfer Lock Period */
  transfer_lock_period?: number;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
}

/** RegisterClassWithCalculateResponse */
export interface RegisterClassWithCalculateResponse {
  /** Id */
  id: number;
  /** Class Name */
  class_name: string;
  /** Register Id */
  register_id: number;
  /** Current Price Per Share */
  current_price_per_share: number;
  /** Min Investment */
  min_investment: number;
  /**
   * Number Of Units
   * @default "0"
   */
  number_of_units?: number;
  /**
   * Change
   * @default "0"
   */
  change?: number;
  /**
   * Change Value
   * @default "0"
   */
  change_value?: number;
}

/** RegisterClassWithNAVResponse */
export interface RegisterClassWithNAVResponse {
  /** Id */
  id: number;
  /** Class Name */
  class_name: string;
  /** Register Id */
  register_id: number;
  /** Current Price Per Share */
  current_price_per_share: number;
  /** Min Investment */
  min_investment: number;
  /** Transfer Lock Period */
  transfer_lock_period?: number;
  /** Navs */
  navs?: NAVHistoryResponse[];
}

/** RegisterParty */
export interface RegisterParty {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** Name */
  name: string;
}

/** RegisterResponse */
export interface RegisterResponse {
  /** Id */
  id: number;
  type: RegisterType;
  /** Name */
  name: string;
  /** Code */
  code: string;
  /**
   * Allows Fractional Shares
   * @default false
   */
  allows_fractional_shares?: boolean;
  /** Country Code */
  country_code?: string;
  /** Registered Office */
  registered_office?: string;
  /** Acn */
  ACN: string;
  /** Abn */
  abn: string;
  /** Email */
  email?: string;
  /** Phone */
  phone?: string;
  /** Website */
  website?: string;
  /** Trustee */
  trustee: string;
  /** Register Legal Name */
  register_legal_name?: string;
  /** User Identification Number */
  user_identification_number?: number;
  /** Icon Url */
  icon_url?: string;
  /** Correspondence Email */
  correspondence_email?: string;
  currency?: CurrencyEnum;
  /** Private Id */
  private_id?: string;
  /** Custodial Updates Email */
  custodial_updates_email?: string;
}

/** RegisterSettingsResponse */
export interface RegisterSettingsResponse {
  /** Id */
  id: number;
  rounding_type: RoundingType;
  /** Allows Fractional Shares */
  allows_fractional_shares: boolean;
  /** Hold Carried Forward */
  hold_carried_forward: boolean;
  /** Register Id */
  register_id: number;
  /**
   * Changes Date
   * @format date-time
   */
  changes_date: string;
}

/** RegisterSsoInvestorRequest */
export interface RegisterSsoInvestorRequest {
  /** Apply Register Private Id */
  apply_register_private_id: string;
}

/** RegisterSsoInvestorResponse */
export interface RegisterSsoInvestorResponse {
  /** Success */
  success: boolean;
}

/** RegisterTotalFundByYearHolderItem */
export interface RegisterTotalFundByYearHolderItem {
  /** Entity Id */
  entity_id: number;
  /** Display Name */
  display_name: string;
  /** First Name */
  first_name?: string;
  /** Last Name */
  last_name?: string;
  /** Avatar Url */
  avatar_url?: string;
  /** Email */
  email?: string;
}

/** RegisterTotalFundByYearListItem */
export interface RegisterTotalFundByYearListItem {
  /** Register Id */
  register_id: number;
  /** Register Name */
  register_name: string;
  /** Total Fund */
  total_fund: number;
}

/** RegisterTotalFundByYearResponse */
export interface RegisterTotalFundByYearResponse {
  /** Id */
  id: number;
  /** Register Id */
  register_id: number;
  /** Year */
  year: number;
  /** Total Fund */
  total_fund: number;
}

/** RegisterUserItem */
export interface RegisterUserItem {
  /** Id */
  id: number;
  /** Email */
  email?: string;
  /** First Name */
  first_name?: string;
  /** Last Name */
  last_name?: string;
}

/** RegisterWithInvestmentResponse */
export interface RegisterWithInvestmentResponse {
  /** Id */
  id: number;
  type: RegisterType;
  /** Name */
  name: string;
  /** Code */
  code: string;
  /** Register Classes Info */
  register_classes_info?: RegisterClassWithCalculateResponse[];
}

/** RegisterWithJoinResponse */
export interface RegisterWithJoinResponse {
  /** Id */
  id: number;
  /** Email */
  email?: string;
  type: RegisterType;
  /** Name */
  name: string;
  /** Code */
  code: string;
  /** Total Invested */
  total_invested?: number;
  /** Register Classes */
  register_classes: RegisterClassResponse[];
}

/** Report */
export interface Report {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** Register Id */
  register_id: number;
  /** Entity Id */
  entity_id?: number;
  /**
   * Generated At
   * @format date-time
   */
  generated_at?: string;
  status: ReportStatus;
  /** Filename */
  filename?: string;
  type: ReportType;
  format: ReportFormat;
  /**
   * Start Date
   * @format date
   */
  start_date?: string;
  /**
   * End Date
   * @format date
   */
  end_date?: string;
  /** File Storage Item Id */
  file_storage_item_id?: string;
  /** Report Id */
  report_id?: number;
  /** Created By */
  created_by?: number;
  /** Dividend Event Id */
  dividend_event_id?: number;
  /** Parent Report Id */
  parent_report_id?: number;
  /**
   * Is Bulk
   * @default false
   */
  is_bulk?: boolean;
}

/** ReportList */
export interface ReportList {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** Register Id */
  register_id: number;
  /** Entity Id */
  entity_id?: number;
  /**
   * Generated At
   * @format date-time
   */
  generated_at?: string;
  status: ReportStatus;
  /** Filename */
  filename?: string;
  type: ReportType;
  format: ReportFormat;
  /**
   * Start Date
   * @format date
   */
  start_date?: string;
  /**
   * End Date
   * @format date
   */
  end_date?: string;
  /** File Storage Item Id */
  file_storage_item_id?: string;
  /** Report Id */
  report_id?: number;
  /** Created By */
  created_by?: number;
  /** Dividend Event Id */
  dividend_event_id?: number;
  /** Parent Report Id */
  parent_report_id?: number;
  /**
   * Is Bulk
   * @default false
   */
  is_bulk?: boolean;
  /** File Storage Item Url */
  file_storage_item_url?: string;
  /** Document Storage Item Url */
  document_storage_item_url?: string;
  /** Classes */
  classes?: RegisterClass[];
}

/** ReportResponse */
export interface ReportResponse {
  /** Id */
  id: number;
  /** Register Id */
  register_id: number;
  /** Entity Id */
  entity_id?: number;
  /**
   * Generated At
   * @format date-time
   */
  generated_at?: string;
  status: ReportStatus;
  /** Filename */
  filename?: string;
  type: ReportType;
  format: ReportFormat;
  /**
   * Start Date
   * @format date
   */
  start_date?: string;
  /**
   * End Date
   * @format date
   */
  end_date?: string;
  /** File Storage Item Url */
  file_storage_item_url?: string;
  /** Parent Report Id */
  parent_report_id?: number;
  /**
   * Is Bulk
   * @default false
   */
  is_bulk?: boolean;
}

/** ReportWithUrl */
export interface ReportWithUrl {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** Register Id */
  register_id: number;
  /** Entity Id */
  entity_id?: number;
  /**
   * Generated At
   * @format date-time
   */
  generated_at?: string;
  status: ReportStatus;
  /** Filename */
  filename?: string;
  type: ReportType;
  format: ReportFormat;
  /**
   * Start Date
   * @format date
   */
  start_date?: string;
  /**
   * End Date
   * @format date
   */
  end_date?: string;
  /** File Storage Item Url */
  file_storage_item_url?: string;
  /** Created By */
  created_by?: number;
  /** Parent Report Id */
  parent_report_id?: number;
  /**
   * Is Bulk
   * @default false
   */
  is_bulk?: boolean;
}

/** ReportWithUrlResponse */
export interface ReportWithUrlResponse {
  /** Id */
  id: number;
  /** Register Id */
  register_id: number;
  /** Entity Id */
  entity_id?: number;
  /**
   * Generated At
   * @format date-time
   */
  generated_at?: string;
  status: ReportStatus;
  /** Filename */
  filename?: string;
  type: ReportType;
  format: ReportFormat;
  /**
   * Start Date
   * @format date
   */
  start_date?: string;
  /**
   * End Date
   * @format date
   */
  end_date?: string;
  /** File Storage Item Url */
  file_storage_item_url?: string;
  /** Created By */
  created_by?: number;
  /** Parent Report Id */
  parent_report_id?: number;
  /**
   * Is Bulk
   * @default false
   */
  is_bulk?: boolean;
  /** Classes */
  classes: RegisterClass[];
}

/** RequestedAction */
export interface RequestedAction {
  /** Id */
  id?: string;
  /** Type */
  type?: string;
  /** Role */
  role?: string;
  /** Extract Type */
  extract_type?: string;
  fields?: Fields;
}

/** ResetUserTotpResponse */
export interface ResetUserTotpResponse {
  /** Success */
  success: boolean;
}

/** SMSFEntityDetails */
export interface SMSFEntityDetails {
  /** Country */
  country?: string;
  /** Name */
  name?: string;
  /** Abn */
  abn?: string;
  /** Registeredoffice */
  registeredOffice?: string;
  /** Uploadtrustdeed */
  uploadTrustDeed?: string;
  /**
   * Type Literal
   * @default "smsf"
   */
  type_literal?: "smsf";
  /** Trustee */
  trustee: (
    | ({
        type_literal: "company";
      } & CompanyEntityDetails)
    | ({
        type_literal: "individual";
      } & IndividualEntityDetails)
  )[];
  /** Settlors */
  settlors: (
    | ({
        type_literal: "company";
      } & CompanyEntityDetails)
    | ({
        type_literal: "individual";
      } & IndividualEntityDetails)
  )[];
  /** Beneficiaries */
  beneficiaries: (
    | ({
        type_literal: "company";
      } & CompanyEntityDetails)
    | ({
        type_literal: "individual";
      } & IndividualEntityDetails)
  )[];
  /** Business Name Trustee */
  business_name_trustee?: string;
}

/** SendExistingBulkReportChildrenCommunicationRequest */
export interface SendExistingBulkReportChildrenCommunicationRequest {
  /**
   * Parent Report Id
   * @exclusiveMin 0
   */
  parent_report_id: number;
}

/** SendExistingBulkReportChildrenCommunicationResponse */
export interface SendExistingBulkReportChildrenCommunicationResponse {
  /** Recipients Count */
  recipients_count: number;
  /** Sent Emails Count */
  sent_emails_count: number;
  /** Skipped Count */
  skipped_count: number;
}

/** ShareCertificateDataResponse */
export interface ShareCertificateDataResponse {
  /** Entity */
  entity?: string;
  /** Register Name */
  register_name: string;
  /** Register Class */
  register_class: string;
  /** Price Per Share */
  price_per_share?: number;
  /** Quantity Of Shares */
  quantity_of_shares?: number;
  /**
   * Generated Date
   * @format date
   */
  generated_date?: string;
  /** Registered Office */
  registered_office?: string;
  /** Country Code */
  country_code?: string;
  status: ShareCertificateStatus;
  /** Url */
  url: string;
}

/** ShareCertificateResponse */
export interface ShareCertificateResponse {
  /** Id */
  id: number;
  /** Shareholder Id */
  shareholder_id: number;
  register_class?: RegisterClass;
  register_data: Register;
  entity?: ShareholderEntity;
  /** Price Per Share */
  price_per_share: number;
  /** Quantity Of Shares */
  quantity_of_shares: number;
  /** Verification Code */
  verification_code: string;
  /** Document Storage Item Id */
  document_storage_item_id: string;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /** File Storage Item Url */
  file_storage_item_url?: string;
  status: ShareCertificateStatus;
  /**
   * Is Archived
   * @default false
   */
  is_archived?: boolean;
  /**
   * Archived At
   * @format date-time
   */
  archived_at?: string;
}

/** ShareOfIncomeSchema */
export interface ShareOfIncomeSchema {
  /** Primary Production */
  primary_production: string;
  /** Pp Ncmi */
  pp_ncmi: string;
  /** Pp Excluded Ncmi */
  pp_excluded_ncmi: string;
  /** Non Primary Production */
  non_primary_production: string;
  /** Npp Ncmi */
  npp_ncmi: string;
  /** Npp Excluded Ncmi */
  npp_excluded_ncmi: string;
  /** Primary Production Allocation Method */
  primary_production_allocation_method: "manual" | "auto";
  /** Primary Production Total Fund */
  primary_production_total_fund: string;
  /** Primary Production Total Value */
  primary_production_total_value: string;
  /** Pp Ncmi Allocation Method */
  pp_ncmi_allocation_method: "manual" | "auto";
  /** Pp Ncmi Total Fund */
  pp_ncmi_total_fund: string;
  /** Pp Ncmi Total Value */
  pp_ncmi_total_value: string;
  /** Pp Excluded Ncmi Allocation Method */
  pp_excluded_ncmi_allocation_method: "manual" | "auto";
  /** Pp Excluded Ncmi Total Fund */
  pp_excluded_ncmi_total_fund: string;
  /** Pp Excluded Ncmi Total Value */
  pp_excluded_ncmi_total_value: string;
  /** Non Primary Production Allocation Method */
  non_primary_production_allocation_method: "manual" | "auto";
  /** Non Primary Production Total Fund */
  non_primary_production_total_fund: string;
  /** Non Primary Production Total Value */
  non_primary_production_total_value: string;
  /** Npp Ncmi Allocation Method */
  npp_ncmi_allocation_method: "manual" | "auto";
  /** Npp Ncmi Total Fund */
  npp_ncmi_total_fund: string;
  /** Npp Ncmi Total Value */
  npp_ncmi_total_value: string;
  /** Npp Excluded Ncmi Allocation Method */
  npp_excluded_ncmi_allocation_method: "manual" | "auto";
  /** Npp Excluded Ncmi Total Fund */
  npp_excluded_ncmi_total_fund: string;
  /** Npp Excluded Ncmi Total Value */
  npp_excluded_ncmi_total_value: string;
  [key: string]: any;
}

/** Shareholder */
export interface Shareholder {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** Register Id */
  register_id: number;
  /** Entity Id */
  entity_id: number;
  /** Email */
  email?: string;
  /** Phone Number */
  phone_number?: string;
  /** Address */
  address?: string;
  /** Additional Emails */
  additional_emails?: string[];
  /** Notifications Enabled */
  notifications_enabled?: boolean;
  preferred_contact_way?: EntityPreferredContactWay;
  /** Additional Address */
  additional_address?: string;
  /** Suburb */
  suburb?: string;
  /** State */
  state?: string;
  /** Postcode */
  postcode?: string;
  /** Country */
  country?: string;
  /** Dividend Reinvestment */
  dividend_reinvestment?: Record<string, boolean>;
}

/** ShareholderBalance */
export interface ShareholderBalance {
  /** Shareholder Id */
  shareholder_id?: number;
  /** Entity Id */
  entity_id?: number;
  /** Entity Name */
  entity_name: string;
  /** Balance */
  balance: number;
  /** Percentage */
  percentage: number;
  /** Units */
  units?: number;
  /** Entity Str Id */
  entity_str_id?: string;
  /**
   * Joined
   * @format date-time
   */
  joined?: string;
  entity_status?: EntityStatus;
}

/** ShareholderEmailSetting */
export interface ShareholderEmailSetting {
  /**
   * Shareholder Id
   * @exclusiveMin 0
   */
  shareholder_id: number;
  /**
   * Send Email
   * @default true
   */
  send_email?: boolean;
}

/** ShareholderEntity */
export interface ShareholderEntity {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** User Id */
  user_id: number;
  /** Entity Id */
  entity_id: string;
  /** Entity Application Rejection Reason */
  entity_application_rejection_reason?: string;
  /** Bank Account Name */
  bank_account_name?: string;
  /** Bank Account Bsb */
  bank_account_bsb?: string;
  /** Bank Account Number */
  bank_account_number?: string;
  /** Bank Name */
  bank_name?: string;
  /** Email */
  email?: string;
  /** Suburb */
  suburb?: string;
  /** Postcode */
  postcode?: string;
  /** Phone Number */
  phone_number?: string;
  /** Address */
  address?: string;
  /** Entity Name */
  entity_name?: string;
  /** Apply Register Id */
  apply_register_id?: number;
  /** Additional Emails */
  additional_emails?: string[] | string;
  /** Individual Entity Details */
  individual_entity_details?: object;
  /** Company Entity Details */
  company_entity_details?: object;
  /** Trust Entity Details */
  trust_entity_details?: object;
  /** Partnership Entity Details */
  partnership_entity_details?: object;
  /** Association Entity Details Id */
  association_entity_details_id?: object;
  type?: EntityType;
  payment_info_status?: EntitiesPaymentInfoStatus;
  /**
   * Payment Info Updated At
   * @format date-time
   */
  payment_info_updated_at?: string;
  /**
   * Payment Info Requested At
   * @format date-time
   */
  payment_info_requested_at?: string;
  /** Smsf Entity Details */
  smsf_entity_details?: object;
  registration_type: EntitiesRegistrationType;
}

/** ShareholderEntityResponse */
export interface ShareholderEntityResponse {
  /** User Id */
  user_id: number;
  /** Entity Id */
  entity_id: string;
  status?: EntityStatus;
  /** Entity Application Rejection Reason */
  entity_application_rejection_reason?: string;
  /** Bank Account Name */
  bank_account_name?: string;
  /** Bank Account Bsb */
  bank_account_bsb?: string;
  /** Bank Account Number */
  bank_account_number?: string;
  /** Bank Name */
  bank_name?: string;
  /** Email */
  email?: string;
  /** Phone Number */
  phone_number?: string;
  /** Address */
  address?: string;
  /** Entity Name */
  entity_name?: string;
  /** Apply Register Id */
  apply_register_id: number;
  /** Additional Emails */
  additional_emails?: string[] | string;
  /** Individual Entity Details */
  individual_entity_details?: object;
  /** Company Entity Details */
  company_entity_details?: object;
  /** Trust Entity Details */
  trust_entity_details?: object;
  /** Partnership Entity Details */
  partnership_entity_details?: object;
  /** Association Entity Details Id */
  association_entity_details_id?: object;
  type?: EntityType;
  payment_info_status?: EntitiesPaymentInfoStatus;
  /**
   * Payment Info Updated At
   * @format date-time
   */
  payment_info_updated_at?: string;
  /**
   * Payment Info Requested At
   * @format date-time
   */
  payment_info_requested_at?: string;
  registration_type: EntitiesRegistrationType;
}

/** ShareholderExtend */
export interface ShareholderExtend {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** Register Id */
  register_id: number;
  /** Entity Id */
  entity_id: number;
  /** Email */
  email?: string;
  /** Phone Number */
  phone_number?: string;
  /** Address */
  address?: string;
  /** Additional Emails */
  additional_emails?: string[];
  /** Notifications Enabled */
  notifications_enabled?: boolean;
  preferred_contact_way?: EntityPreferredContactWay;
  /** Additional Address */
  additional_address?: string;
  /** Suburb */
  suburb?: string;
  /** State */
  state?: string;
  /** Postcode */
  postcode?: string;
  /** Country */
  country?: string;
  /** Total Amount */
  total_amount?: number;
  /** Total Quantity */
  total_quantity?: number;
  register_obj: Register;
  entity: ShareholderEntity;
  /** Dividend Reinvestment */
  dividend_reinvestment?: Record<string, boolean>;
}

/** ShareholderExtendResponse */
export interface ShareholderExtendResponse {
  /** Id */
  id: number;
  /** Register Id */
  register_id: number;
  /** Entity Id */
  entity_id: number;
  /** Total Amount */
  total_amount: number;
  /** Total Quantity */
  total_quantity: number;
  register_obj: RegisterResponse;
  entity: ShareholderEntityResponse;
  user?: UserResponse;
  /** Email */
  email?: string;
  /** Phone Number */
  phone_number?: string;
  /** Address */
  address?: string;
  /** Additional Emails */
  additional_emails?: string[];
  /** Notifications Enabled */
  notifications_enabled?: boolean;
  /** Additional Address */
  additional_address?: string;
  /** Suburb */
  suburb?: string;
  /** State */
  state?: string;
  /** Postcode */
  postcode?: string;
  country?: CountryCodeEnum;
  preferred_contact_way?: EntityPreferredContactWay;
  /** Registration Address */
  registration_address?: string;
  entity_details?: EntityDetails;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /** Dividend Reinvestment Extended */
  dividend_reinvestment_extended?: DividendReinvestmentExtended[];
}

/** ShareholderExtendWithSubscriptionClasses */
export interface ShareholderExtendWithSubscriptionClasses {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** Register Id */
  register_id: number;
  /** Entity Id */
  entity_id: number;
  /** Email */
  email?: string;
  /** Phone Number */
  phone_number?: string;
  /** Address */
  address?: string;
  /** Additional Emails */
  additional_emails?: string[];
  /** Notifications Enabled */
  notifications_enabled?: boolean;
  preferred_contact_way?: EntityPreferredContactWay;
  /** Additional Address */
  additional_address?: string;
  /** Suburb */
  suburb?: string;
  /** State */
  state?: string;
  /** Postcode */
  postcode?: string;
  /** Country */
  country?: string;
  /** Total Amount */
  total_amount?: number;
  /** Total Quantity */
  total_quantity?: number;
  register_obj: Register;
  entity: ShareholderEntity;
  /** Dividend Reinvestment */
  dividend_reinvestment?: Record<string, boolean>;
  /** Classes */
  classes: RegisterClass[];
}

/** ShareholderHistoryDTO */
export interface ShareholderHistoryDTO {
  /**
   * Calculate Date
   * @format date
   */
  calculate_date: string;
  /** Amount */
  amount: number;
}

/** ShareholderResponse */
export interface ShareholderResponse {
  /** Id */
  id: number;
  /** Register Id */
  register_id: number;
  /** Entity Id */
  entity_id: number;
  /** Email */
  email?: string;
  /** Phone Number */
  phone_number?: string;
  /** Address */
  address?: string;
  /** Additional Emails */
  additional_emails?: string[];
  /** Notifications Enabled */
  notifications_enabled?: boolean;
  /** Additional Address */
  additional_address?: string;
  /** Suburb */
  suburb?: string;
  /** State */
  state?: string;
  /** Postcode */
  postcode?: string;
  country?: CountryCodeEnum;
  preferred_contact_way?: EntityPreferredContactWay;
}

/** ShareholderShortInfo */
export interface ShareholderShortInfo {
  /** Entity Name */
  entity_name: string;
  type?: EntityType;
}

/** ShareholderUser */
export interface ShareholderUser {
  /** Id */
  id: number;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /** Avatar Storage Item Id */
  avatar_storage_item_id?: string;
  /** Avatar Url */
  avatar_url?: string;
}

/** ShareholderUserResponse */
export interface ShareholderUserResponse {
  /** Id */
  id: number;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /** Avatar Storage Item Id */
  avatar_storage_item_id?: string;
  /** Avatar Url */
  avatar_url?: string;
}

/** SignUpUserRequest */
export interface SignUpUserRequest {
  /**
   * The first name of the user
   * @minLength 3
   * @maxLength 255
   */
  first_name: string;
  /**
   * The last name of the user
   * @minLength 3
   * @maxLength 255
   */
  last_name: string;
  /**
   * The email of the user
   * @format email
   */
  email: string;
  /**
   * The password of the user
   * @format password
   * @minLength 1
   * @maxLength 300
   */
  password: string;
  /**
   * The keycloak user id
   * @minLength 1
   * @maxLength 20
   */
  keycloak_user_id?: string;
  /** Redirect url */
  redirect_url?: string;
}

/** SignUpUserResponse */
export interface SignUpUserResponse {
  user: UserResponse;
  /** Session */
  session: string;
}

/** SmallBusinessIncomeTaxOffsetSchema */
export interface SmallBusinessIncomeTaxOffsetSchema {
  /** Share Net Small Business Income */
  share_net_small_business_income: string;
  /** Share Net Small Business Income Allocation Method */
  share_net_small_business_income_allocation_method: "manual" | "auto";
  /** Share Net Small Business Income Total Fund */
  share_net_small_business_income_total_fund: string;
  /** Share Net Small Business Income Total Value */
  share_net_small_business_income_total_value: string;
  [key: string]: any;
}

/** SummaryPendingApplicationSection */
export interface SummaryPendingApplicationSection {
  /** Quantity */
  quantity: number;
  /** Value */
  value: number;
  /** Status */
  status: string;
  /**
   * Percentage
   * @default "0"
   */
  percentage?: number;
}

/** TaxDetails */
export interface TaxDetails {
  /** Account Holders Gin */
  account_holders_gin?: string;
  /** Sponsoring Entity Name */
  sponsoring_entity_name?: string;
  /** Country Of Tax Residence */
  country_of_tax_residence?: string;
  /**
   * Is Us Person
   * @default false
   */
  is_us_person?: boolean;
  /** Non Us Person Certification */
  non_us_person_certification?: string;
  /**
   * Is Managed By Another Institution
   * @default false
   */
  is_managed_by_another_institution?: boolean;
  /**
   * Crs Status
   * @default "Not implemented yet"
   */
  crs_status?: string;
}

/** TaxReportByYearDataSchema */
export interface TaxReportByYearDataSchema {
  capital_gains: CapitalGainsSchema;
  credits: CreditsSchema;
  /** Div6Aa Eligible Income */
  div6aa_eligible_income: string;
  /** Share Of Income Trust Estate */
  share_of_income_trust_estate: string;
  /** Assessment Calculation Code */
  assessment_calculation_code: string;
  foreign_income: ForeignIncomeSchema;
  offsets: OffsetsSchema;
  share_of_income: ShareOfIncomeSchema;
  small_business_income_tax_offset: SmallBusinessIncomeTaxOffsetSchema;
  other_non_assessable_amounts: OtherNonAssessableAmountsSchema;
  other_deductions: OtherDeductionsSchema;
  /** Div6Aa Eligible Income Allocation Method */
  div6aa_eligible_income_allocation_method: "manual" | "auto";
  /** Div6Aa Eligible Income Total Fund */
  div6aa_eligible_income_total_fund: string;
  /** Div6Aa Eligible Income Total Value */
  div6aa_eligible_income_total_value: string;
  /** Share Of Income Trust Estate Allocation Method */
  share_of_income_trust_estate_allocation_method: "manual" | "auto";
  /** Share Of Income Trust Estate Total Fund */
  share_of_income_trust_estate_total_fund: string;
  /** Share Of Income Trust Estate Total Value */
  share_of_income_trust_estate_total_value: string;
  /** Assessment Calculation Code Allocation Method */
  assessment_calculation_code_allocation_method: "manual" | "auto";
  /** Assessment Calculation Code Total Fund */
  assessment_calculation_code_total_fund: string;
  /** Assessment Calculation Code Total Value */
  assessment_calculation_code_total_value: string;
  [key: string]: any;
}

/** TaxResidence */
export interface TaxResidence {
  /** Country */
  country?: string;
  /** Is Tin */
  is_tin?: boolean;
  /** Tfn Or Exemption Code */
  tfn_or_exemption_code?: string;
  /** Reason If No Tin */
  reason_if_no_tin?: string;
  /** Tin */
  tin?: string;
}

/** TopHoldersChart */
export interface TopHoldersChart {
  /** Total */
  total: number;
  /** Data */
  data: ShareholderBalance[];
}

/** TotalBalanceByDateResponse */
export interface TotalBalanceByDateResponse {
  /** Amount */
  amount: number;
  /**
   * Calculate Date
   * @format date
   */
  calculate_date?: string;
}

/** TotalPercentageData */
export interface TotalPercentageData {
  /** Total */
  total: number;
  /** Percentage */
  percentage: number;
}

/** Transaction */
export interface Transaction {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** Register Id */
  register_id: number;
  /** Register Class Id */
  register_class_id: number;
  /** Shareholder Id */
  shareholder_id: number;
  /**
   * Issue Date
   * @format date-time
   */
  issue_date?: string;
  type: TransactionType;
  status: TransactionStatus;
  /** Quantity */
  quantity: number;
  /** Price Per Share */
  price_per_share: number;
  /** Memo */
  memo?: string;
  /** Dividend Reinvestment */
  dividend_reinvestment?: boolean;
  /** Dividend Event Id */
  dividend_event_id?: number;
  /** Buy Back Event Id */
  buy_back_event_id?: number;
  /** Reject Reason */
  reject_reason?: string;
  /** Total */
  total?: number;
  /** Timezone Offset */
  timezone_offset?: string;
  /** Documents */
  documents?: OperationDocument[];
}

/** TransactionPaginateResponse */
export interface TransactionPaginateResponse {
  /** Id */
  id: number;
  /** Register Id */
  register_id?: number;
  /** Payment Id */
  payment_id?: number;
  /**
   * Issue Date
   * @format date-time
   */
  issue_date?: string;
  /**
   * Requested At Date
   * @format date-time
   */
  requested_at_date?: string;
  /** Register Class Id */
  register_class_id?: number;
  /** Shareholder Id */
  shareholder_id?: number;
  /** Entity Id */
  entity_id?: number;
  type?: TransactionType;
  status?: TransactionStatus;
  /** Quantity */
  quantity?: number;
  /** Amount */
  amount: number;
  /** Price Per Share */
  price_per_share?: number;
  /** Memo */
  memo?: string;
  /** Dividend Reinvestment */
  dividend_reinvestment?: boolean;
  /** Dividend Event Id */
  dividend_event_id?: number;
  register_class?: RegisterClassResponse;
  shareholder_user?: ShareholderUserResponse;
  shareholder_entity?: Entity;
  /** Total */
  total?: number;
}

/** TransactionResponse */
export interface TransactionResponse {
  /** Id */
  id: number;
  /** Register Id */
  register_id: number;
  /** Register Class Id */
  register_class_id: number;
  /** Shareholder Id */
  shareholder_id: number;
  type: TransactionType;
  /**
   * Issue Date
   * @format date-time
   */
  issue_date?: string;
  /** Buy Back Event Id */
  buy_back_event_id?: number;
  status: TransactionStatus;
  /** Quantity */
  quantity: number;
  /** Price Per Share */
  price_per_share: number;
  /** Memo */
  memo?: string;
  /** Dividend Reinvestment */
  dividend_reinvestment?: boolean;
  /** Dividend Event Id */
  dividend_event_id?: number;
  /** Reject Reason */
  reject_reason?: string;
}

/** TransactionSetAwaitPaymentStatusRequest */
export interface TransactionSetAwaitPaymentStatusRequest {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
  /**
   * Register Class Id
   * @exclusiveMin 0
   */
  register_class_id?: number;
  /**
   * Quantity
   * @exclusiveMin 0
   */
  quantity?: number;
  /**
   * Price Per Share
   * @min 0
   */
  price_per_share?: number;
  /** Memo */
  memo?: string;
  /**
   * Issue Date
   * @format date-time
   * @default "2026-06-30T15:23:56.245011"
   */
  issue_date?: string;
  /**
   * Bank Id
   * @exclusiveMin 0
   */
  bank_id?: number;
  round_to?: RoundTo;
  /**
   * Do Not Notify Investor
   * @default false
   */
  do_not_notify_investor?: boolean;
}

/** TransactionSetAwaitPaymentStatusResponse */
export interface TransactionSetAwaitPaymentStatusResponse {
  transaction: TransactionResponse;
}

/** TransactionSetCompletedStatusRequest */
export interface TransactionSetCompletedStatusRequest {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
  /**
   * Do Not Notify Investor
   * @default false
   */
  do_not_notify_investor?: boolean;
}

/** TransactionSetCompletedStatusResponse */
export interface TransactionSetCompletedStatusResponse {
  transaction: TransactionResponse;
}

/** TransactionSetRejectStatusRequest */
export interface TransactionSetRejectStatusRequest {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
  /** Reject Reason */
  reject_reason: string;
}

/** TransactionSetRejectStatusResponse */
export interface TransactionSetRejectStatusResponse {
  transaction: TransactionResponse;
}

/** TransactionWithStorageItemUrl */
export interface TransactionWithStorageItemUrl {
  /** Id */
  id: number;
  /** Register Id */
  register_id: number;
  /** Register Class Id */
  register_class_id: number;
  register_class: RegisterClass;
  /** Shareholder Id */
  shareholder_id: number;
  /**
   * Issue Date
   * @format date-time
   */
  issue_date?: string;
  type: TransactionType;
  status: TransactionStatus;
  /** Quantity */
  quantity: number;
  /** Price Per Share */
  price_per_share: number;
  /** Memo */
  memo?: string;
  /** Dividend Reinvestment */
  dividend_reinvestment?: boolean;
  /** Dividend Event Id */
  dividend_event_id?: number;
  /** Buy Back Event Id */
  buy_back_event_id?: number;
  /** Reject Reason */
  reject_reason?: string;
  /** Total */
  total?: number;
  /** Document Storage Item Urls */
  document_storage_item_urls?: OperationDocumentResponse[];
  shareholder_entity?: Entity;
  /**
   * Requested At Date
   * @format date-time
   */
  requested_at_date: string;
  /** Payment Id */
  payment_id?: number;
  /** Amount */
  amount?: number;
  /** Payment Memo */
  payment_memo?: string;
}

/** TransferPaginateResponse */
export interface TransferPaginateResponse {
  /** Id */
  id: number;
  /** Register Id */
  register_id: number;
  /** From Shareholder Id */
  from_shareholder_id: number;
  /** To Shareholder Id */
  to_shareholder_id: number;
  /** Register Class Id */
  register_class_id: number;
  /**
   * Confirmation Date
   * @format date-time
   */
  confirmation_date?: string;
  /**
   * Requested At Date
   * @format date-time
   */
  requested_at_date?: string;
  status: TransactionStatus;
  /** Quantity */
  quantity: number;
  /** Price Per Share */
  price_per_share: number;
  /** Memo */
  memo: string;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  register_obj: RegisterResponse;
  register_class: RegisterClassResponse;
  from_shareholder_user?: UserResponse;
  to_shareholder_user?: UserResponse;
  from_shareholder_entity?: Entity;
  to_shareholder_entity?: Entity;
  /** Document Storage Item Urls */
  document_storage_item_urls?: OperationDocumentResponse[];
}

/** TransferResponse */
export interface TransferResponse {
  /** Id */
  id: number;
  /** Register Id */
  register_id: number;
  /** From Shareholder Id */
  from_shareholder_id: number;
  /** To Shareholder Id */
  to_shareholder_id: number;
  /** Register Class Id */
  register_class_id: number;
  /**
   * Confirmation Date
   * @format date-time
   */
  confirmation_date?: string;
  /**
   * Requested At Date
   * @format date-time
   */
  requested_at_date?: string;
  status: TransactionStatus;
  /** Quantity */
  quantity: number;
  /** Price Per Share */
  price_per_share: number;
  /** Memo */
  memo: string;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
}

/** TransferSetCompletedStatusRequest */
export interface TransferSetCompletedStatusRequest {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
  /**
   * Confirmation Date
   * @format date-time
   */
  confirmation_date?: string;
}

/** TransferSetCompletedStatusResponse */
export interface TransferSetCompletedStatusResponse {
  transfer: TransferResponse;
}

/** TransferSetRejectedStatusRequest */
export interface TransferSetRejectedStatusRequest {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
  /** Reject Reason */
  reject_reason: string;
}

/** TransferSetRejectedStatusResponse */
export interface TransferSetRejectedStatusResponse {
  transfer: TransferResponse;
}

/** TreemapChartData */
export interface TreemapChartData {
  /** Asset Id */
  asset_id?: number;
  /** Broker Id */
  broker_id?: number;
  /** Name */
  name: string;
  currency: CurrencyEnum;
  /** Pnl */
  pnl: number;
  /** Pnl Ratio */
  pnl_ratio: number;
  /** Quantity */
  quantity: number;
  /** Value */
  value: number;
}

/** TrustEntityDetails */
export interface TrustEntityDetails {
  /** Country */
  country?: string;
  /** Is Regulated */
  is_regulated?: boolean;
  /** Abn */
  abn?: string;
  /** Type */
  type?: string;
  /** Business Name Trustee */
  business_name_trustee?: string;
  adviser?: AdviserDetails;
  /** Trustee */
  trustee: (
    | ({
        type_literal: "company";
      } & CompanyEntityDetails)
    | ({
        type_literal: "individual";
      } & IndividualEntityDetails)
  )[];
  /** Settlors */
  settlors: (
    | ({
        type_literal: "company";
      } & CompanyEntityDetails)
    | ({
        type_literal: "individual";
      } & IndividualEntityDetails)
  )[];
  /** Beneficiaries */
  beneficiaries: (
    | ({
        type_literal: "company";
      } & CompanyEntityDetails)
    | ({
        type_literal: "individual";
      } & IndividualEntityDetails)
  )[];
  /** Registered Office */
  registered_office?: string;
  /** Company Name */
  company_name?: string;
  /** Is Advisor */
  is_advisor?: boolean;
  /** Is Wholesale */
  is_wholesale?: boolean;
  /**
   * Type Literal
   * @default "trust"
   */
  type_literal?: "trust";
}

/** UpdateAssetPricesResponse */
export interface UpdateAssetPricesResponse {
  /** Updated */
  updated: number;
  /** Skipped */
  skipped: number;
  /** Failed */
  failed: number;
}

/** UpdateAssetRequest */
export interface UpdateAssetRequest {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
  /** Name */
  name?: string;
  /** Risks */
  risks?: string;
  asset_type?: AssetType;
  /** Broker Id */
  broker_id?: number;
  /** Price Per Share */
  price_per_share?: number;
  currency?: CurrencyEnum;
  industry?: GicsIndustry;
}

/** UpdateBrokerRequest */
export interface UpdateBrokerRequest {
  /** Broker Id */
  broker_id: number;
  /** Portfolio Id */
  portfolio_id: number;
  /**
   * Broker name
   * @maxLength 250
   */
  name: string;
}

/** UpdateBrokerResponse */
export interface UpdateBrokerResponse {
  data: Broker;
}

/** UpdateDividendEventRequest */
export interface UpdateDividendEventRequest {
  /** Id */
  id: number;
  /**
   * Is Create Report
   * @default true
   */
  is_create_report?: boolean;
  /** Shareholder Email Settings */
  shareholder_email_settings?: ShareholderEmailSetting[];
}

/** UpdateDividendEventResponse */
export interface UpdateDividendEventResponse {
  divided_event: DividendEventResponse;
}

/** UpdateDocumentRequest */
export interface UpdateDocumentRequest {
  /** Transaction Id */
  transaction_id?: number;
  /** Transfer Id */
  transfer_id?: number;
  /** Upload Document */
  upload_document?: string[];
  /** Delete Document Ids */
  delete_document_ids?: string[];
}

/** UpdateDocumentResponse */
export interface UpdateDocumentResponse {
  /** Success */
  success: boolean;
}

/** UpdateEntityPaymentAndContactDetailsRequest */
export interface UpdateEntityPaymentAndContactDetailsRequest {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
  /**
   * The entity bank account name
   * @maxLength 50
   */
  bank_account_name?: string;
  /**
   * The entity bank account bsb
   * @maxLength 50
   */
  bank_account_bsb?: string;
  /**
   * The entity bank account number
   * @maxLength 50
   */
  bank_account_number?: string;
  /**
   * The entity bank name
   * @maxLength 50
   */
  bank_name?: string;
  /**
   * The entity address
   * @maxLength 100
   */
  address?: string;
  /** The entity email */
  email?: string;
  /**
   * Entity additional emails
   * @maxItems 5
   */
  additional_emails?: string[];
  /**
   * The entity phone number
   * @maxLength 20
   */
  phone_number?: string;
  dividend_reinvestment_by_holder?: DividendReinvestmentShareholder;
}

/** UpdateEntityPaymentAndContactDetailsResponse */
export interface UpdateEntityPaymentAndContactDetailsResponse {
  entity: EntityResponse;
}

/** UpdateEntityRequest */
export interface UpdateEntityRequest {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
  /** The entity type */
  type: EntityType;
  /** The entity bank account name */
  bank_account_name?: string;
  /** The entity bank account bsb */
  bank_account_bsb?: string;
  /** The entity account number */
  bank_account_number?: string;
  /** The bank name */
  bank_name?: string;
  /** The entity email */
  email?: string;
  /** Entity additional emails */
  additional_emails?: string[];
  /** The entity phone number */
  phone_number?: string;
  /** The entity address */
  address?: string;
  /** The entity preferred contact way */
  preferred_contact_way?: EntityPreferredContactWay;
  /** Entity name */
  entity_name?: string;
  /** Document data in base64 string */
  documents?: EntityDocumentItem[];
  /** The Individual entity details */
  individual_entity_details: object;
  /** The Company entity details */
  company_entity_details?: object;
  /** The Trust entity details */
  trust_entity_details?: object;
  /** The Partnership entity details */
  partnership_entity_details?: object;
  /** The Association entity details */
  association_entity_details_id?: object;
  /** The SMSF entity details */
  smsf_entity_details?: object;
  /**
   * Send investment information about other investments
   * @default true
   */
  send_information_about_other_investments?: boolean;
  /**
   * Entity additional address
   * @maxLength 255
   */
  additional_address?: string;
  /**
   * Entity suburb
   * @maxLength 50
   */
  suburb?: string;
  /**
   * Entity state
   * @maxLength 20
   */
  state?: string;
  /**
   * Entity postcode
   * @maxLength 20
   */
  postcode?: string;
  /** Entity country */
  country?: CountryCodeEnum;
  /**
   * Notifications Enabled
   * @default false
   */
  notifications_enabled?: boolean;
  /** Entity Id */
  entity_id: string;
}

/** UpdateEntityResponse */
export interface UpdateEntityResponse {
  entity: EntityResponse;
}

/** UpdateEntityStatusRequest */
export interface UpdateEntityStatusRequest {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
  status: EntityStatus;
  /** Entity Application Rejection Reason */
  entity_application_rejection_reason: string;
}

/** UpdateEntityStatusResponse */
export interface UpdateEntityStatusResponse {
  entity: EntityResponse;
}

/** UpdateHolderDetailsRequest */
export interface UpdateHolderDetailsRequest {
  user_data?: UserDetailsData;
  id?: number;
  entity_data: CreateEntityRequest | UpdateEntityRequest;
  dividend_reinvestment?: Record<string, boolean>;
}

/** UpdateHolderDetailsResponse */
export interface UpdateHolderDetailsResponse {
  data: InvestorEdits;
}

/** UpdateNavRequest */
export interface UpdateNavRequest {
  /** Id */
  id: number;
  /**
   * The price per share
   * @min 0
   */
  price_per_share: number;
  /**
   * Changes Date
   * @format date-time
   */
  changes_date: string;
  /** Justification */
  justification?: string;
}

/** UpdateNavResponse */
export interface UpdateNavResponse {
  data: NAVHistoryItem;
}

/** UpdatePortfolioRequest */
export interface UpdatePortfolioRequest {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
  /**
   * Name
   * @minLength 1
   * @maxLength 100
   */
  name: string;
}

/** UpdatePortfolioResponse */
export interface UpdatePortfolioResponse {
  portfolio: Portfolio;
}

/** UpdatePortfolioTransactionRequest */
export interface UpdatePortfolioTransactionRequest {
  /** Id */
  id: number;
  /** Asset Id */
  asset_id?: number;
  transaction_type?: PortfolioTransactionType;
  status?: PortfolioTransactionStatus;
  /**
   * Confirmation Date
   * @format date-time
   */
  confirmation_date?: string;
  /** Price Per Share */
  price_per_share?: number;
  /** Quantity */
  quantity?: number;
  /** To Portfolio Bank Id */
  to_portfolio_bank_id?: number;
  /** From Portfolio Bank Id */
  from_portfolio_bank_id?: number;
  /** Ref Portfolio Transaction Id */
  ref_portfolio_transaction_id?: number;
  /** Memo */
  memo?: string;
  /** Is Complete Book */
  is_complete_book?: boolean;
  /** Fee */
  fee?: number;
  /** Amount */
  amount?: number;
  /**
   * Fx Rate
   * @default "1.00"
   */
  fx_rate?: number;
  /** Portfolio Id */
  portfolio_id: number;
  /**
   * Split Post Quantity
   * @default "0.00"
   */
  split_post_quantity?: number;
  /** Broker Id */
  broker_id?: number;
  from_currency?: CurrencyEnum;
  to_currency?: CurrencyEnum;
}

/** UpdateRegisterBankRequest */
export interface UpdateRegisterBankRequest {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
  /** Bank Name */
  bank_name?: string;
  /** Bank Account Name */
  bank_account_name?: string;
  /** Bank Account Bsb */
  bank_account_bsb?: string;
  /** Bank Account Number */
  bank_account_number?: string;
  /** Bank Types */
  bank_types?: BankTypeEnum[];
  bank_currency?: CurrencyEnum;
  /** Bank Classes */
  bank_classes?: number[];
}

/** UpdateRegisterBankResponse */
export interface UpdateRegisterBankResponse {
  /** Success */
  success: boolean;
}

/** UpdateRegisterClassRequest */
export interface UpdateRegisterClassRequest {
  /**
   * The register class ID
   * @exclusiveMin 0
   */
  id: number;
  /**
   * The register class's name
   * @minLength 1
   * @maxLength 100
   */
  class_name: string;
  /**
   * The current price per share
   * @min 0
   */
  current_price_per_share: number;
  /**
   * The minimal value for investment
   * @min 0
   */
  min_investment: number;
  /** The transfer lock period */
  transfer_lock_period?: number;
  /**
   * Date
   * @format date-time
   */
  date?: string;
}

/** UpdateRegisterClassResponse */
export interface UpdateRegisterClassResponse {
  register_class: RegisterClassResponse;
}

/** UpdateRegisterRequest */
export interface UpdateRegisterRequest {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
  country_code: CountryCodeEnum;
  /**
   * Registered Office
   * @minLength 1
   * @maxLength 60
   */
  registered_office: string;
  /**
   * Email
   * @maxLength 60
   */
  email?: string;
  /**
   * Phone
   * @maxLength 20
   */
  phone?: string;
  /**
   * Website
   * @maxLength 60
   */
  website?: string;
  /**
   * Abn
   * @maxLength 30
   */
  abn: string;
  /**
   * Trustee
   * @maxLength 60
   */
  trustee: string;
  /**
   * Allows Fractional Shares
   * @default false
   */
  allows_fractional_shares?: boolean;
  type: RegisterType;
  /**
   * Name
   * @minLength 1
   * @maxLength 60
   */
  name: string;
  /**
   * Code
   * @minLength 1
   * @maxLength 60
   */
  code: string;
  /**
   * Acn
   * @minLength 1
   * @maxLength 60
   */
  ACN: string;
  /**
   * User Identification Number
   * @max 999999
   */
  user_identification_number?: number;
  /** PNG/JPEG image in Base64 string */
  icon_base64?: string;
  /** Register Legal Name */
  register_legal_name?: string;
  rounding_type?: RoundingType;
  /**
   * Hold Carried Forward
   * @default false
   */
  hold_carried_forward?: boolean;
  /** Banks */
  banks: BankModel[];
}

/** UpdateRegisterResponse */
export interface UpdateRegisterResponse {
  register_obj: RegisterByIdResponse;
  register_settings?: RegisterSettingsResponse;
}

/** UpdateShareholderRequest */
export interface UpdateShareholderRequest {
  /** Id */
  id: number;
  /** The entity email */
  email?: string;
  /** The entity phone number */
  phone_number?: string;
  /** The entity address */
  address?: string;
  /**
   * Entity additional emails
   * @maxItems 5
   */
  additional_emails?: string[];
  /**
   * Notifications Enabled
   * @default false
   */
  notifications_enabled?: boolean;
  /** @default "email" */
  preferred_contact_way?: EntityPreferredContactWay;
  /**
   * Entity additional address
   * @maxLength 255
   */
  additional_address?: string;
  /**
   * Entity suburb
   * @maxLength 50
   */
  suburb?: string;
  /**
   * Entity state
   * @maxLength 20
   */
  state?: string;
  /**
   * Entity postcode
   * @maxLength 20
   */
  postcode?: string;
  /** Entity country */
  country?: CountryCodeEnum;
  /** Dividend Reinvestment */
  dividend_reinvestment?: Record<string, boolean>;
}

/** UpdateShareholderResponse */
export interface UpdateShareholderResponse {
  shareholder: ShareholderResponse;
}

/** UpdateUserPermissionRequest */
export interface UpdateUserPermissionRequest {
  /** User Id */
  user_id: number;
  /** Register Id */
  register_id: number;
  role?: KeycloakIssuerRole;
  /** Register Permission */
  register_permission?: boolean;
  /** Communication Permission */
  communication_permission?: boolean;
  /** Holder Details Permission */
  holder_details_permission?: boolean;
}

/** UpdateUserPermissionResponse */
export interface UpdateUserPermissionResponse {
  /** Success */
  success: boolean;
}

/** UpdateUserProfileRequest */
export interface UpdateUserProfileRequest {
  /** Notifications enabled */
  notifications_enabled?: boolean;
}

/** UpdateUserProfileResponse */
export interface UpdateUserProfileResponse {
  user: UserResponse;
}

/** UpdateUserTotpStatusRequest */
export interface UpdateUserTotpStatusRequest {
  /**
   * Enabled
   * Enable or disable 2FA
   */
  enabled: boolean;
}

/** UpdateUserTotpStatusResponse */
export interface UpdateUserTotpStatusResponse {
  /** Success */
  success: boolean;
}

/** UpsertHolderTaxReportByYearDataRequest */
export interface UpsertHolderTaxReportByYearDataRequest {
  /**
   * Year
   * @min 1900
   * @max 9999
   */
  year: number;
  /**
   * Entity Id
   * @exclusiveMin 0
   */
  entity_id: number;
  /**
   * Register Id
   * @exclusiveMin 0
   */
  register_id: number;
  /** Tax Report Json */
  tax_report_json: TaxReportByYearDataSchema | object;
}

/** UpsertHolderTaxReportByYearDataResponse */
export interface UpsertHolderTaxReportByYearDataResponse {
  /** Id */
  id: number;
  /** Year */
  year: number;
  /** Entity Id */
  entity_id: number;
  /** Register Id */
  register_id: number;
  /** Tax Report Json */
  tax_report_json: TaxReportByYearDataSchema | object;
}

/** UpsertRegisterTotalFundByYearRequest */
export interface UpsertRegisterTotalFundByYearRequest {
  /**
   * Register Id
   * @exclusiveMin 0
   */
  register_id: number;
  /**
   * Year
   * @min 1900
   * @max 9999
   */
  year: number;
  /** Total Fund */
  total_fund: number;
}

/** UserDetailsData */
export interface UserDetailsData {
  /**
   * The first name of the user
   * @minLength 3
   * @maxLength 255
   */
  first_name: string;
  /**
   * The last name of the user
   * @minLength 3
   * @maxLength 255
   */
  last_name: string;
  /**
   * The email of the user
   * @format email
   */
  email: string;
}

/** UserPermission */
export interface UserPermission {
  /** Register Id */
  register_id: number;
  /** User Id */
  user_id: number;
  /** Register Permission */
  register_permission: boolean;
  /** Communication Permission */
  communication_permission: boolean;
  /** Holder Details Permission */
  holder_details_permission: boolean;
}

/** UserRegister */
export interface UserRegister {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** User Id */
  user_id: number;
  /** Register Id */
  register_id: number;
  user_role?: UserRole;
}

/** UserRegisterResponse */
export interface UserRegisterResponse {
  /** Id */
  id: number;
  /** User Id */
  user_id: number;
  /** Register Id */
  register_id: number;
  register_obj?: RegisterResponse;
}

/** UserResponse */
export interface UserResponse {
  /** Id */
  id: number;
  /**
   * Email
   * @format email
   */
  email: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /** Notifications Enabled */
  notifications_enabled: boolean;
  /** Avatar Storage Item Id */
  avatar_storage_item_id?: string;
  /** Avatar Url */
  avatar_url?: string;
  /** Is Enabled Tfa */
  is_enabled_tfa?: boolean;
  /** Keycloak User Id */
  keycloak_user_id?: string;
}

/** UserShortModel */
export interface UserShortModel {
  /** First Name */
  first_name?: string;
  /** Last Name */
  last_name?: string;
  /** Email */
  email?: string;
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
}

/** ValueOvertimeChartData */
export interface ValueOvertimeChartData {
  /** Name */
  name: "Portfolio Value" | "Total Asset Value" | "Bank Cash";
  /** Data */
  data: OvertimeData[];
}

/** VerifyEntityPaymentRequest */
export interface VerifyEntityPaymentRequest {
  /** Entity Id */
  entity_id: number;
}

/** VerifyEntityPaymentResponse */
export interface VerifyEntityPaymentResponse {
  /** Success */
  success: boolean;
}

/** WebhookEventsResponse */
export interface WebhookEventsResponse {
  /** Success */
  success: boolean;
}

/** BrokerExtended */
export interface BrokerExtended {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Portfolio Id */
  portfolio_id: number;
  portfolio: Portfolio;
  /** Balances */
  balances?: BrokerBalances[];
}

/** CreateAssetResponse */
export interface CreateAssetResponse {
  asset: Asset;
}

/** CreatePortfolioTransactionResponse */
export interface CreatePortfolioTransactionResponse {
  transaction: PortfolioTransactionExtended;
}

/** GetAssetByIdResponse */
export interface GetAssetByIdResponse {
  asset: AssetExtended;
}

/** GetAssetListResponse */
export interface GetAssetListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: AssetExtended[];
}

/** GetAssetsBreakdownChartResponse */
export interface GetAssetsBreakdownChartResponse {
  /** Data */
  data: AssetBreakdownChartData[];
}

/** GetAssetsTreemapChartResponse */
export interface GetAssetsTreemapChartResponse {
  /** Data */
  data: TreemapChartData[];
}

/** GetBrokerByIdResponse */
export interface GetBrokerByIdResponse {
  data: BrokerExtended;
}

/** GetBrokerListResponse */
export interface GetBrokerListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: BrokerExtended[];
}

/** GetOutdatedAssetsResponse */
export interface GetOutdatedAssetsResponse {
  /** Has Outdated */
  has_outdated: boolean;
  /** Outdated Assets */
  outdated_assets: AssetWithQuantity[];
}

/** GetPortfolioCashMovementsByIdResponse */
export interface GetPortfolioCashMovementsByIdResponse {
  data: PortfolioCashMovementExtend;
}

/** GetPortfolioListResponse */
export interface GetPortfolioListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: PortfolioModel[];
}

/** GetPortfolioOverallBalanceResponse */
export interface GetPortfolioOverallBalanceResponse {
  data: OverallBalance;
}

/** GetPortfolioTransactionByIdResponse */
export interface GetPortfolioTransactionByIdResponse {
  transaction: PortfolioTransactionExtended;
}

/** GetPortfolioTransactionListResponse */
export interface GetPortfolioTransactionListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: PortfolioTransactionExtended[];
}

/** GetRegisterBankByIdResponse */
export interface GetRegisterBankByIdResponse {
  register_bank: RegisterBankExtended;
}

/** GetRegisterBankListResponse */
export interface GetRegisterBankListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: RegisterBankExtended[];
}

/** GetValueOvertimeChartResponse */
export interface GetValueOvertimeChartResponse {
  /** Data */
  data: ValueOvertimeChartData[];
}

/** OverallBalance */
export interface OverallBalance {
  /**
   * Total Value
   * @default "0"
   */
  total_value?: number;
  /**
   * Total Available Cash
   * @default "0"
   */
  total_available_cash?: number;
  /**
   * Total Asset Value
   * @default "0"
   */
  total_asset_value?: number;
  /**
   * Pnl
   * @default "0"
   */
  pnl?: number;
  /**
   * Pnl Ratio
   * @default "0"
   */
  pnl_ratio?: number;
  /** Banks Balance */
  banks_balance: BankBalanceCash[];
}

/** PortfolioCashMovementExtend */
export interface PortfolioCashMovementExtend {
  /** Id */
  id: number;
  /** Register Id */
  register_id: number;
  /** Shareholder Id */
  shareholder_id: number;
  /**
   * Confirmation Date
   * @format date-time
   */
  confirmation_date?: string;
  /**
   * Requested At Date
   * @format date-time
   */
  requested_at_date: string;
  /** Transaction Id */
  transaction_id?: number;
  direction: CashMovementType;
  status: PaymentStatus;
  /** Amount */
  amount: number;
  /** Memo */
  memo?: string;
  /** Dividend Event Id */
  dividend_event_id?: number;
  /** Correspondence Id */
  correspondence_id?: number;
  register_obj: Register;
  shareholder: Shareholder;
  transaction?: Transaction;
  dividend_event?: DividendEvent;
  portfolio_transaction?: PortfolioTransaction;
  correspondence?: CorrespondenceSummary;
  /** Payment Id */
  payment_id?: number;
}

/** PortfolioTransactionExtended */
export interface PortfolioTransactionExtended {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** Asset Id */
  asset_id?: number;
  transaction_type: PortfolioTransactionType;
  status: PortfolioTransactionStatus;
  /**
   * Confirmation Date
   * @format date-time
   */
  confirmation_date?: string;
  /** Price Per Share */
  price_per_share: number;
  /** Quantity */
  quantity: number;
  /** Correspondence Id */
  correspondence_id?: number;
  /** To Portfolio Bank Id */
  to_portfolio_bank_id?: number;
  /** From Portfolio Bank Id */
  from_portfolio_bank_id?: number;
  /** Ref Portfolio Transaction Id */
  ref_portfolio_transaction_id?: number;
  /** Memo */
  memo?: string;
  /** Fee */
  fee?: number;
  /** Amount */
  amount?: number;
  /** Portfolio Id */
  portfolio_id: number;
  /** Fx Rate */
  fx_rate?: number;
  /** Split Post Quantity */
  split_post_quantity?: number;
  from_currency?: CurrencyEnum;
  to_currency?: CurrencyEnum;
  /**
   * Is Conversion
   * @default false
   */
  is_conversion?: boolean;
  /**
   * Created With Ai
   * @default false
   */
  created_with_ai?: boolean;
  asset?: AssetExtended;
  to_bank?: RegisterBankExtended;
  from_bank?: RegisterBankExtended;
  broker?: BrokerExtended;
  correspondence?: CorrespondenceSummary;
}

/** Register */
export interface Register {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** Email */
  email?: string;
  /** Phone */
  phone?: string;
  /** Website */
  website?: string;
  /** Abn */
  abn: string;
  /** Trustee */
  trustee: string;
  /**
   * Allows Fractional Shares
   * @default false
   */
  allows_fractional_shares?: boolean;
  type: RegisterType;
  /** Name */
  name: string;
  /** Code */
  code: string;
  /**
   * Blockchain Data Encryption Key
   * @format binary
   */
  blockchain_data_encryption_key?: File;
  /** Registered Office */
  registered_office?: string;
  /** Country Code */
  country_code?: string;
  /** Acn */
  ACN: string;
  /** Register Legal Name */
  register_legal_name?: string;
  /** User Identification Number */
  user_identification_number?: number;
  /** Icon Url */
  icon_url?: string;
  /** Icon Storage Item Id */
  icon_storage_item_id?: string;
  /** Keycloak Organization Id */
  keycloak_organization_id?: string;
  /** Correspondence Email */
  correspondence_email?: string;
  currency?: CurrencyEnum;
  /** Private Id */
  private_id?: string;
  /** Custodial Updates Email */
  custodial_updates_email?: string;
}

/** UpdateAssetResponse */
export interface UpdateAssetResponse {
  asset: Asset;
}

/** UpdatePortfolioTransactionResponse */
export interface UpdatePortfolioTransactionResponse {
  transaction: PortfolioTransactionExtended;
}

export interface GetUsersListV1UsersGetParams {
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
}

export interface GetCurrentUserEntitiesV1UsersCurrentEntitiesGetParams {
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
}

export interface GetTransactionsV1UsersCurrentTransactionsGetParams {
  /**
   * Register Id
   * @exclusiveMin 0
   */
  register_id?: number;
  /**
   * Register Class Id
   * @exclusiveMin 0
   */
  register_class_id?: number;
  /**
   * Shareholder Id
   * @exclusiveMin 0
   */
  shareholder_id?: number;
  /** Type */
  type?: TransactionType;
  /** Status */
  status?: TransactionStatus;
  /**
   * Confirmation Date From
   * @format date-time
   */
  confirmation_date_from?: string;
  /**
   * Confirmation Date To
   * @format date-time
   */
  confirmation_date_to?: string;
  /**
   * Requested At Date From
   * @format date-time
   */
  requested_at_date_from?: string;
  /**
   * Requested At Date To
   * @format date-time
   */
  requested_at_date_to?: string;
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
  /** @default "requested_at_date" */
  sorted_by?: SortedBy;
  /**
   * Type Exclude
   * @example "a,b,c"
   */
  type_exclude?: string[] | string;
}

export interface GetAdminEntitiesListV1UsersAdminEntitiesGetParams {
  /**
   * Apply Register Id
   * @exclusiveMin 0
   */
  apply_register_id?: number;
  /** Status */
  status?: EntityStatus;
  /** Type */
  type?: EntityType;
  /** Register Type */
  register_type?: RegisterType;
  /** Search */
  search?: string;
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
}

export interface DeleteEntityDocumentV1UsersEntitiesDocumentsDeleteParams {
  /**
   * Entity Id
   * @exclusiveMin 0
   */
  entity_id?: number;
  /** Type */
  type: string;
  /** Index */
  index?: string;
  /**
   * Issuer Edit Request
   * @exclusiveMin 0
   */
  issuer_edit_request?: number;
}

export interface GetEntityV1UsersEntitiesEntityIdGetParams {
  /** Entity Id */
  entityId: number;
}

export interface RemoveEntityV1UsersEntitiesEntityIdDeleteParams {
  /** Entity Id */
  entityId: number;
}

export interface GetIssuersV1UsersIssuersGetParams {
  /** Register Id */
  register_id?: number;
  /** Search */
  search?: string;
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
}

export interface DeleteIssuerV1UsersIssuersIssuerIdDeleteParams {
  /** Issuer Id */
  issuerId: number;
}

export interface DeleteUserRegistersV1SrUserRegistersIdDeleteParams {
  /** Id */
  id: number;
}

export interface IssuerDeleteUserRegistersV1SrIssuerUserRegistersIdDeleteParams {
  /** Id */
  id: number;
}

export interface GetRegisterClassListV1SrRegisterClassesGetParams {
  /**
   * Register Id
   * @exclusiveMin 0
   */
  register_id?: number;
  /** Search */
  search?: string;
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
}

export interface DeleteRegisterClassV1SrRegisterClassesIdDeleteParams {
  /** Id */
  id: number;
}

export interface GetEntityShareholderListV1SrShareholdersGetParams {
  /** Entity Id */
  entity_id: number;
}

export interface GetRegisterShareholderListV1SrShareholdersByYourRegisterGetParams {
  /**
   * Register Id
   * @exclusiveMin 0
   */
  register_id?: number;
  /**
   * Entity Id
   * @exclusiveMin 0
   */
  entity_id?: number;
  /** Search */
  search?: string;
  /**
   * Register Class Id
   * @exclusiveMin 0
   */
  register_class_id?: number;
  /**
   * Entity Status
   * @example "a,b,c"
   */
  entity_status?: string[] | string;
  /**
   * Is Subscribed
   * @default false
   */
  is_subscribed?: boolean;
}

export interface FindShareholdersByRegisterV1SrShareholdersRegisterGetParams {
  /** Search */
  search?: string;
  /**
   * Register Class Id
   * @exclusiveMin 0
   */
  register_class_id?: number;
  /**
   * Shareholder Id
   * @exclusiveMin 0
   */
  shareholder_id?: number;
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
}

export interface GetShareholdersSubscriptionsClassesV1SrShareholdersSubscriptionClassesGetParams {
  /**
   * Shareholders Ids
   * Comma-separated list of integers
   * @example "1,2,3"
   */
  shareholders_ids: number[] | string;
}

export interface GetTransactionsListV1SrTransactionsGetParams {
  /**
   * Register Id
   * @exclusiveMin 0
   */
  register_id?: number;
  /**
   * Register Class Id
   * @exclusiveMin 0
   */
  register_class_id?: number;
  /**
   * Shareholder Id
   * @exclusiveMin 0
   */
  shareholder_id?: number;
  /** Type */
  type?: TransactionType;
  /** Status */
  status?: TransactionStatus;
  /**
   * Confirmation Date From
   * @format date-time
   */
  confirmation_date_from?: string;
  /**
   * Confirmation Date To
   * @format date-time
   */
  confirmation_date_to?: string;
  /**
   * Requested At Date From
   * @format date-time
   */
  requested_at_date_from?: string;
  /**
   * Requested At Date To
   * @format date-time
   */
  requested_at_date_to?: string;
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
  /** @default "requested_at_date" */
  sorted_by?: SortedBy;
  /**
   * Type Exclude
   * @example "a,b,c"
   */
  type_exclude?: string[] | string;
  /** Entity Id */
  entity_id?: number;
  /** Portfolio Id */
  portfolio_id?: number;
  /**
   * Is Deleted
   * @default false
   */
  is_deleted?: boolean;
  /** Dividend Event Id */
  dividend_event_id?: number;
}

export interface GetTransactionV1SrTransactionsIdGetParams {
  /**
   * Is Deleted
   * @default false
   */
  is_deleted?: boolean;
  /** Id */
  id: number;
}

export interface IssuerRegisterClassListV1SrRegisterClassesIssuerGetParams {
  /** Search */
  search?: string;
}

export interface GetRegisterClassV1SrRegisterClassesRegisterClassesIdGetParams {
  /** Register Classes Id */
  registerClassesId: number;
}

export interface GetRegistersListV1SrRegistersGetParams {
  /** Type */
  type?: RegisterType;
  /** Search */
  search?: string;
  /** Register Id */
  register_id?: number;
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
}

export interface GetRegisterUsersV1SrRegistersCurrentUsersGetParams {
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
  /** Name */
  name?: string;
}

export interface DeleteRegisterV1SrRegistersIdDeleteParams {
  /** Id */
  id: number;
}

export interface GetRegisterByIdV1SrRegistersIdGetParams {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
}

export interface DeleteReportV1SrReportsIdDeleteParams {
  /** Id */
  id: number;
}

export interface GetPaymentsListV1SrPaymentsGetParams {
  /** Status */
  status?: PaymentStatus;
  /** Direction */
  direction?: PaymentDirection;
  /** Amount From */
  amount_from?: number;
  /** Amount To */
  amount_to?: number;
  /**
   * Confirmation Date From
   * @format date-time
   */
  confirmation_date_from?: string;
  /**
   * Confirmation Date To
   * @format date-time
   */
  confirmation_date_to?: string;
  /**
   * Requested At Date From
   * @format date-time
   */
  requested_at_date_from?: string;
  /**
   * Requested At Date To
   * @format date-time
   */
  requested_at_date_to?: string;
  /** Register Class Id */
  register_class_id?: number;
  /** Shareholder Id */
  shareholder_id?: number;
  /** Dividend Event Id */
  dividend_event_id?: number;
  /** Is Dividend Payments */
  is_dividend_payments?: boolean;
  /** Bank Id */
  bank_id?: number;
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
  /** @default "requested_at_date" */
  sorted_by?: SortedBy;
  /** Entity Id */
  entity_id?: number;
  /**
   * Is Deleted
   * @default false
   */
  is_deleted?: boolean;
}

export interface GetPaymentByIdV1SrPaymentsIdGetParams {
  /**
   * Is Deleted
   * @default false
   */
  is_deleted?: boolean;
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
}

export interface GetMyInvestmentsListV1SrMyInvestmentsGetParams {
  /**
   * Register Id
   * @exclusiveMin 0
   */
  register_id?: number;
  /**
   * Register Class Id
   * @exclusiveMin 0
   */
  register_class_id?: number;
  /**
   * Shareholder Id
   * @exclusiveMin 0
   */
  shareholder_id?: number;
  /** Type */
  type?: TransactionType;
  /** Status */
  status?: TransactionStatus;
  /**
   * Confirmation Date From
   * @format date-time
   */
  confirmation_date_from?: string;
  /**
   * Confirmation Date To
   * @format date-time
   */
  confirmation_date_to?: string;
  /**
   * Requested At Date From
   * @format date-time
   */
  requested_at_date_from?: string;
  /**
   * Requested At Date To
   * @format date-time
   */
  requested_at_date_to?: string;
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
}

export interface GetIssuerBalanceStatisticsV1SrIssuerBalanceStatisticsGetParams {
  /** Entity Id */
  entity_id: number;
}

export interface BalancesListV1SrBalancesGetParams {
  /**
   * From Date
   * @format date
   */
  from_date: string;
  /**
   * To Date
   * @format date
   */
  to_date: string;
}

export interface IssuerBalancesListV1SrIssuerBalancesGetParams {
  /**
   * From Date
   * @format date
   */
  from_date: string;
  /**
   * To Date
   * @format date
   */
  to_date: string;
  /** Entity Id */
  entity_id: number;
}

export interface MyActivitiesListV1SrActivitiesMyGetParams {
  /**
   * Register Class Id
   * @exclusiveMin 0
   */
  register_class_id?: number;
  /**
   * Payment Id
   * @exclusiveMin 0
   */
  payment_id?: number;
  /** Status */
  status?: ActivitiesStatus;
  /** Type */
  type?: ActivitiesType;
  /** Quantity From */
  quantity_from?: number;
  /** Quantity To */
  quantity_to?: number;
  /**
   * Total From
   * @exclusiveMax 9223372036854776000
   */
  total_from?: number;
  /**
   * Total To
   * @exclusiveMax 9223372036854776000
   */
  total_to?: number;
  /**
   * Completion Date From
   * @format date-time
   */
  completion_date_from?: string;
  /**
   * Completion Date To
   * @format date-time
   */
  completion_date_to?: string;
  /**
   * Requested At Date From
   * @format date-time
   */
  requested_at_date_from?: string;
  /**
   * Requested At Date To
   * @format date-time
   */
  requested_at_date_to?: string;
  /** Shareholder Id */
  shareholder_id?: number;
  /** Is Dividend Activities */
  is_dividend_activities?: boolean;
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
  /** @default "requested_at_date" */
  sorted_by?: SortedBy;
}

export interface IssuerActivitiesListV1SrActivitiesIssuerGetParams {
  /**
   * Register Class Id
   * @exclusiveMin 0
   */
  register_class_id?: number;
  /**
   * Payment Id
   * @exclusiveMin 0
   */
  payment_id?: number;
  /** Status */
  status?: ActivitiesStatus;
  /** Type */
  type?: ActivitiesType;
  /** Quantity From */
  quantity_from?: number;
  /** Quantity To */
  quantity_to?: number;
  /**
   * Total From
   * @exclusiveMax 9223372036854776000
   */
  total_from?: number;
  /**
   * Total To
   * @exclusiveMax 9223372036854776000
   */
  total_to?: number;
  /**
   * Completion Date From
   * @format date-time
   */
  completion_date_from?: string;
  /**
   * Completion Date To
   * @format date-time
   */
  completion_date_to?: string;
  /**
   * Requested At Date From
   * @format date-time
   */
  requested_at_date_from?: string;
  /**
   * Requested At Date To
   * @format date-time
   */
  requested_at_date_to?: string;
  /** Shareholder Id */
  shareholder_id?: number;
  /** Is Dividend Activities */
  is_dividend_activities?: boolean;
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
  /** @default "requested_at_date" */
  sorted_by?: SortedBy;
  /**
   * Dividend Id
   * @exclusiveMin 0
   */
  dividend_id?: number;
  /**
   * Is Deleted
   * @default false
   */
  is_deleted?: boolean;
}

export interface GetIssuerTransferListV1SrTransfersIssuerGetParams {
  /**
   * From Shareholder Id
   * @exclusiveMin 0
   */
  from_shareholder_id?: number;
  /**
   * To Shareholder Id
   * @exclusiveMin 0
   */
  to_shareholder_id?: number;
  /**
   * General Shareholder Id
   * @exclusiveMin 0
   */
  general_shareholder_id?: number;
  /**
   * Register Class Id
   * @exclusiveMin 0
   */
  register_class_id?: number;
  /**
   * From Confirmation Date
   * @format date-time
   */
  from_confirmation_date?: string;
  /**
   * To Confirmation Date
   * @format date-time
   */
  to_confirmation_date?: string;
  /**
   * From Requested At Date
   * @format date-time
   */
  from_requested_at_date?: string;
  /**
   * To Requested At Date
   * @format date-time
   */
  to_requested_at_date?: string;
  /** Status */
  status?: TransactionStatus;
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
  /** Sorted By */
  sorted_by?: SortedBy;
  /**
   * Is Deleted
   * @default false
   */
  is_deleted?: boolean;
}

export interface GetInvestorTransferListV1SrTransfersInvestorGetParams {
  /**
   * From Shareholder Id
   * @exclusiveMin 0
   */
  from_shareholder_id?: number;
  /**
   * To Shareholder Id
   * @exclusiveMin 0
   */
  to_shareholder_id?: number;
  /**
   * General Shareholder Id
   * @exclusiveMin 0
   */
  general_shareholder_id?: number;
  /**
   * Register Class Id
   * @exclusiveMin 0
   */
  register_class_id?: number;
  /**
   * From Confirmation Date
   * @format date-time
   */
  from_confirmation_date?: string;
  /**
   * To Confirmation Date
   * @format date-time
   */
  to_confirmation_date?: string;
  /**
   * From Requested At Date
   * @format date-time
   */
  from_requested_at_date?: string;
  /**
   * To Requested At Date
   * @format date-time
   */
  to_requested_at_date?: string;
  /** Status */
  status?: TransactionStatus;
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
  /** Sorted By */
  sorted_by?: SortedBy;
}

export interface GetTransferV1SrTransfersIdGetParams {
  /**
   * Is Deleted
   * @default false
   */
  is_deleted?: boolean;
  /** Id */
  id: number;
}

export interface GetReportsListV1SrReportsGetParams {
  /**
   * Register Id
   * @exclusiveMin 0
   */
  register_id?: number;
  /**
   * Entity Id
   * @exclusiveMin 0
   */
  entity_id?: number;
  /** Filename */
  filename?: string;
  /** Format */
  format?: ReportFormat;
  /** Type */
  type?: ReportType;
  /**
   * Created By
   * @exclusiveMin 0
   */
  created_by?: number;
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
}

export interface GetBulkReportChildrenV1SrReportsReportIdChildrenGetParams {
  /** Report Id */
  reportId: number;
}

export interface RegenerateBulkReportZipV1SrReportsReportIdRegenerateZipPostParams {
  /** Report Id */
  reportId: number;
}

export interface GenerateInvestorDistributionReportsV1SrDividendIdInvestorDistributionReportsGeneratePostParams {
  /** Id */
  id: number;
}

export interface GetDividendEventListV1SrDividendEventsGetParams {
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
  /** Register Class Id */
  register_class_id?: number;
  /**
   * Date From
   * @format date-time
   */
  date_from?: string;
  /**
   * Date To
   * @format date-time
   */
  date_to?: string;
  /** Status */
  status?: DividendStatus;
  /**
   * Is Deleted
   * @default false
   */
  is_deleted?: boolean;
}

export interface GetNavHistoryListV1SrNavHistoryGetParams {
  /**
   * From Date
   * @format date
   */
  from_date?: string;
  /**
   * To Date
   * @format date
   */
  to_date?: string;
}

export interface GetNavsV1SrNavsGetParams {
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
  /**
   * Register Class Id
   * @exclusiveMin 0
   */
  register_class_id: number;
  /**
   * Active From
   * @format date
   */
  active_from?: string;
  /**
   * Active To
   * @format date
   */
  active_to?: string;
  /**
   * Created At From
   * @format date
   */
  created_at_from?: string;
  /**
   * Created At To
   * @format date
   */
  created_at_to?: string;
}

export interface GetShareholderHistoryListV1SrShareholdersHoldingsValueHistoryGetParams {
  /**
   * From Date
   * @format date
   */
  from_date?: string;
  /**
   * To Date
   * @format date
   */
  to_date?: string;
}

export interface GetBuyBackEventListV1SrBuyBackEventsGetParams {
  /**
   * Register Id
   * @exclusiveMin 0
   */
  register_id?: number;
  /**
   * Register Class Id
   * @exclusiveMin 0
   */
  register_class_id?: number;
  /**
   * Event Date From
   * @format date
   */
  event_date_from?: string;
  /**
   * Event Date To
   * @format date
   */
  event_date_to?: string;
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
  /**
   * Is Deleted
   * @default false
   */
  is_deleted?: boolean;
}

export interface GetEventLogListV1SrEventLogsGetParams {
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
  /** Is Read */
  is_read?: boolean;
  /**
   * Types
   * @example "a,b,c"
   */
  types?: string[] | string;
  /**
   * From Date
   * @format date
   */
  from_date?: string;
  /**
   * To Date
   * @format date
   */
  to_date?: string;
  /** Register Class Id */
  register_class_id?: number;
  /** Dividend Event Id */
  dividend_event_id?: number;
  /**
   * Is Deleted
   * @default false
   */
  is_deleted?: boolean;
  /**
   * Created By
   * @exclusiveMin 0
   */
  created_by?: number;
  /** Portfolio Id */
  portfolio_id?: number;
  /** Broker Id */
  broker_id?: number;
}

export interface GetCommunicationListV1SrCommunicationsGetParams {
  /**
   * Register Id
   * @exclusiveMin 0
   */
  register_id?: number;
  /**
   * Register Class Id
   * @exclusiveMin 0
   */
  register_class_id?: number;
  /**
   * Event Date From
   * @format date
   */
  event_date_from?: string;
  /**
   * Event Date To
   * @format date
   */
  event_date_to?: string;
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
}

export interface GetIssuersListByRegisterV1SrIssuersIssuersByRegisterIdGetParams {
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
}

export interface GetEmbeddableNavListV1SrEmbeddableNavListGetParams {
  /**
   * Register Id
   * @exclusiveMin 0
   */
  register_id: number;
  /**
   * From Date
   * @format date
   */
  from_date: string;
  /**
   * To Date
   * @format date
   * @default "2026-06-30"
   */
  to_date?: string;
}

export interface GetEmbeddablePaginatedNavListV1SrEmbeddablePaginatedNavListGetParams {
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
  /**
   * Register Class Id
   * @exclusiveMin 0
   */
  register_class_id: number;
  /**
   * Active From
   * @format date
   */
  active_from?: string;
  /**
   * Active To
   * @format date
   */
  active_to?: string;
  /**
   * Created At From
   * @format date
   */
  created_at_from?: string;
  /**
   * Created At To
   * @format date
   */
  created_at_to?: string;
  /**
   * Register Id
   * @exclusiveMin 0
   */
  register_id: number;
}

export interface GetRegisterByPrivateIdV1SrRegisterInviteIdGetParams {
  /** Id */
  id: string;
}

export interface GetBronIdLookupV1SrBronIdLookupGetParams {
  /**
   * Abn
   * @minLength 9
   * @maxLength 11
   */
  abn: string;
}

export interface GetEntitiesListV1SrIssuerEntitiesGetParams {
  /**
   * Apply Register Id
   * @exclusiveMin 0
   */
  apply_register_id?: number;
  /** Status */
  status?: EntityStatus;
  /** Type */
  type?: EntityType;
  /** Register Type */
  register_type?: RegisterType;
  /** Search */
  search?: string;
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
  /**
   * Register Ids
   * @example "a,b,c"
   */
  register_ids?: string[] | string;
}

export interface DeleteDividendV1SrDividendIdDeleteParams {
  /** Id */
  id: number;
}

export interface GetDividendByIdV1SrDividendIdGetParams {
  /**
   * Is Deleted
   * @default false
   */
  is_deleted?: boolean;
  /** Id */
  id: number;
}

export interface BulkPaymentFileV1SrDividendIdBulkPaymentFileGetParams {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
}

export interface GetDocumentsV1SrDocumentsGetParams {
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
  /**
   * Register Id
   * @exclusiveMin 0
   */
  register_id?: number;
  /**
   * Shareholder Id
   * @exclusiveMin 0
   */
  shareholder_id?: number;
  /** Operation Type */
  operation_type?: DocumentOperationType;
  /**
   * Operation Id
   * @exclusiveMin 0
   */
  operation_id?: number;
  /**
   * Date From
   * @format date-time
   */
  date_from?: string;
  /**
   * Date To
   * @format date-time
   */
  date_to?: string;
}

export interface GetCorrespondenceListV1SrCorrespondencesGetParams {
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
  /** Root Id */
  root_id: number;
}

export interface GetCommunicationCorrespondenceListV1SrCommunicationCorrespondenceTrackingGetParams {
  /** Text */
  text?: string;
  /** Type */
  type?: CommunicationType;
  /** Sender */
  sender?: string;
  /** Recipient */
  recipient?: string;
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
}

export interface GetCurrencyHistoricalFxV1SrCurrencyHistoricalFxGetParams {
  from_currency: CurrencyEnum;
  to_currency: CurrencyEnum;
  /**
   * Fx Date
   * @format date
   */
  fx_date?: string;
}

export interface GetRegisterClassUnitsV1SrRegisterClassUnitsGetParams {
  /**
   * Date From
   * @format date-time
   */
  date_from?: string;
  /**
   * Date To
   * @format date-time
   */
  date_to?: string;
}

export interface GetTaxReportIncomeV1SrTaxReportDividendIncomeGetParams {
  /**
   * Date From
   * @format date-time
   */
  date_from?: string;
  /**
   * Date To
   * @format date-time
   */
  date_to?: string;
  /**
   * Entity Id
   * @exclusiveMin 0
   */
  entity_id: number;
}

export interface GetRegisterTotalFundByYearListV1SrTaxReportRegisterTotalFundByYearGetParams {
  /**
   * Year
   * @min 1900
   * @max 9999
   */
  year: number;
}

export interface GetRegisterTotalFundByYearRegisterHoldersV1SrTaxReportRegisterTotalFundByYearHoldersGetParams {
  /**
   * Register Id
   * @exclusiveMin 0
   */
  register_id: number;
  /**
   * Year
   * @min 1901
   * @max 9999
   */
  year: number;
}

export interface GetHolderTaxReportYearsByRegisterV1SrTaxReportHolderByYearDataYearsGetParams {
  /**
   * Entity Id
   * @exclusiveMin 0
   */
  entity_id: number;
  /**
   * Register Id
   * @exclusiveMin 0
   */
  register_id: number;
}

export interface GetHolderTaxReportByYearDataV1SrTaxReportHolderByYearDataGetParams {
  /**
   * Entity Id
   * @exclusiveMin 0
   */
  entity_id: number;
  /**
   * Register Id
   * @exclusiveMin 0
   */
  register_id: number;
  /**
   * Year
   * @min 1900
   * @max 9999
   */
  year: number;
}

export interface ArchiveDividendV1SrArchivingDividendsIdPostParams {
  /** Id */
  id: number;
}

export interface ArchivePaymentV1SrArchivingPaymentsIdPostParams {
  /** Id */
  id: number;
}

export interface ArchiveTransactionV1SrArchivingTransactionsIdPostParams {
  /** Id */
  id: number;
}

export interface ArchiveTransferV1SrArchivingTransferIdPostParams {
  /** Id */
  id: number;
}

export interface GetBuybackV1SrBuyBackEventsIdGetParams {
  /**
   * Is Deleted
   * @default false
   */
  is_deleted?: boolean;
  /** Id */
  id: number;
}

export interface ArchiveBuybackV1SrBuyBackEventsIdPostParams {
  /** Id */
  id: number;
}

export interface GetTopHoldersChartV1SrChartsIssuerTopHoldersGetParams {
  /**
   * Register Class Id
   * @exclusiveMin 0
   */
  register_class_id?: number;
}

export interface GetApplicationOverTimeChartV1SrChartsIssuerApplicationOverTimeGetParams {
  /**
   * Date From
   * @format date-time
   */
  date_from?: string;
  /**
   * Date To
   * @format date-time
   */
  date_to?: string;
}

export interface GetIssuedCapitalChartV1SrChartsIssuerIssuedCapitalGetParams {
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
  /** Entity Id */
  entity_id?: number;
}

export interface GetPendingApplicationSummaryV1SrChartsIssuerPendingApplicationSummaryGetParams {
  /**
   * Date From
   * @format date-time
   */
  date_from?: string;
  /**
   * Date To
   * @format date-time
   */
  date_to?: string;
}

export interface GetIssuedCapitalOverTimeV1SrChartsIssuerIssuedCapitalOverTimeGetParams {
  /**
   * Date From
   * @format date-time
   */
  date_from?: string;
  /**
   * Date To
   * @format date-time
   */
  date_to?: string;
  /** Register Class Id */
  register_class_id?: number;
}

export interface GetIssuedCapitalOverTimeBySecuritiesV1SrChartsIssuerIssuedCapitalOverTimeBySecuritiesGetParams {
  /**
   * Date From
   * @format date-time
   */
  date_from?: string;
  /**
   * Date To
   * @format date-time
   */
  date_to?: string;
  /**
   * Register Class Ids
   * @example "a,b,c"
   */
  register_class_ids?: string[] | string;
}

export interface GetCapitalSummarySectionV1SrSectionsIssuerCapitalSummaryGetParams {
  /** Register Class Id */
  register_class_id?: number;
  /**
   * Date From
   * @format date-time
   */
  date_from?: string;
  /**
   * Date To
   * @format date-time
   */
  date_to?: string;
}

export interface GetPendingApplicationSummarySectionV1SrSectionsIssuerPendingApplicationSummaryGetParams {
  /**
   * Date From
   * @format date-time
   */
  date_from?: string;
  /**
   * Date To
   * @format date-time
   */
  date_to?: string;
}

export interface GetShareCertificateDataV1SrCertificatesShareCertificateDataCodeGetParams {
  /** Code */
  code: string;
}

export interface GetListByInvestorV1SrCertificatesInvestorGetParams {
  /** Status */
  status?: ShareCertificateStatus;
  /**
   * From Date
   * @format date
   */
  from_date?: string;
  /**
   * To Date
   * @format date
   */
  to_date?: string;
  /** Register Class Id */
  register_class_id?: number;
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
}

export interface GetListByIssuerV1SrCertificatesIssuerGetParams {
  /** Shareholder Id */
  shareholder_id?: number;
  /** Status */
  status?: ShareCertificateStatus;
  /**
   * From Date
   * @format date
   */
  from_date?: string;
  /**
   * To Date
   * @format date
   */
  to_date?: string;
  /** Register Class Id */
  register_class_id?: number;
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
}

export interface GetVerificationStatusV1SrBronidGetVerificationStatusGetParams {
  /** Entity Id */
  entity_id: number;
}

export interface GetBlockchainTransactionsV1BlockchainEventsGetParams {
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
}

export interface GetInvestorEditListV1InvestorEditGetParams {
  /**
   * Status
   * @example "a,b,c"
   */
  status?: string[] | string;
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
}

export interface ChangeStatusToAwaitingApprovalV1InvestorEditAwaitingApprovalIdPatchParams {
  /** Id */
  id: number;
}

export interface GetInvestorEditRequestByIdV1InvestorEditIdGetParams {
  /** Id */
  id: number;
}

export interface GetPortfolioListV1SelfCustodyPortfolioGetParams {
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
}

export interface GetPortfolioByIdV1SelfCustodyPortfolioPortfolioIdGetParams {
  /**
   * Date To
   * @format date-time
   */
  date_to?: string;
  /**
   * Portfolio Id
   * @exclusiveMin 0
   */
  portfolioId: number;
}

export interface DeletePortfolioByIdV1SelfCustodyPortfolioPortfolioIdDeleteParams {
  /** Portfolio Id */
  portfolioId: number;
}

export interface GetAssetListV1SelfCustodyAssetGetParams {
  /** Search */
  search?: string;
  /** Sort By */
  sort_by?: SortBy;
  /**
   * Sort Direction
   * @default "asc"
   */
  sort_direction?: "asc" | "desc";
  /** Asset Type */
  asset_type?: AssetType;
  /** Broker Id */
  broker_id?: number;
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
  /** Portfolio Id */
  portfolio_id?: number;
  /**
   * Is Asset Only
   * @default false
   */
  is_asset_only?: boolean;
}

export interface GetAssetByIdV1SelfCustodyAssetAssetIdGetParams {
  /**
   * Is Broker
   * @default false
   */
  is_broker?: boolean;
  /** Asset Id */
  assetId: number;
}

export interface DeleteAssetByIdV1SelfCustodyAssetAssetIdDeleteParams {
  /** Asset Id */
  assetId: number;
}

export interface RefreshAssetPriceV1SelfCustodyAssetAssetIdRefreshPricePostParams {
  /** Asset Id */
  assetId: number;
}

export interface GetPortfolioTransactionListV1SelfCustodyPortfolioTransactionGetParams {
  /**
   * Date From
   * @format date-time
   */
  date_from?: string;
  /**
   * Date To
   * @format date-time
   */
  date_to?: string;
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
  /**
   * Portfolio Id
   * @exclusiveMin 0
   */
  portfolio_id: number;
  /**
   * Asset Id
   * @exclusiveMin 0
   */
  asset_id?: number;
  /**
   * Broker Id
   * @exclusiveMin 0
   */
  broker_id?: number;
  /** Transaction Type */
  transaction_type?: PortfolioTransactionType;
  /** Is Book */
  is_book?: boolean;
  /** Is Bank */
  is_bank?: boolean;
  /** Status */
  status?: PortfolioTransactionStatus;
  /** Bank Id */
  bank_id?: number;
}

export interface DeletePortfolioTransactionByIdV1SelfCustodyPortfolioTransactionTransactionIdDeleteParams {
  /** Transaction Id */
  transactionId: number;
}

export interface GetPortfolioTransactionByIdV1SelfCustodyPortfolioTransactionTransactionIdGetParams {
  /** Transaction Id */
  transactionId: number;
}

export interface GetPortfolioCashMovementListV1SelfCustodyCashMovementGetParams {
  /** Status */
  status?: PaymentStatus;
  /** Direction */
  direction?: CashMovementType;
  /** Amount From */
  amount_from?: number;
  /** Amount To */
  amount_to?: number;
  /**
   * Confirmation Date From
   * @format date-time
   */
  confirmation_date_from?: string;
  /**
   * Confirmation Date To
   * @format date-time
   */
  confirmation_date_to?: string;
  /**
   * Requested At Date From
   * @format date-time
   */
  requested_at_date_from?: string;
  /**
   * Requested At Date To
   * @format date-time
   */
  requested_at_date_to?: string;
  /** Register Class Id */
  register_class_id?: number;
  /** Shareholder Id */
  shareholder_id?: number;
  /** Dividend Event Id */
  dividend_event_id?: number;
  /** Is Dividend Payments */
  is_dividend_payments?: boolean;
  /** Bank Id */
  bank_id?: number;
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
  /** @default "requested_at_date" */
  sorted_by?: SortedBy;
  /** Entity Id */
  entity_id?: number;
  /** Portfolio Id */
  portfolio_id?: number;
}

export interface GetPortfolioCashMovementByIdV1SelfCustodyCashMovementCashMovementIdGetParams {
  /** Portfolio Id */
  portfolio_id: number;
  /** Cash Movement Id */
  cashMovementId: number;
}

export interface GetAssetsTreemapChartV1SelfCustodyChartsAssetsTreemapGetParams {
  /** Portfolio Id */
  portfolio_id: number;
}

export interface GetAssetsBreakdownChartV1SelfCustodyChartsAssetsBreakdownGetParams {
  /** Portfolio Id */
  portfolio_id: number;
}

export interface GetPnlOvertimeChartV1SelfCustodyChartsPnlOvertimeGetParams {
  /** Portfolio Id */
  portfolio_id: number;
}

export interface GetTotalCashInOutChartV1SelfCustodyChartsCashInOutGetParams {
  /** Portfolio Id */
  portfolio_id: number;
}

export interface GetValueOvertimeChartV1SelfCustodyChartsValueOvertimeGetParams {
  /** Portfolio Id */
  portfolio_id: number;
}

export interface GetOverallBalanceStatisticV1SelfCustodyOverallBalanceStatisticGetParams {
  /**
   * Date To
   * @format date-time
   */
  date_to?: string;
}

export interface GetBrokerListV1SelfCustodyBrokersGetParams {
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 500
   * @default 1
   */
  page_size?: number;
  /** Portfolio Id */
  portfolio_id: number;
  /**
   * Date From
   * @format date-time
   */
  date_from?: string;
  /**
   * Date To
   * @format date-time
   */
  date_to?: string;
}

export interface GetBrokerByIdV1SelfCustodyBrokersBrokerIdGetParams {
  /** Broker Id */
  brokerId: number;
}

export interface DeleteBrokerByIdV1SelfCustodyBrokersBrokerIdDeleteParams {
  /** Broker Id */
  brokerId: number;
}

export interface GetRegisterBankListV1SrRegisterBanksGetParams {
  /**
   * Page
   * @exclusiveMin 0
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @exclusiveMin 0
   * @max 100
   * @default 20
   */
  page_size?: number;
  /** Bank Type */
  bank_type?: BankTypeEnum;
  /** Portfolio Id */
  portfolio_id?: number;
  /** Is Overall */
  is_overall?: boolean;
  /**
   * Date To
   * @format date-time
   */
  date_to?: string;
}

export interface GetRegisterBankByIdV1SrRegisterBanksRegisterBankIdGetParams {
  /** Register Bank Id */
  registerBankId: number;
}

export interface DeleteRegisterBankV1SrRegisterBanksRegisterBankIdDeleteParams {
  /** Register Bank Id */
  registerBankId: number;
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "http://localhost:8081/",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Compli One SR API
 * @version 1.0
 * @baseUrl http://localhost:8081/
 *
 * Compli One SR Backend REST API 💅
 * Base URL: http://localhost:8081/
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  healthcheck = {
    /**
     * No description
     *
     * @tags healthcheck
     * @name HealthcheckHealthcheckGet
     * @summary Healthcheck
     * @request GET:/healthcheck
     */
    healthcheckHealthcheckGet: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/healthcheck`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  v1 = {
    /**
     * No description
     *
     * @tags users
     * @name SignUpUserV1UsersPost
     * @summary Sign Up User
     * @request POST:/v1/users
     */
    signUpUserV1UsersPost: (
      data: SignUpUserRequest,
      params: RequestParams = {},
    ) =>
      this.request<SignUpUserResponse, HTTPValidationError>({
        path: `/v1/users`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags users
     * @name GetUsersListV1UsersGet
     * @summary Get Users List
     * @request GET:/v1/users
     * @secure
     */
    getUsersListV1UsersGet: (
      query: GetUsersListV1UsersGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetUserListResponse, HTTPValidationError>({
        path: `/v1/users`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor, issuer, issuer_admin, super_admin
     *
     * @tags users
     * @name EmbeddableTokenV1UsersEmbeddableTokenPost
     * @summary Embeddable Token
     * @request POST:/v1/users/embeddable/token
     * @secure
     */
    embeddableTokenV1UsersEmbeddableTokenPost: (
      data: ExchangeUserTokenToEmbeddableTokenRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ExchangeUserTokenToEmbeddableTokenResponse,
        HTTPValidationError
      >({
        path: `/v1/users/embeddable/token`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor, issuer, issuer_admin, super_admin
     *
     * @tags users
     * @name GetCurrentUserEntitiesV1UsersCurrentEntitiesGet
     * @summary Get Current User Entities
     * @request GET:/v1/users/current/entities
     * @secure
     */
    getCurrentUserEntitiesV1UsersCurrentEntitiesGet: (
      query: GetCurrentUserEntitiesV1UsersCurrentEntitiesGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetUserEntitiesResponse, HTTPValidationError>({
        path: `/v1/users/current/entities`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor
     *
     * @tags users
     * @name GetTransactionsV1UsersCurrentTransactionsGet
     * @summary Get Transactions
     * @request GET:/v1/users/current/transactions
     * @secure
     */
    getTransactionsV1UsersCurrentTransactionsGet: (
      query: GetTransactionsV1UsersCurrentTransactionsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetCurrentUserTransactionListResponse, HTTPValidationError>({
        path: `/v1/users/current/transactions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor, issuer, issuer_admin, super_admin
     *
     * @tags users
     * @name GetCurrentUserV1UsersCurrentGet
     * @summary Get Current User
     * @request GET:/v1/users/current
     * @secure
     */
    getCurrentUserV1UsersCurrentGet: (params: RequestParams = {}) =>
      this.request<GetCurrentUserResponse, any>({
        path: `/v1/users/current`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor
     *
     * @tags users
     * @name CreateEntityV1UsersEntitiesPost
     * @summary Create Entity
     * @request POST:/v1/users/entities
     * @secure
     */
    createEntityV1UsersEntitiesPost: (
      data: CreateEntityRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateEntityResponse, HTTPValidationError>({
        path: `/v1/users/entities`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor
     *
     * @tags users
     * @name UpdateEntityV1UsersEntitiesPatch
     * @summary Update Entity
     * @request PATCH:/v1/users/entities
     * @secure
     */
    updateEntityV1UsersEntitiesPatch: (
      data: UpdateEntityRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateEntityResponse, HTTPValidationError>({
        path: `/v1/users/entities`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Can be used to fetch your investor entities. **Required roles:** investor, issuer, issuer_admin, super_admin
     *
     * @tags users
     * @name GetUserEntitiesV1UsersEntitiesGet
     * @summary Get User Entities
     * @request GET:/v1/users/entities
     * @secure
     */
    getUserEntitiesV1UsersEntitiesGet: (params: RequestParams = {}) =>
      this.request<GetUserEntitiesResponse, HTTPValidationError>({
        path: `/v1/users/entities`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** super_admin
     *
     * @tags users
     * @name GetAdminEntitiesListV1UsersAdminEntitiesGet
     * @summary Get Admin Entities List
     * @request GET:/v1/users/admin/entities
     * @secure
     */
    getAdminEntitiesListV1UsersAdminEntitiesGet: (
      query: GetAdminEntitiesListV1UsersAdminEntitiesGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetEntitiesResponse, HTTPValidationError>({
        path: `/v1/users/admin/entities`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor
     *
     * @tags users
     * @name EntitySetAwaitingApprovedV1UsersEntitiesStatusAwaitingApprovedPatch
     * @summary Entity Set Awaiting Approved
     * @request PATCH:/v1/users/entities/status/awaiting-approved
     * @secure
     */
    entitySetAwaitingApprovedV1UsersEntitiesStatusAwaitingApprovedPatch: (
      data: EntitySetAwaitingApprovalRequest,
      params: RequestParams = {},
    ) =>
      this.request<EntitySetAwaitingApprovalResponse, HTTPValidationError>({
        path: `/v1/users/entities/status/awaiting-approved`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** super_admin
     *
     * @tags users
     * @name UpdateEntityStatusV1UsersEntitiesStatusPatch
     * @summary Update Entity Status
     * @request PATCH:/v1/users/entities/status
     * @secure
     */
    updateEntityStatusV1UsersEntitiesStatusPatch: (
      data: UpdateEntityStatusRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateEntityStatusResponse, HTTPValidationError>({
        path: `/v1/users/entities/status`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor, issuer, issuer_admin
     *
     * @tags users
     * @name DeleteEntityDocumentV1UsersEntitiesDocumentsDelete
     * @summary Delete Entity Document
     * @request DELETE:/v1/users/entities/documents
     * @secure
     */
    deleteEntityDocumentV1UsersEntitiesDocumentsDelete: (
      query: DeleteEntityDocumentV1UsersEntitiesDocumentsDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteEntityDocumentResponse, HTTPValidationError>({
        path: `/v1/users/entities/documents`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor, super_admin
     *
     * @tags users
     * @name GetEntityV1UsersEntitiesEntityIdGet
     * @summary Get Entity
     * @request GET:/v1/users/entities/{entity_id}
     * @secure
     */
    getEntityV1UsersEntitiesEntityIdGet: (
      { entityId }: GetEntityV1UsersEntitiesEntityIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetEntityItemResponse, HTTPValidationError>({
        path: `/v1/users/entities/${entityId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor
     *
     * @tags users
     * @name RemoveEntityV1UsersEntitiesEntityIdDelete
     * @summary Remove Entity
     * @request DELETE:/v1/users/entities/{entity_id}
     * @secure
     */
    removeEntityV1UsersEntitiesEntityIdDelete: (
      { entityId }: RemoveEntityV1UsersEntitiesEntityIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteEntityResponse, HTTPValidationError>({
        path: `/v1/users/entities/${entityId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor, issuer, issuer_admin, super_admin
     *
     * @tags users
     * @name DeleteUserAvatarV1UsersAvatarDelete
     * @summary Delete User Avatar
     * @request DELETE:/v1/users/avatar
     * @secure
     */
    deleteUserAvatarV1UsersAvatarDelete: (params: RequestParams = {}) =>
      this.request<DeleteUserAvatarResponse, any>({
        path: `/v1/users/avatar`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** super_admin, issuer, issuer_admin
     *
     * @tags users
     * @name GetIssuersV1UsersIssuersGet
     * @summary Get Issuers
     * @request GET:/v1/users/issuers
     * @secure
     */
    getIssuersV1UsersIssuersGet: (
      query: GetIssuersV1UsersIssuersGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetIssuerListResponse, HTTPValidationError>({
        path: `/v1/users/issuers`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** super_admin
     *
     * @tags users
     * @name AddNewIssuerV1UsersIssuersPost
     * @summary Add New Issuer
     * @request POST:/v1/users/issuers
     * @secure
     */
    addNewIssuerV1UsersIssuersPost: (
      data: AddNewIssuerRequest,
      params: RequestParams = {},
    ) =>
      this.request<AddNewIssuerResponse, HTTPValidationError>({
        path: `/v1/users/issuers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags users
     * @name IssuerAddV1UsersIssuerAddPost
     * @summary Issuer Add
     * @request POST:/v1/users/issuer/add
     * @secure
     */
    issuerAddV1UsersIssuerAddPost: (
      data: IssuerAddNewIssuerRequest,
      params: RequestParams = {},
    ) =>
      this.request<IssuerAddNewIssuerResponse, HTTPValidationError>({
        path: `/v1/users/issuer/add`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** super_admin
     *
     * @tags users
     * @name DeleteIssuerV1UsersIssuersIssuerIdDelete
     * @summary Delete Issuer
     * @request DELETE:/v1/users/issuers/{issuer_id}
     * @secure
     */
    deleteIssuerV1UsersIssuersIssuerIdDelete: (
      { issuerId }: DeleteIssuerV1UsersIssuersIssuerIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteIssuerResponse, HTTPValidationError>({
        path: `/v1/users/issuers/${issuerId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor, issuer, issuer_admin, super_admin
     *
     * @tags users
     * @name UpdateUserSettingsV1UsersSettingsPatch
     * @summary Update User Settings
     * @request PATCH:/v1/users/settings
     * @secure
     */
    updateUserSettingsV1UsersSettingsPatch: (
      data: UpdateUserProfileRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateUserProfileResponse, HTTPValidationError>({
        path: `/v1/users/settings`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** super_admin
     *
     * @tags users
     * @name MigrateDataToKeycloakV1UsersMigrateDataToKeycloakPost
     * @summary Migrate Data To Keycloak
     * @request POST:/v1/users/migrate-data-to-keycloak
     * @secure
     */
    migrateDataToKeycloakV1UsersMigrateDataToKeycloakPost: (
      data: MigrateDataToKeycloakRequest,
      params: RequestParams = {},
    ) =>
      this.request<MigrateDataToKeycloakResponse, HTTPValidationError>({
        path: `/v1/users/migrate-data-to-keycloak`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** super_admin, issuer, compliance_user, compliance_admin, loans_admin, loans_user, issuer_admin, academy_user, academy_organisation_admin, investor
     *
     * @tags users
     * @name ApplyInvestorRoleV1UsersApplyInvestorRolePut
     * @summary Apply Investor Role
     * @request PUT:/v1/users/apply-investor-role
     * @secure
     */
    applyInvestorRoleV1UsersApplyInvestorRolePut: (
      data: AddOrganizationRoleRequest,
      params: RequestParams = {},
    ) =>
      this.request<AddOrganizationRoleResponse, HTTPValidationError>({
        path: `/v1/users/apply-investor-role`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags users
     * @name RegisterSsoInvestorV1UsersRegisterSsoInvestorPost
     * @summary Register Sso Investor
     * @request POST:/v1/users/register-sso-investor
     */
    registerSsoInvestorV1UsersRegisterSsoInvestorPost: (
      data: RegisterSsoInvestorRequest,
      params: RequestParams = {},
    ) =>
      this.request<RegisterSsoInvestorResponse, HTTPValidationError>({
        path: `/v1/users/register-sso-investor`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Use case for fully resetting a user's Two-Factor Authentication (2FA) configuration. This class allows a user to completely remove their existing TOTP-based 2FA setup, enabling them to reconfigure or add a new 2FA device from scratch. It retrieves the current authenticated user from the request context and calls the Users API to perform the reset operation. **Required roles:** investor, issuer, issuer_admin, super_admin
     *
     * @tags users
     * @name ResetUser2FaV1UsersReset2FaPost
     * @summary Reset User 2Fa
     * @request POST:/v1/users/reset-2fa
     * @secure
     */
    resetUser2FaV1UsersReset2FaPost: (params: RequestParams = {}) =>
      this.request<ResetUserTotpResponse, any>({
        path: `/v1/users/reset-2fa`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Use case for enabling or disabling a user's Two-Factor Authentication (2FA) using Time-based One-Time Passwords (TOTP). This class retrieves the current authenticated user from the request context and calls the Users API to update the user's TOTP status. The operation allows the user to turn on or off their 2FA security feature. **Required roles:** investor, issuer, issuer_admin, super_admin
     *
     * @tags users
     * @name UpdateUserTotpStatusV1UsersOtpPost
     * @summary Update User Totp Status
     * @request POST:/v1/users/otp
     * @secure
     */
    updateUserTotpStatusV1UsersOtpPost: (
      data: UpdateUserTotpStatusRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateUserTotpStatusResponse, HTTPValidationError>({
        path: `/v1/users/otp`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Can be used to fetch registers your user belongs to. He can be an investor or an issuer in these registers. **Required roles:** investor, issuer, issuer_admin, super_admin
     *
     * @tags sr
     * @name GetCurrentUserRegistersV1SrUserRegistersGet
     * @summary Get Current User Registers
     * @request GET:/v1/sr/user-registers
     * @secure
     */
    getCurrentUserRegistersV1SrUserRegistersGet: (params: RequestParams = {}) =>
      this.request<GetUserRegistersResponse, any>({
        path: `/v1/sr/user-registers`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** super_admin
     *
     * @tags sr
     * @name CreateUserRegisterV1SrUserRegistersPost
     * @summary Create User Register
     * @request POST:/v1/sr/user-registers
     * @secure
     */
    createUserRegisterV1SrUserRegistersPost: (
      data: CreateUserRegisterRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateUserRegisterResponse, HTTPValidationError>({
        path: `/v1/sr/user-registers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** super_admin
     *
     * @tags sr
     * @name DeleteUserRegistersV1SrUserRegistersIdDelete
     * @summary Delete User Registers
     * @request DELETE:/v1/sr/user-registers/{id}
     * @secure
     */
    deleteUserRegistersV1SrUserRegistersIdDelete: (
      { id }: DeleteUserRegistersV1SrUserRegistersIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminDeleteRegisterIssuerResponse, HTTPValidationError>({
        path: `/v1/sr/user-registers/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name IssuerDeleteUserRegistersV1SrIssuerUserRegistersIdDelete
     * @summary Issuer Delete User Registers
     * @request DELETE:/v1/sr/issuer/user-registers/{id}
     * @secure
     */
    issuerDeleteUserRegistersV1SrIssuerUserRegistersIdDelete: (
      { id }: IssuerDeleteUserRegistersV1SrIssuerUserRegistersIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IssuerDeleteIssuersRegisterResponse, HTTPValidationError>({
        path: `/v1/sr/issuer/user-registers/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name CreateRegisterClassV1SrRegisterClassesPost
     * @summary Create Register Class
     * @request POST:/v1/sr/register-classes
     * @secure
     */
    createRegisterClassV1SrRegisterClassesPost: (
      data: CreateRegisterClassRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateRegisterClassResponse, HTTPValidationError>({
        path: `/v1/sr/register-classes`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name UpdateRegisterClassV1SrRegisterClassesPatch
     * @summary Update Register Class
     * @request PATCH:/v1/sr/register-classes
     * @secure
     */
    updateRegisterClassV1SrRegisterClassesPatch: (
      data: UpdateRegisterClassRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateRegisterClassResponse, HTTPValidationError>({
        path: `/v1/sr/register-classes`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor, issuer, issuer_admin, super_admin
     *
     * @tags sr
     * @name GetRegisterClassListV1SrRegisterClassesGet
     * @summary Get Register Class List
     * @request GET:/v1/sr/register-classes
     * @secure
     */
    getRegisterClassListV1SrRegisterClassesGet: (
      query: GetRegisterClassListV1SrRegisterClassesGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetRegisterClassListResponse, HTTPValidationError>({
        path: `/v1/sr/register-classes`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name DeleteRegisterClassV1SrRegisterClassesIdDelete
     * @summary Delete Register Class
     * @request DELETE:/v1/sr/register-classes/{id}
     * @secure
     */
    deleteRegisterClassV1SrRegisterClassesIdDelete: (
      { id }: DeleteRegisterClassV1SrRegisterClassesIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteRegisterClassResponse, HTTPValidationError>({
        path: `/v1/sr/register-classes/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor
     *
     * @tags sr
     * @name CreateShareholderV1SrShareholdersPost
     * @summary Create Shareholder
     * @request POST:/v1/sr/shareholders
     * @secure
     */
    createShareholderV1SrShareholdersPost: (
      data: CreateShareholderRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateShareholderResponse, HTTPValidationError>({
        path: `/v1/sr/shareholders`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor, issuer, issuer_admin, super_admin
     *
     * @tags sr
     * @name GetEntityShareholderListV1SrShareholdersGet
     * @summary Get Entity Shareholder List
     * @request GET:/v1/sr/shareholders
     * @secure
     */
    getEntityShareholderListV1SrShareholdersGet: (
      query: GetEntityShareholderListV1SrShareholdersGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetEntityShareholdersResponse, HTTPValidationError>({
        path: `/v1/sr/shareholders`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name AddExistingInvestorToRegisterV1SrShareholdersAddExistingPost
     * @summary Add Existing Investor To Register
     * @request POST:/v1/sr/shareholders/add-existing
     * @secure
     */
    addExistingInvestorToRegisterV1SrShareholdersAddExistingPost: (
      data: AddExistingInvestorToRegisterRequest,
      params: RequestParams = {},
    ) =>
      this.request<AddExistingInvestorToRegisterResponse, HTTPValidationError>({
        path: `/v1/sr/shareholders/add-existing`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor, issuer, issuer_admin, super_admin
     *
     * @tags sr
     * @name GetRegisterShareholderListV1SrShareholdersByYourRegisterGet
     * @summary Get Register Shareholder List
     * @request GET:/v1/sr/shareholders/by-your-register
     * @secure
     */
    getRegisterShareholderListV1SrShareholdersByYourRegisterGet: (
      query: GetRegisterShareholderListV1SrShareholdersByYourRegisterGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetShareholdersByRegisterResponse, HTTPValidationError>({
        path: `/v1/sr/shareholders/by-your-register`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name FindShareholdersByRegisterV1SrShareholdersRegisterGet
     * @summary Find Shareholders By Register
     * @request GET:/v1/sr/shareholders/register
     * @secure
     */
    findShareholdersByRegisterV1SrShareholdersRegisterGet: (
      query: FindShareholdersByRegisterV1SrShareholdersRegisterGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetShareholdersByRegisterIdResponse, HTTPValidationError>({
        path: `/v1/sr/shareholders/register`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name GetShareholdersSubscriptionsClassesV1SrShareholdersSubscriptionClassesGet
     * @summary Get Shareholders Subscriptions Classes
     * @request GET:/v1/sr/shareholders/subscription-classes
     * @secure
     */
    getShareholdersSubscriptionsClassesV1SrShareholdersSubscriptionClassesGet: (
      query: GetShareholdersSubscriptionsClassesV1SrShareholdersSubscriptionClassesGetParams,
      params: RequestParams = {},
    ) =>
      this.request<
        GetShareholdersSubscriptionsClassesResponse,
        HTTPValidationError
      >({
        path: `/v1/sr/shareholders/subscription-classes`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor, issuer, issuer_admin
     *
     * @tags sr
     * @name CreateTransactionV1SrTransactionsPost
     * @summary Create Transaction
     * @request POST:/v1/sr/transactions
     * @secure
     */
    createTransactionV1SrTransactionsPost: (
      data: CreateTransactionRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateTransactionResponse, HTTPValidationError>({
        path: `/v1/sr/transactions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name GetTransactionsListV1SrTransactionsGet
     * @summary Get Transactions List
     * @request GET:/v1/sr/transactions
     * @secure
     */
    getTransactionsListV1SrTransactionsGet: (
      query: GetTransactionsListV1SrTransactionsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetTransactionListResponse, HTTPValidationError>({
        path: `/v1/sr/transactions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name TransactionSetRejectV1SrTransactionsStatusRejectedPatch
     * @summary Transaction Set Reject
     * @request PATCH:/v1/sr/transactions/status/rejected
     * @secure
     */
    transactionSetRejectV1SrTransactionsStatusRejectedPatch: (
      data: TransactionSetRejectStatusRequest,
      params: RequestParams = {},
    ) =>
      this.request<TransactionSetRejectStatusResponse, HTTPValidationError>({
        path: `/v1/sr/transactions/status/rejected`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, investor, issuer_admin
     *
     * @tags sr
     * @name TransactionSetAwaitPaymentV1SrTransactionsStatusAwaitPaymentPatch
     * @summary Transaction Set Await Payment
     * @request PATCH:/v1/sr/transactions/status/await-payment
     * @secure
     */
    transactionSetAwaitPaymentV1SrTransactionsStatusAwaitPaymentPatch: (
      data: TransactionSetAwaitPaymentStatusRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        TransactionSetAwaitPaymentStatusResponse,
        HTTPValidationError
      >({
        path: `/v1/sr/transactions/status/await-payment`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name TransactionBulkSetAwaitPaymentV1SrTransactionsStatusBulkAwaitPaymentPatch
     * @summary Transaction Bulk Set Await Payment
     * @request PATCH:/v1/sr/transactions/status/bulk-await-payment
     * @secure
     */
    transactionBulkSetAwaitPaymentV1SrTransactionsStatusBulkAwaitPaymentPatch: (
      data: BulkCompleteDrpRequest,
      params: RequestParams = {},
    ) =>
      this.request<BulkCompleteDrpResponse, HTTPValidationError>({
        path: `/v1/sr/transactions/status/bulk-await-payment`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name TransactionSetCompletedV1SrTransactionsStatusCompletedPatch
     * @summary Transaction Set Completed
     * @request PATCH:/v1/sr/transactions/status/completed
     * @secure
     */
    transactionSetCompletedV1SrTransactionsStatusCompletedPatch: (
      data: TransactionSetCompletedStatusRequest,
      params: RequestParams = {},
    ) =>
      this.request<TransactionSetCompletedStatusResponse, HTTPValidationError>({
        path: `/v1/sr/transactions/status/completed`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name GetTransactionV1SrTransactionsIdGet
     * @summary Get Transaction
     * @request GET:/v1/sr/transactions/{id}
     * @secure
     */
    getTransactionV1SrTransactionsIdGet: (
      { id, ...query }: GetTransactionV1SrTransactionsIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetTransactionResponse, HTTPValidationError>({
        path: `/v1/sr/transactions/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name IssuerRegisterClassListV1SrRegisterClassesIssuerGet
     * @summary Issuer Register Class List
     * @request GET:/v1/sr/register-classes/issuer
     * @secure
     */
    issuerRegisterClassListV1SrRegisterClassesIssuerGet: (
      query: IssuerRegisterClassListV1SrRegisterClassesIssuerGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetIssuerRegisterClassListResponse, HTTPValidationError>({
        path: `/v1/sr/register-classes/issuer`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor, issuer, issuer_admin, super_admin
     *
     * @tags sr
     * @name GetRegisterClassV1SrRegisterClassesRegisterClassesIdGet
     * @summary Get Register Class
     * @request GET:/v1/sr/register-classes/{register_classes_id}
     * @secure
     */
    getRegisterClassV1SrRegisterClassesRegisterClassesIdGet: (
      {
        registerClassesId,
      }: GetRegisterClassV1SrRegisterClassesRegisterClassesIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetRegisterClassByIdResponse, HTTPValidationError>({
        path: `/v1/sr/register-classes/${registerClassesId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** super_admin
     *
     * @tags sr
     * @name CreateRegisterV1SrRegistersPost
     * @summary Create Register
     * @request POST:/v1/sr/registers
     * @secure
     */
    createRegisterV1SrRegistersPost: (
      data: CreateRegisterRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateRegisterResponse, HTTPValidationError>({
        path: `/v1/sr/registers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Allows an issuer or platform super admin to update register (your fund/company) details like legal information, contact information and payment information visible to investors in reports. **Required roles:** super_admin, issuer_admin, issuer
     *
     * @tags sr
     * @name UpdateRegisterV1SrRegistersPut
     * @summary Update Register
     * @request PUT:/v1/sr/registers
     * @secure
     */
    updateRegisterV1SrRegistersPut: (
      data: UpdateRegisterRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateRegisterResponse, HTTPValidationError>({
        path: `/v1/sr/registers`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor, issuer, issuer_admin, super_admin
     *
     * @tags sr
     * @name GetRegistersListV1SrRegistersGet
     * @summary Get Registers List
     * @request GET:/v1/sr/registers
     * @secure
     */
    getRegistersListV1SrRegistersGet: (
      query: GetRegistersListV1SrRegistersGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetRegisterListResponse, HTTPValidationError>({
        path: `/v1/sr/registers`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name GetRegisterUsersV1SrRegistersCurrentUsersGet
     * @summary Get Register Users
     * @request GET:/v1/sr/registers/current/users
     * @secure
     */
    getRegisterUsersV1SrRegistersCurrentUsersGet: (
      query: GetRegisterUsersV1SrRegistersCurrentUsersGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetRegisterUsersResponse, HTTPValidationError>({
        path: `/v1/sr/registers/current/users`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name ClearNewHolderOnboardedNotificationV1SrRegistersCurrentNewHolderOnboardedNotificationPatch
     * @summary Clear New Holder Onboarded Notification
     * @request PATCH:/v1/sr/registers/current/new-holder-onboarded-notification
     * @secure
     */
    clearNewHolderOnboardedNotificationV1SrRegistersCurrentNewHolderOnboardedNotificationPatch:
      (params: RequestParams = {}) =>
        this.request<
          ClearNewHolderOnboardedNotificationResponse,
          HTTPValidationError
        >({
          path: `/v1/sr/registers/current/new-holder-onboarded-notification`,
          method: "PATCH",
          secure: true,
          format: "json",
          ...params,
        }),

    /**
     * @description **Required roles:** super_admin
     *
     * @tags sr
     * @name DeleteRegisterV1SrRegistersIdDelete
     * @summary Delete Register
     * @request DELETE:/v1/sr/registers/{id}
     * @secure
     */
    deleteRegisterV1SrRegistersIdDelete: (
      { id }: DeleteRegisterV1SrRegistersIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteRegisterResponse, HTTPValidationError>({
        path: `/v1/sr/registers/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin, investor, super_admin
     *
     * @tags sr
     * @name GetRegisterByIdV1SrRegistersIdGet
     * @summary Get Register By Id
     * @request GET:/v1/sr/registers/{id}
     * @secure
     */
    getRegisterByIdV1SrRegistersIdGet: (
      { id }: GetRegisterByIdV1SrRegistersIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetRegisterByIdResponse, HTTPValidationError>({
        path: `/v1/sr/registers/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor, issuer, issuer_admin, super_admin
     *
     * @tags sr
     * @name DeleteReportV1SrReportsIdDelete
     * @summary Delete Report
     * @request DELETE:/v1/sr/reports/{id}
     * @secure
     */
    deleteReportV1SrReportsIdDelete: (
      { id }: DeleteReportV1SrReportsIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteReportResponse, HTTPValidationError>({
        path: `/v1/sr/reports/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor, issuer, issuer_admin, super_admin
     *
     * @tags sr
     * @name GetPaymentsListV1SrPaymentsGet
     * @summary Get Payments List
     * @request GET:/v1/sr/payments
     * @secure
     */
    getPaymentsListV1SrPaymentsGet: (
      query: GetPaymentsListV1SrPaymentsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetPaymentListResponse, HTTPValidationError>({
        path: `/v1/sr/payments`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name CreatePaymentV1SrPaymentsPost
     * @summary Create Payment
     * @request POST:/v1/sr/payments
     * @secure
     */
    createPaymentV1SrPaymentsPost: (
      data: CreatePaymentRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreatePaymentResponse, HTTPValidationError>({
        path: `/v1/sr/payments`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name PaymentSetCompletedV1SrPaymentsStatusCompletedPatch
     * @summary Payment Set Completed
     * @request PATCH:/v1/sr/payments/status/completed
     * @secure
     */
    paymentSetCompletedV1SrPaymentsStatusCompletedPatch: (
      data: PaymentSetCompletedStatusRequest,
      params: RequestParams = {},
    ) =>
      this.request<PaymentSetCompletedStatusResponse, HTTPValidationError>({
        path: `/v1/sr/payments/status/completed`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name GetPaymentByIdV1SrPaymentsIdGet
     * @summary Get Payment By Id
     * @request GET:/v1/sr/payments/{id}
     * @secure
     */
    getPaymentByIdV1SrPaymentsIdGet: (
      { id, ...query }: GetPaymentByIdV1SrPaymentsIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetPaymentByIdExtendedResponse, HTTPValidationError>({
        path: `/v1/sr/payments/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name PaymentBulkSetCompletedV1SrPaymentsStatusBulkCompletedPatch
     * @summary Payment Bulk Set Completed
     * @request PATCH:/v1/sr/payments/status/bulk-completed
     * @secure
     */
    paymentBulkSetCompletedV1SrPaymentsStatusBulkCompletedPatch: (
      data: BulkPaymentSetCompletedStatusRequest,
      params: RequestParams = {},
    ) =>
      this.request<BulkPaymentSetCompletedStatusResponse, HTTPValidationError>({
        path: `/v1/sr/payments/status/bulk-completed`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name PaymentSetRejectedV1SrPaymentsStatusRejectedPatch
     * @summary Payment Set Rejected
     * @request PATCH:/v1/sr/payments/status/rejected
     * @secure
     */
    paymentSetRejectedV1SrPaymentsStatusRejectedPatch: (
      data: PaymentSetRejectedStatusRequest,
      params: RequestParams = {},
    ) =>
      this.request<PaymentSetRejectedStatusResponse, HTTPValidationError>({
        path: `/v1/sr/payments/status/rejected`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor, issuer, issuer_admin, super_admin
     *
     * @tags sr
     * @name GetMyInvestmentsListV1SrMyInvestmentsGet
     * @summary Get My Investments List
     * @request GET:/v1/sr/my-investments
     * @secure
     */
    getMyInvestmentsListV1SrMyInvestmentsGet: (
      query: GetMyInvestmentsListV1SrMyInvestmentsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetMyInvestmentsResponse, HTTPValidationError>({
        path: `/v1/sr/my-investments`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get current balance information like total value ($), dividends received ($) and performance (%). **Required roles:** investor
     *
     * @tags sr
     * @name GetBalanceStatisticsV1SrBalanceStatisticsGet
     * @summary Get Balance Statistics
     * @request GET:/v1/sr/balance/statistics
     * @secure
     */
    getBalanceStatisticsV1SrBalanceStatisticsGet: (
      params: RequestParams = {},
    ) =>
      this.request<GetBalanceStatisticsResponse, HTTPValidationError>({
        path: `/v1/sr/balance/statistics`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name GetIssuerBalanceStatisticsV1SrIssuerBalanceStatisticsGet
     * @summary Get Issuer Balance Statistics
     * @request GET:/v1/sr/issuer/balance/statistics
     * @secure
     */
    getIssuerBalanceStatisticsV1SrIssuerBalanceStatisticsGet: (
      query: GetIssuerBalanceStatisticsV1SrIssuerBalanceStatisticsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetBalanceStatisticsResponse, HTTPValidationError>({
        path: `/v1/sr/issuer/balance/statistics`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor
     *
     * @tags sr
     * @name BalancesListV1SrBalancesGet
     * @summary Balances List
     * @request GET:/v1/sr/balances
     * @secure
     */
    balancesListV1SrBalancesGet: (
      query: BalancesListV1SrBalancesGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetBalanceByDateResponse, HTTPValidationError>({
        path: `/v1/sr/balances`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name IssuerBalancesListV1SrIssuerBalancesGet
     * @summary Issuer Balances List
     * @request GET:/v1/sr/issuer/balances
     * @secure
     */
    issuerBalancesListV1SrIssuerBalancesGet: (
      query: IssuerBalancesListV1SrIssuerBalancesGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetBalanceByDateResponse, HTTPValidationError>({
        path: `/v1/sr/issuer/balances`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor
     *
     * @tags sr
     * @name MyActivitiesListV1SrActivitiesMyGet
     * @summary My Activities List
     * @request GET:/v1/sr/activities/my/
     * @secure
     */
    myActivitiesListV1SrActivitiesMyGet: (
      query: MyActivitiesListV1SrActivitiesMyGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetCurrentUserActivitiesListResponse, HTTPValidationError>({
        path: `/v1/sr/activities/my/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name IssuerActivitiesListV1SrActivitiesIssuerGet
     * @summary Issuer Activities List
     * @request GET:/v1/sr/activities/issuer
     * @secure
     */
    issuerActivitiesListV1SrActivitiesIssuerGet: (
      query: IssuerActivitiesListV1SrActivitiesIssuerGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetIssuerActivitiesListResponse, HTTPValidationError>({
        path: `/v1/sr/activities/issuer`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor
     *
     * @tags sr
     * @name CreateTransferV1SrTransfersPost
     * @summary Create Transfer
     * @request POST:/v1/sr/transfers
     * @secure
     */
    createTransferV1SrTransfersPost: (
      data: CreateTransferRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateTransferResponse, HTTPValidationError>({
        path: `/v1/sr/transfers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name CreateIssuerTransferV1SrTransfersIssuerPost
     * @summary Create Issuer Transfer
     * @request POST:/v1/sr/transfers/issuer
     * @secure
     */
    createIssuerTransferV1SrTransfersIssuerPost: (
      data: CreateTransferRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateTransferResponse, HTTPValidationError>({
        path: `/v1/sr/transfers/issuer`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name GetIssuerTransferListV1SrTransfersIssuerGet
     * @summary Get Issuer Transfer List
     * @request GET:/v1/sr/transfers/issuer
     * @secure
     */
    getIssuerTransferListV1SrTransfersIssuerGet: (
      query: GetIssuerTransferListV1SrTransfersIssuerGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetIssuerTransferListResponse, HTTPValidationError>({
        path: `/v1/sr/transfers/issuer`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor
     *
     * @tags sr
     * @name GetInvestorTransferListV1SrTransfersInvestorGet
     * @summary Get Investor Transfer List
     * @request GET:/v1/sr/transfers/investor
     * @secure
     */
    getInvestorTransferListV1SrTransfersInvestorGet: (
      query: GetInvestorTransferListV1SrTransfersInvestorGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetUserTransferListResponse, HTTPValidationError>({
        path: `/v1/sr/transfers/investor`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name TransferSetRejectV1SrTransfersStatusRejectedPatch
     * @summary Transfer Set Reject
     * @request PATCH:/v1/sr/transfers/status/rejected
     * @secure
     */
    transferSetRejectV1SrTransfersStatusRejectedPatch: (
      data: TransferSetRejectedStatusRequest,
      params: RequestParams = {},
    ) =>
      this.request<TransferSetRejectedStatusResponse, HTTPValidationError>({
        path: `/v1/sr/transfers/status/rejected`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name TransferSetCompletedV1SrTransfersStatusCompletedPatch
     * @summary Transfer Set Completed
     * @request PATCH:/v1/sr/transfers/status/completed
     * @secure
     */
    transferSetCompletedV1SrTransfersStatusCompletedPatch: (
      data: TransferSetCompletedStatusRequest,
      params: RequestParams = {},
    ) =>
      this.request<TransferSetCompletedStatusResponse, HTTPValidationError>({
        path: `/v1/sr/transfers/status/completed`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor, issuer, issuer_admin
     *
     * @tags sr
     * @name GetTransferV1SrTransfersIdGet
     * @summary Get Transfer
     * @request GET:/v1/sr/transfers/{id}
     * @secure
     */
    getTransferV1SrTransfersIdGet: (
      { id, ...query }: GetTransferV1SrTransfersIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetTransferResponse, HTTPValidationError>({
        path: `/v1/sr/transfers/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor, issuer, issuer_admin, super_admin
     *
     * @tags sr
     * @name GetReportsListV1SrReportsGet
     * @summary Get Reports List
     * @request GET:/v1/sr/reports
     * @secure
     */
    getReportsListV1SrReportsGet: (
      query: GetReportsListV1SrReportsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetReportListResponse, HTTPValidationError>({
        path: `/v1/sr/reports`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor, issuer, issuer_admin
     *
     * @tags sr
     * @name CreateReportV1SrReportsPost
     * @summary Create Report
     * @request POST:/v1/sr/reports
     * @secure
     */
    createReportV1SrReportsPost: (
      data: GenerateReportRequest,
      params: RequestParams = {},
    ) =>
      this.request<GenerateReportResponse, HTTPValidationError>({
        path: `/v1/sr/reports`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name CreateBulkReportV1SrReportsBulkPost
     * @summary Create Bulk Report
     * @request POST:/v1/sr/reports/bulk
     * @secure
     */
    createBulkReportV1SrReportsBulkPost: (
      data: BulkGenerateReportRequest,
      params: RequestParams = {},
    ) =>
      this.request<GenerateBulkReportsResponse, HTTPValidationError>({
        path: `/v1/sr/reports/bulk`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name GetBulkReportChildrenV1SrReportsReportIdChildrenGet
     * @summary Get Bulk Report Children
     * @request GET:/v1/sr/reports/{report_id}/children
     * @secure
     */
    getBulkReportChildrenV1SrReportsReportIdChildrenGet: (
      { reportId }: GetBulkReportChildrenV1SrReportsReportIdChildrenGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetBulkReportChildrenResponse, HTTPValidationError>({
        path: `/v1/sr/reports/${reportId}/children`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name RegenerateBulkReportZipV1SrReportsReportIdRegenerateZipPost
     * @summary Regenerate Bulk Report Zip
     * @request POST:/v1/sr/reports/{report_id}/regenerate-zip
     * @secure
     */
    regenerateBulkReportZipV1SrReportsReportIdRegenerateZipPost: (
      {
        reportId,
      }: RegenerateBulkReportZipV1SrReportsReportIdRegenerateZipPostParams,
      params: RequestParams = {},
    ) =>
      this.request<RegenerateBulkReportZipResponse, HTTPValidationError>({
        path: `/v1/sr/reports/${reportId}/regenerate-zip`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name GenerateInvestorDistributionReportsV1SrDividendIdInvestorDistributionReportsGeneratePost
     * @summary Generate Investor Distribution Reports
     * @request POST:/v1/sr/dividend/{id}/investor-distribution-reports/generate
     * @secure
     */
    generateInvestorDistributionReportsV1SrDividendIdInvestorDistributionReportsGeneratePost:
      (
        {
          id,
        }: GenerateInvestorDistributionReportsV1SrDividendIdInvestorDistributionReportsGeneratePostParams,
        params: RequestParams = {},
      ) =>
        this.request<
          GenerateInvestorDistributionReportsResponse,
          HTTPValidationError
        >({
          path: `/v1/sr/dividend/${id}/investor-distribution-reports/generate`,
          method: "POST",
          secure: true,
          format: "json",
          ...params,
        }),

    /**
     * @description **Required roles:** investor, issuer, issuer_admin
     *
     * @tags sr
     * @name CreateRedemptionRequestReportV1SrRedemptionRequestPost
     * @summary Create Redemption Request Report
     * @request POST:/v1/sr/redemption-request
     * @secure
     */
    createRedemptionRequestReportV1SrRedemptionRequestPost: (
      data: GenerateRedemptionRequestPdfRequest,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/v1/sr/redemption-request`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name CreateDividendEventV1SrDividendEventsPost
     * @summary Create Dividend Event
     * @request POST:/v1/sr/dividend-events
     * @secure
     */
    createDividendEventV1SrDividendEventsPost: (
      data: CreateDividendEventRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateDividendEventResponse, HTTPValidationError>({
        path: `/v1/sr/dividend-events`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, investor, issuer_admin
     *
     * @tags sr
     * @name GetDividendEventListV1SrDividendEventsGet
     * @summary Get Dividend Event List
     * @request GET:/v1/sr/dividend-events
     * @secure
     */
    getDividendEventListV1SrDividendEventsGet: (
      query: GetDividendEventListV1SrDividendEventsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetIssuerDividendEventListResponse, HTTPValidationError>({
        path: `/v1/sr/dividend-events`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, investor, issuer_admin
     *
     * @tags sr
     * @name GetNavHistoryListV1SrNavHistoryGet
     * @summary Get Nav History List
     * @request GET:/v1/sr/nav-history
     * @secure
     */
    getNavHistoryListV1SrNavHistoryGet: (
      query: GetNavHistoryListV1SrNavHistoryGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetRegisterClassesWithNAVResponse, HTTPValidationError>({
        path: `/v1/sr/nav-history`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name GetNavsV1SrNavsGet
     * @summary Get Navs
     * @request GET:/v1/sr/navs
     * @secure
     */
    getNavsV1SrNavsGet: (
      query: GetNavsV1SrNavsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetNavsListResponse, HTTPValidationError>({
        path: `/v1/sr/navs`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name UpdateNavV1SrNavPatch
     * @summary Update Nav
     * @request PATCH:/v1/sr/nav
     * @secure
     */
    updateNavV1SrNavPatch: (
      data: UpdateNavRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateNavResponse, HTTPValidationError>({
        path: `/v1/sr/nav`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name CreateNavV1SrNavPost
     * @summary Create Nav
     * @request POST:/v1/sr/nav
     * @secure
     */
    createNavV1SrNavPost: (
      data: CreateNavRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateNavResponse, HTTPValidationError>({
        path: `/v1/sr/nav`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name DeleteNavV1SrNavDelete
     * @summary Delete Nav
     * @request DELETE:/v1/sr/nav
     * @secure
     */
    deleteNavV1SrNavDelete: (
      data: DeleteNavByIdRequest,
      params: RequestParams = {},
    ) =>
      this.request<DeleteNavByIdResponse, HTTPValidationError>({
        path: `/v1/sr/nav`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, investor, issuer_admin
     *
     * @tags sr
     * @name GetShareholderHistoryListV1SrShareholdersHoldingsValueHistoryGet
     * @summary Get Shareholder History List
     * @request GET:/v1/sr/shareholders-holdings-value-history
     * @secure
     */
    getShareholderHistoryListV1SrShareholdersHoldingsValueHistoryGet: (
      query: GetShareholderHistoryListV1SrShareholdersHoldingsValueHistoryGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetTotalShareholderHistoryResponse, HTTPValidationError>({
        path: `/v1/sr/shareholders-holdings-value-history`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name CreateBuyBackEventV1SrBuyBackEventsPost
     * @summary Create Buy Back Event
     * @request POST:/v1/sr/buy-back-events
     * @secure
     */
    createBuyBackEventV1SrBuyBackEventsPost: (
      data: CreateBuyBackEventRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateBuyBackEventResponse, HTTPValidationError>({
        path: `/v1/sr/buy-back-events`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name GetBuyBackEventListV1SrBuyBackEventsGet
     * @summary Get Buy Back Event List
     * @request GET:/v1/sr/buy-back-events
     * @secure
     */
    getBuyBackEventListV1SrBuyBackEventsGet: (
      query: GetBuyBackEventListV1SrBuyBackEventsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetBuyBackEventListResponse, HTTPValidationError>({
        path: `/v1/sr/buy-back-events`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor, issuer, issuer_admin, super_admin
     *
     * @tags sr
     * @name GetTotalIsReadValueV1SrAllIsReadGet
     * @summary Get Total Is Read Value
     * @request GET:/v1/sr/all-is-read
     * @secure
     */
    getTotalIsReadValueV1SrAllIsReadGet: (params: RequestParams = {}) =>
      this.request<GetTotalIsReadValueResponse, HTTPValidationError>({
        path: `/v1/sr/all-is-read`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor, issuer, issuer_admin, super_admin
     *
     * @tags sr
     * @name EventLogIsReadV1SrEventLogsIsReadPatch
     * @summary Event Log Is Read
     * @request PATCH:/v1/sr/event-logs/is-read
     * @secure
     */
    eventLogIsReadV1SrEventLogsIsReadPatch: (
      data: EventLogsIsReadRequest,
      params: RequestParams = {},
    ) =>
      this.request<EventLogsIsReadResponse, HTTPValidationError>({
        path: `/v1/sr/event-logs/is-read`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor, issuer, issuer_admin, super_admin
     *
     * @tags sr
     * @name GetEventLogListV1SrEventLogsGet
     * @summary Get Event Log List
     * @request GET:/v1/sr/event-logs
     * @secure
     */
    getEventLogListV1SrEventLogsGet: (
      query: GetEventLogListV1SrEventLogsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetEventLogListResponse, HTTPValidationError>({
        path: `/v1/sr/event-logs`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name CreateCommunicationV1SrCommunicationsPost
     * @summary Create Communication
     * @request POST:/v1/sr/communications
     * @secure
     */
    createCommunicationV1SrCommunicationsPost: (
      data: CreateCommunicationRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateCommunicationResponse, HTTPValidationError>({
        path: `/v1/sr/communications`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name GetCommunicationListV1SrCommunicationsGet
     * @summary Get Communication List
     * @request GET:/v1/sr/communications
     * @secure
     */
    getCommunicationListV1SrCommunicationsGet: (
      query: GetCommunicationListV1SrCommunicationsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetCommunicationListResponse, HTTPValidationError>({
        path: `/v1/sr/communications`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name PreviewCommunicationGeneratedAttachmentsV1SrCommunicationsPreviewPost
     * @summary Preview Communication Generated Attachments
     * @request POST:/v1/sr/communications/preview
     * @secure
     */
    previewCommunicationGeneratedAttachmentsV1SrCommunicationsPreviewPost: (
      data: PreviewCommunicationGeneratedAttachmentsRequest,
      params: RequestParams = {},
    ) =>
      this.request<CommunicationAttachmentPreviewResponse, HTTPValidationError>(
        {
          path: `/v1/sr/communications/preview`,
          method: "POST",
          body: data,
          secure: true,
          type: ContentType.Json,
          format: "json",
          ...params,
        },
      ),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name PreviewBulkReportChildren
     * @summary Preview Existing Bulk Report Children
     * @request POST:/v1/sr/communications/preview-bulk-report-children
     * @secure
     */
    previewBulkReportChildren: (
      data: PreviewExistingBulkReportChildrenRequest,
      params: RequestParams = {},
    ) =>
      this.request<CommunicationAttachmentPreviewResponse, HTTPValidationError>(
        {
          path: `/v1/sr/communications/preview-bulk-report-children`,
          method: "POST",
          body: data,
          secure: true,
          type: ContentType.Json,
          format: "json",
          ...params,
        },
      ),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name SendBulkReportChildren
     * @summary Send Existing Bulk Report Children
     * @request POST:/v1/sr/communications/send-bulk-report-children
     * @secure
     */
    sendBulkReportChildren: (
      data: SendExistingBulkReportChildrenCommunicationRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        SendExistingBulkReportChildrenCommunicationResponse,
        HTTPValidationError
      >({
        path: `/v1/sr/communications/send-bulk-report-children`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags sr
     * @name EntityBronIdWebhookV1SrEntityBronidWebhookPost
     * @summary Entity Bron Id Webhook
     * @request POST:/v1/sr/entity/bronid-webhook
     */
    entityBronIdWebhookV1SrEntityBronidWebhookPost: (
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/v1/sr/entity/bronid-webhook`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor
     *
     * @tags sr
     * @name BronidFollowUpV1SrEntityBronidFollowUpPost
     * @summary Bronid Follow Up
     * @request POST:/v1/sr/entity/bronid-follow-up
     * @secure
     */
    bronidFollowUpV1SrEntityBronidFollowUpPost: (
      data: BronIDFollowUpRequest,
      params: RequestParams = {},
    ) =>
      this.request<BronIDFollowUpResponse, HTTPValidationError>({
        path: `/v1/sr/entity/bronid-follow-up`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer_admin
     *
     * @tags sr
     * @name GetIssuersListByRegisterV1SrIssuersIssuersByRegisterIdGet
     * @summary Get Issuers List By Register
     * @request GET:/v1/sr/issuers/issuers-by-register/{id}
     * @secure
     */
    getIssuersListByRegisterV1SrIssuersIssuersByRegisterIdGet: (
      {
        id,
        ...query
      }: GetIssuersListByRegisterV1SrIssuersIssuersByRegisterIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetIssuersByRegisterResponse, HTTPValidationError>({
        path: `/v1/sr/issuers/issuers-by-register/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, investor, issuer_admin
     *
     * @tags sr
     * @name UpdateEntityContactPaymentDetailsV1SrEntitiesContactPaymentDetailsPatch
     * @summary Update Entity Contact Payment Details
     * @request PATCH:/v1/sr/entities/contact-payment-details
     * @secure
     */
    updateEntityContactPaymentDetailsV1SrEntitiesContactPaymentDetailsPatch: (
      data: UpdateEntityPaymentAndContactDetailsRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        UpdateEntityPaymentAndContactDetailsResponse,
        HTTPValidationError
      >({
        path: `/v1/sr/entities/contact-payment-details`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags sr
     * @name GetEmbeddableNavListV1SrEmbeddableNavListGet
     * @summary Get Embeddable Nav List
     * @request GET:/v1/sr/embeddable/nav-list
     * @secure
     */
    getEmbeddableNavListV1SrEmbeddableNavListGet: (
      query: GetEmbeddableNavListV1SrEmbeddableNavListGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetNavsListEmbeddableResponse, HTTPValidationError>({
        path: `/v1/sr/embeddable/nav-list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags sr
     * @name GetEmbeddablePaginatedNavListV1SrEmbeddablePaginatedNavListGet
     * @summary Get Embeddable Paginated Nav List
     * @request GET:/v1/sr/embeddable/paginated-nav-list
     * @secure
     */
    getEmbeddablePaginatedNavListV1SrEmbeddablePaginatedNavListGet: (
      query: GetEmbeddablePaginatedNavListV1SrEmbeddablePaginatedNavListGetParams,
      params: RequestParams = {},
    ) =>
      this.request<
        GetPaginatedNavsListEmbeddablesResponse,
        HTTPValidationError
      >({
        path: `/v1/sr/embeddable/paginated-nav-list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name VerifyEntityPaymentInfoV1SrEntityVerifyPaymentInfoPost
     * @summary Verify Entity Payment Info
     * @request POST:/v1/sr/entity/verify-payment-info
     * @secure
     */
    verifyEntityPaymentInfoV1SrEntityVerifyPaymentInfoPost: (
      data: VerifyEntityPaymentRequest,
      params: RequestParams = {},
    ) =>
      this.request<VerifyEntityPaymentResponse, HTTPValidationError>({
        path: `/v1/sr/entity/verify-payment-info`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor
     *
     * @tags sr
     * @name VerifiedEntityPaymentInfoV1SrEntityVerifiedPaymentInfoPost
     * @summary Verified Entity Payment Info
     * @request POST:/v1/sr/entity/verified-payment-info
     * @secure
     */
    verifiedEntityPaymentInfoV1SrEntityVerifiedPaymentInfoPost: (
      data: EntityPaymentInfoVerifiedRequest,
      params: RequestParams = {},
    ) =>
      this.request<EntityPaymentInfoVerifiedResponse, HTTPValidationError>({
        path: `/v1/sr/entity/verified-payment-info`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags sr
     * @name GetRegisterByPrivateIdV1SrRegisterInviteIdGet
     * @summary Get Register By Private Id
     * @request GET:/v1/sr/register/invite/{id}
     */
    getRegisterByPrivateIdV1SrRegisterInviteIdGet: (
      { id }: GetRegisterByPrivateIdV1SrRegisterInviteIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetRegisterByPrivateIdResponse, HTTPValidationError>({
        path: `/v1/sr/register/invite/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor, issuer, issuer_admin, super_admin
     *
     * @tags sr
     * @name GetBronIdLookupV1SrBronIdLookupGet
     * @summary Get Bron Id Lookup
     * @request GET:/v1/sr/bron-id/lookup
     * @secure
     */
    getBronIdLookupV1SrBronIdLookupGet: (
      query: GetBronIdLookupV1SrBronIdLookupGetParams,
      params: RequestParams = {},
    ) =>
      this.request<BronIDLookupResponse, HTTPValidationError>({
        path: `/v1/sr/bron-id/lookup`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name GetEntitiesListV1SrIssuerEntitiesGet
     * @summary Get Entities List
     * @request GET:/v1/sr/issuer/entities
     * @secure
     */
    getEntitiesListV1SrIssuerEntitiesGet: (
      query: GetEntitiesListV1SrIssuerEntitiesGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetEntitiesListResponse, HTTPValidationError>({
        path: `/v1/sr/issuer/entities`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer_admin
     *
     * @tags sr
     * @name UpdateIssuerEntityStatusV1SrIssuerEntitiesStatusPatch
     * @summary Issuer Update Entity Status
     * @request PATCH:/v1/sr/issuer/entities/status
     * @secure
     */
    updateIssuerEntityStatusV1SrIssuerEntitiesStatusPatch: (
      data: UpdateEntityStatusRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateEntityStatusResponse, HTTPValidationError>({
        path: `/v1/sr/issuer/entities/status`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name GetPendingApplicationSummaryV1SrIssuerPendingApplicationSummaryGet
     * @summary Get Pending Application Summary
     * @request GET:/v1/sr/issuer/pending-application-summary
     * @secure
     */
    getPendingApplicationSummaryV1SrIssuerPendingApplicationSummaryGet: (
      params: RequestParams = {},
    ) =>
      this.request<GetApplicationSummaryResponse, HTTPValidationError>({
        path: `/v1/sr/issuer/pending-application-summary`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor
     *
     * @tags sr
     * @name GetCommunicationSettingsV1SrInvestorCommunicationSettingsGet
     * @summary Get Communication Settings
     * @request GET:/v1/sr/investor/communication-settings
     * @secure
     */
    getCommunicationSettingsV1SrInvestorCommunicationSettingsGet: (
      params: RequestParams = {},
    ) =>
      this.request<GetShareholderByEntityIdResponse, HTTPValidationError>({
        path: `/v1/sr/investor/communication-settings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor
     *
     * @tags sr
     * @name UpdateCommunicationSettingsV1SrInvestorCommunicationSettingsPatch
     * @summary Update Communication Settings
     * @request PATCH:/v1/sr/investor/communication-settings
     * @secure
     */
    updateCommunicationSettingsV1SrInvestorCommunicationSettingsPatch: (
      data: UpdateShareholderRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateShareholderResponse, HTTPValidationError>({
        path: `/v1/sr/investor/communication-settings`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** super_admin
     *
     * @tags sr
     * @name ImportOperationsV1SrAdminImportOperationsPost
     * @summary Import Operations
     * @request POST:/v1/sr/admin/import-operations
     * @secure
     */
    importOperationsV1SrAdminImportOperationsPost: (
      data: ImportOperationsRequest,
      params: RequestParams = {},
    ) =>
      this.request<ImportOperationsResponse, HTTPValidationError>({
        path: `/v1/sr/admin/import-operations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name UpdateDividendStatusV1SrDividendStatusPut
     * @summary Update Dividend Status
     * @request PUT:/v1/sr/dividend-status
     * @secure
     */
    updateDividendStatusV1SrDividendStatusPut: (
      data: UpdateDividendEventRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateDividendEventResponse, HTTPValidationError>({
        path: `/v1/sr/dividend-status`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name GeneratePreDividendReportV1SrPreDividendReportPost
     * @summary Generate Pre Dividend Report
     * @request POST:/v1/sr/pre-dividend-report
     * @secure
     */
    generatePreDividendReportV1SrPreDividendReportPost: (
      data: PreDividendReportRequest,
      params: RequestParams = {},
    ) =>
      this.request<PreDividendReportResponse, HTTPValidationError>({
        path: `/v1/sr/pre-dividend-report`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** super_admin
     *
     * @tags sr
     * @name DeleteDividendV1SrDividendIdDelete
     * @summary Delete Dividend
     * @request DELETE:/v1/sr/dividend/{id}
     * @secure
     */
    deleteDividendV1SrDividendIdDelete: (
      { id }: DeleteDividendV1SrDividendIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteDividendEventResponse, HTTPValidationError>({
        path: `/v1/sr/dividend/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, investor, issuer_admin
     *
     * @tags sr
     * @name GetDividendByIdV1SrDividendIdGet
     * @summary Get Dividend By Id
     * @request GET:/v1/sr/dividend/{id}
     * @secure
     */
    getDividendByIdV1SrDividendIdGet: (
      { id, ...query }: GetDividendByIdV1SrDividendIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetDividendByIdExtendedResponse, HTTPValidationError>({
        path: `/v1/sr/dividend/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name BulkPaymentFileV1SrDividendIdBulkPaymentFileGet
     * @summary Bulk Payment File
     * @request GET:/v1/sr/dividend/{id}/bulk-payment-file
     * @secure
     */
    bulkPaymentFileV1SrDividendIdBulkPaymentFileGet: (
      { id }: BulkPaymentFileV1SrDividendIdBulkPaymentFileGetParams,
      params: RequestParams = {},
    ) =>
      this.request<BulkPaymentFileGeneratorResponse, HTTPValidationError>({
        path: `/v1/sr/dividend/${id}/bulk-payment-file`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Can get documents applied to transaction and transfers. Also allows to use filtering by shareholder, operation type and operation ID **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name GetDocumentsV1SrDocumentsGet
     * @summary Get Documents
     * @request GET:/v1/sr/documents
     * @secure
     */
    getDocumentsV1SrDocumentsGet: (
      query: GetDocumentsV1SrDocumentsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetDocumentsResponse, HTTPValidationError>({
        path: `/v1/sr/documents`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Handles adding or removing documents from transactions and transfers. **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name UpdateDocumentsV1SrDocumentsPatch
     * @summary Update Documents
     * @request PATCH:/v1/sr/documents
     * @secure
     */
    updateDocumentsV1SrDocumentsPatch: (
      data: UpdateDocumentRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateDocumentResponse, HTTPValidationError>({
        path: `/v1/sr/documents`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Use case for updating user permissions for the Issuer role. **Required roles:** issuer_admin, super_admin
     *
     * @tags sr
     * @name UpdateUserPermissionV1SrUserPermissionPatch
     * @summary Update User Permission
     * @request PATCH:/v1/sr/user-permission
     * @secure
     */
    updateUserPermissionV1SrUserPermissionPatch: (
      data: UpdateUserPermissionRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateUserPermissionResponse, HTTPValidationError>({
        path: `/v1/sr/user-permission`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Use case for retrieving user permissions. This endpoint fetches the permissions for the current issuer based on their register ID. **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name GetUserPermissionV1SrUserPermissionGet
     * @summary Get User Permission
     * @request GET:/v1/sr/user-permission
     * @secure
     */
    getUserPermissionV1SrUserPermissionGet: (params: RequestParams = {}) =>
      this.request<GetUserPermissionResponse, HTTPValidationError>({
        path: `/v1/sr/user-permission`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name GetCorrespondenceListV1SrCorrespondencesGet
     * @summary Get Correspondence List
     * @request GET:/v1/sr/correspondences
     * @secure
     */
    getCorrespondenceListV1SrCorrespondencesGet: (
      query: GetCorrespondenceListV1SrCorrespondencesGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetCorrespondencesResponse, HTTPValidationError>({
        path: `/v1/sr/correspondences`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name GetCommunicationCorrespondenceListV1SrCommunicationCorrespondenceTrackingGet
     * @summary Get Communication Correspondence List
     * @request GET:/v1/sr/communication-correspondence-tracking
     * @secure
     */
    getCommunicationCorrespondenceListV1SrCommunicationCorrespondenceTrackingGet:
      (
        query: GetCommunicationCorrespondenceListV1SrCommunicationCorrespondenceTrackingGetParams,
        params: RequestParams = {},
      ) =>
        this.request<
          GetCommunicationCorrespondenceListResponse,
          HTTPValidationError
        >({
          path: `/v1/sr/communication-correspondence-tracking`,
          method: "GET",
          query: query,
          secure: true,
          format: "json",
          ...params,
        }),

    /**
     * @description Retrieves the historical FX rate for a specific currency pair on a given date. **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name GetCurrencyHistoricalFxV1SrCurrencyHistoricalFxGet
     * @summary Get Currency Historical Fx
     * @request GET:/v1/sr/currency/historical-fx
     * @secure
     */
    getCurrencyHistoricalFxV1SrCurrencyHistoricalFxGet: (
      query: GetCurrencyHistoricalFxV1SrCurrencyHistoricalFxGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetCurrencyHistoricalFXRateResponse, HTTPValidationError>({
        path: `/v1/sr/currency/historical-fx`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name GetRegisterClassUnitsV1SrRegisterClassUnitsGet
     * @summary Get Register Class Units
     * @request GET:/v1/sr/register-class-units
     * @secure
     */
    getRegisterClassUnitsV1SrRegisterClassUnitsGet: (
      query: GetRegisterClassUnitsV1SrRegisterClassUnitsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetRegisterClassUnitsResponse, HTTPValidationError>({
        path: `/v1/sr/register-class-units`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Request to get tax report income information for a specific entity in a given period. This endpoint retrieves dividend distribution data for tax reporting purposes, returning two values: 1. The total distributions across all investors for the specified period 2. The distributions for all other investors excluding the current entity This information is typically used for tax compliance reports and calculations related to dividend distributions. **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name GetTaxReportIncomeV1SrTaxReportDividendIncomeGet
     * @summary Get Tax Report Income
     * @request GET:/v1/sr/tax-report/dividend-income
     * @secure
     */
    getTaxReportIncomeV1SrTaxReportDividendIncomeGet: (
      query: GetTaxReportIncomeV1SrTaxReportDividendIncomeGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetTaxReportIncomeResponse, HTTPValidationError>({
        path: `/v1/sr/tax-report/dividend-income`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name UpsertRegisterTotalFundByYearV1SrTaxReportRegisterTotalFundByYearPut
     * @summary Upsert Register Total Fund By Year
     * @request PUT:/v1/sr/tax-report/register-total-fund-by-year
     * @secure
     */
    upsertRegisterTotalFundByYearV1SrTaxReportRegisterTotalFundByYearPut: (
      data: UpsertRegisterTotalFundByYearRequest,
      params: RequestParams = {},
    ) =>
      this.request<RegisterTotalFundByYearResponse, HTTPValidationError>({
        path: `/v1/sr/tax-report/register-total-fund-by-year`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name GetRegisterTotalFundByYearListV1SrTaxReportRegisterTotalFundByYearGet
     * @summary Get Register Total Fund By Year List
     * @request GET:/v1/sr/tax-report/register-total-fund-by-year
     * @secure
     */
    getRegisterTotalFundByYearListV1SrTaxReportRegisterTotalFundByYearGet: (
      query: GetRegisterTotalFundByYearListV1SrTaxReportRegisterTotalFundByYearGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetRegisterTotalFundByYearListResponse, HTTPValidationError>(
        {
          path: `/v1/sr/tax-report/register-total-fund-by-year`,
          method: "GET",
          query: query,
          secure: true,
          format: "json",
          ...params,
        },
      ),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name GetRegisterTotalFundByYearRegisterHoldersV1SrTaxReportRegisterTotalFundByYearHoldersGet
     * @summary Get Register Total Fund By Year Register Holders
     * @request GET:/v1/sr/tax-report/register-total-fund-by-year/holders
     * @secure
     */
    getRegisterTotalFundByYearRegisterHoldersV1SrTaxReportRegisterTotalFundByYearHoldersGet:
      (
        query: GetRegisterTotalFundByYearRegisterHoldersV1SrTaxReportRegisterTotalFundByYearHoldersGetParams,
        params: RequestParams = {},
      ) =>
        this.request<
          GetRegisterTotalFundByYearRegisterHoldersResponse,
          HTTPValidationError
        >({
          path: `/v1/sr/tax-report/register-total-fund-by-year/holders`,
          method: "GET",
          query: query,
          secure: true,
          format: "json",
          ...params,
        }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name GetHolderTaxReportYearsByRegisterV1SrTaxReportHolderByYearDataYearsGet
     * @summary Get Holder Tax Report Years By Register
     * @request GET:/v1/sr/tax-report/holder-by-year-data/years
     * @secure
     */
    getHolderTaxReportYearsByRegisterV1SrTaxReportHolderByYearDataYearsGet: (
      query: GetHolderTaxReportYearsByRegisterV1SrTaxReportHolderByYearDataYearsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<
        GetHolderTaxReportYearsByRegisterResponse,
        HTTPValidationError
      >({
        path: `/v1/sr/tax-report/holder-by-year-data/years`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name GetHolderTaxReportByYearDataV1SrTaxReportHolderByYearDataGet
     * @summary Get Holder Tax Report By Year Data
     * @request GET:/v1/sr/tax-report/holder-by-year-data
     * @secure
     */
    getHolderTaxReportByYearDataV1SrTaxReportHolderByYearDataGet: (
      query: GetHolderTaxReportByYearDataV1SrTaxReportHolderByYearDataGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetHolderTaxReportByYearDataResponse, HTTPValidationError>({
        path: `/v1/sr/tax-report/holder-by-year-data`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name UpsertHolderTaxReportByYearDataV1SrTaxReportHolderByYearDataPut
     * @summary Upsert Holder Tax Report By Year Data
     * @request PUT:/v1/sr/tax-report/holder-by-year-data
     * @secure
     */
    upsertHolderTaxReportByYearDataV1SrTaxReportHolderByYearDataPut: (
      data: UpsertHolderTaxReportByYearDataRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        UpsertHolderTaxReportByYearDataResponse,
        HTTPValidationError
      >({
        path: `/v1/sr/tax-report/holder-by-year-data`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** super_admin
     *
     * @tags sr
     * @name ExtractInvestorDataV1SrExtractInvestorDataPost
     * @summary Extract Investor Data
     * @request POST:/v1/sr/extract/investor-data
     * @secure
     */
    extractInvestorDataV1SrExtractInvestorDataPost: (
      data: InvestorDataExtractionRequest,
      params: RequestParams = {},
    ) =>
      this.request<InvestorDataExtractionResponse, HTTPValidationError>({
        path: `/v1/sr/extract/investor-data`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Archive dividend event and all related entities by ID (soft delete). **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name ArchiveDividendV1SrArchivingDividendsIdPost
     * @summary Archive Dividend
     * @request POST:/v1/sr/archiving/dividends/{id}
     * @secure
     */
    archiveDividendV1SrArchivingDividendsIdPost: (
      { id }: ArchiveDividendV1SrArchivingDividendsIdPostParams,
      params: RequestParams = {},
    ) =>
      this.request<ArchiveDividendEventResponse, HTTPValidationError>({
        path: `/v1/sr/archiving/dividends/${id}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name ArchivePaymentV1SrArchivingPaymentsIdPost
     * @summary Archive Payment
     * @request POST:/v1/sr/archiving/payments/{id}
     * @secure
     */
    archivePaymentV1SrArchivingPaymentsIdPost: (
      { id }: ArchivePaymentV1SrArchivingPaymentsIdPostParams,
      params: RequestParams = {},
    ) =>
      this.request<ArchivePaymentByIdResponse, HTTPValidationError>({
        path: `/v1/sr/archiving/payments/${id}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name ArchiveTransactionV1SrArchivingTransactionsIdPost
     * @summary Archive Transaction
     * @request POST:/v1/sr/archiving/transactions/{id}
     * @secure
     */
    archiveTransactionV1SrArchivingTransactionsIdPost: (
      { id }: ArchiveTransactionV1SrArchivingTransactionsIdPostParams,
      params: RequestParams = {},
    ) =>
      this.request<ArchiveTransactionByIdResponse, HTTPValidationError>({
        path: `/v1/sr/archiving/transactions/${id}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name ArchiveTransferV1SrArchivingTransferIdPost
     * @summary Archive Transfer
     * @request POST:/v1/sr/archiving/transfer/{id}
     * @secure
     */
    archiveTransferV1SrArchivingTransferIdPost: (
      { id }: ArchiveTransferV1SrArchivingTransferIdPostParams,
      params: RequestParams = {},
    ) =>
      this.request<ArchiveTransferByIdResponse, HTTPValidationError>({
        path: `/v1/sr/archiving/transfer/${id}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name GetBuybackV1SrBuyBackEventsIdGet
     * @summary Get Buyback
     * @request GET:/v1/sr/buy-back-events/{id}
     * @secure
     */
    getBuybackV1SrBuyBackEventsIdGet: (
      { id, ...query }: GetBuybackV1SrBuyBackEventsIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetBuyBackByIdExtendedResponse, HTTPValidationError>({
        path: `/v1/sr/buy-back-events/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr
     * @name ArchiveBuybackV1SrBuyBackEventsIdPost
     * @summary Archive Buyback
     * @request POST:/v1/sr/buy-back-events/{id}
     * @secure
     */
    archiveBuybackV1SrBuyBackEventsIdPost: (
      { id }: ArchiveBuybackV1SrBuyBackEventsIdPostParams,
      params: RequestParams = {},
    ) =>
      this.request<ArchiveBuyBackByIdResponse, HTTPValidationError>({
        path: `/v1/sr/buy-back-events/${id}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags charts
     * @name GetTopHoldersChartV1SrChartsIssuerTopHoldersGet
     * @summary Get Top Holders Chart
     * @request GET:/v1/sr/charts/issuer/top-holders
     * @secure
     */
    getTopHoldersChartV1SrChartsIssuerTopHoldersGet: (
      query: GetTopHoldersChartV1SrChartsIssuerTopHoldersGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetIssuerTopHoldersResponse, HTTPValidationError>({
        path: `/v1/sr/charts/issuer/top-holders`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags charts
     * @name GetPendingApplicationChartV1SrChartsIssuerPendingApplicationGet
     * @summary Get Pending Application Chart
     * @request GET:/v1/sr/charts/issuer/pending-application
     * @secure
     */
    getPendingApplicationChartV1SrChartsIssuerPendingApplicationGet: (
      params: RequestParams = {},
    ) =>
      this.request<GetPendingApplicationChartResponse, HTTPValidationError>({
        path: `/v1/sr/charts/issuer/pending-application`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags charts
     * @name GetApplicationOverTimeChartV1SrChartsIssuerApplicationOverTimeGet
     * @summary Get Application Over Time Chart
     * @request GET:/v1/sr/charts/issuer/application-over-time
     * @secure
     */
    getApplicationOverTimeChartV1SrChartsIssuerApplicationOverTimeGet: (
      query: GetApplicationOverTimeChartV1SrChartsIssuerApplicationOverTimeGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetApplicationOverTimeChartResponse, HTTPValidationError>({
        path: `/v1/sr/charts/issuer/application-over-time`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags charts
     * @name GetIssuedCapitalChartV1SrChartsIssuerIssuedCapitalGet
     * @summary Get Issued Capital Chart
     * @request GET:/v1/sr/charts/issuer/issued-capital
     * @secure
     */
    getIssuedCapitalChartV1SrChartsIssuerIssuedCapitalGet: (
      query: GetIssuedCapitalChartV1SrChartsIssuerIssuedCapitalGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetIssuedCapitalChartResponse, HTTPValidationError>({
        path: `/v1/sr/charts/issuer/issued-capital`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags charts
     * @name GetCommunicationPreferenceChartV1SrChartsIssuerCommunicationPreferenceGet
     * @summary Get Communication Preference Chart
     * @request GET:/v1/sr/charts/issuer/communication-preference
     * @secure
     */
    getCommunicationPreferenceChartV1SrChartsIssuerCommunicationPreferenceGet: (
      params: RequestParams = {},
    ) =>
      this.request<
        GetCommunicationPreferenceChartResponse,
        HTTPValidationError
      >({
        path: `/v1/sr/charts/issuer/communication-preference`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags charts
     * @name GetPaymentElectionChartV1SrChartsIssuerPaymentElectionGet
     * @summary Get Payment Election Chart
     * @request GET:/v1/sr/charts/issuer/payment-election
     * @secure
     */
    getPaymentElectionChartV1SrChartsIssuerPaymentElectionGet: (
      params: RequestParams = {},
    ) =>
      this.request<GetPaymentElectionChartResponse, HTTPValidationError>({
        path: `/v1/sr/charts/issuer/payment-election`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags charts
     * @name GetPendingApplicationSummaryV1SrChartsIssuerPendingApplicationSummaryGet
     * @summary Get Pending Application Summary
     * @request GET:/v1/sr/charts/issuer/pending-application-summary
     * @secure
     */
    getPendingApplicationSummaryV1SrChartsIssuerPendingApplicationSummaryGet: (
      query: GetPendingApplicationSummaryV1SrChartsIssuerPendingApplicationSummaryGetParams,
      params: RequestParams = {},
    ) =>
      this.request<
        GetPendingApplicationSummaryChartResponse,
        HTTPValidationError
      >({
        path: `/v1/sr/charts/issuer/pending-application-summary`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags charts
     * @name GetIssuedCapitalOverTimeV1SrChartsIssuerIssuedCapitalOverTimeGet
     * @summary Get Issued Capital Over Time
     * @request GET:/v1/sr/charts/issuer/issued-capital-over-time
     * @secure
     */
    getIssuedCapitalOverTimeV1SrChartsIssuerIssuedCapitalOverTimeGet: (
      query: GetIssuedCapitalOverTimeV1SrChartsIssuerIssuedCapitalOverTimeGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetIssuedCapitalOvertimeChartResponse, HTTPValidationError>({
        path: `/v1/sr/charts/issuer/issued-capital-over-time`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Issued capital over time: Similar to application overtime time series chart, uses issued capital formula over time **Required roles:** issuer, issuer_admin
     *
     * @tags charts
     * @name GetIssuedCapitalOverTimeBySecuritiesV1SrChartsIssuerIssuedCapitalOverTimeBySecuritiesGet
     * @summary Get Issued Capital Over Time By Securities
     * @request GET:/v1/sr/charts/issuer/issued-capital-over-time-by-securities
     * @secure
     */
    getIssuedCapitalOverTimeBySecuritiesV1SrChartsIssuerIssuedCapitalOverTimeBySecuritiesGet:
      (
        query: GetIssuedCapitalOverTimeBySecuritiesV1SrChartsIssuerIssuedCapitalOverTimeBySecuritiesGetParams,
        params: RequestParams = {},
      ) =>
        this.request<
          GetIssuedCapitalOvertimeChartBySecuritiesResponse,
          HTTPValidationError
        >({
          path: `/v1/sr/charts/issuer/issued-capital-over-time-by-securities`,
          method: "GET",
          query: query,
          secure: true,
          format: "json",
          ...params,
        }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sections
     * @name GetCapitalSummarySectionV1SrSectionsIssuerCapitalSummaryGet
     * @summary Get Capital Summary Section
     * @request GET:/v1/sr/sections/issuer/capital-summary
     * @secure
     */
    getCapitalSummarySectionV1SrSectionsIssuerCapitalSummaryGet: (
      query: GetCapitalSummarySectionV1SrSectionsIssuerCapitalSummaryGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetIssuerCapitalSummarySectionResponse, HTTPValidationError>(
        {
          path: `/v1/sr/sections/issuer/capital-summary`,
          method: "GET",
          query: query,
          secure: true,
          format: "json",
          ...params,
        },
      ),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sections
     * @name GetPendingApplicationSummarySectionV1SrSectionsIssuerPendingApplicationSummaryGet
     * @summary Get Pending Application Summary Section
     * @request GET:/v1/sr/sections/issuer/pending-application-summary
     * @secure
     */
    getPendingApplicationSummarySectionV1SrSectionsIssuerPendingApplicationSummaryGet:
      (
        query: GetPendingApplicationSummarySectionV1SrSectionsIssuerPendingApplicationSummaryGetParams,
        params: RequestParams = {},
      ) =>
        this.request<
          GetPendingApplicationSummarySectionResponse,
          HTTPValidationError
        >({
          path: `/v1/sr/sections/issuer/pending-application-summary`,
          method: "GET",
          query: query,
          secure: true,
          format: "json",
          ...params,
        }),

    /**
     * No description
     *
     * @tags sr/certificates
     * @name GetShareCertificateDataV1SrCertificatesShareCertificateDataCodeGet
     * @summary Get Share Certificate Data
     * @request GET:/v1/sr/certificates/share-certificate-data/{code}
     */
    getShareCertificateDataV1SrCertificatesShareCertificateDataCodeGet: (
      {
        code,
      }: GetShareCertificateDataV1SrCertificatesShareCertificateDataCodeGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetShareCertificateDataResponse, HTTPValidationError>({
        path: `/v1/sr/certificates/share-certificate-data/${code}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** super_admin
     *
     * @tags sr/certificates
     * @name GenerateCertificatesForRegisterV1SrCertificatesGenerateCertificatesForRegisterPost
     * @summary Generate Certificates For Register
     * @request POST:/v1/sr/certificates/generate-certificates-for-register
     * @secure
     */
    generateCertificatesForRegisterV1SrCertificatesGenerateCertificatesForRegisterPost:
      (
        data: GenerateCertificatesForRegisterRequest,
        params: RequestParams = {},
      ) =>
        this.request<
          GenerateCertificatesForRegisterResponse,
          HTTPValidationError
        >({
          path: `/v1/sr/certificates/generate-certificates-for-register`,
          method: "POST",
          body: data,
          secure: true,
          type: ContentType.Json,
          format: "json",
          ...params,
        }),

    /**
     * @description **Required roles:** investor
     *
     * @tags sr/certificates
     * @name GetListByInvestorV1SrCertificatesInvestorGet
     * @summary Get List By Investor
     * @request GET:/v1/sr/certificates/investor
     * @secure
     */
    getListByInvestorV1SrCertificatesInvestorGet: (
      query: GetListByInvestorV1SrCertificatesInvestorGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetInvestorCertificateListResponse, HTTPValidationError>({
        path: `/v1/sr/certificates/investor`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags sr/certificates
     * @name GetListByIssuerV1SrCertificatesIssuerGet
     * @summary Get List By Issuer
     * @request GET:/v1/sr/certificates/issuer
     * @secure
     */
    getListByIssuerV1SrCertificatesIssuerGet: (
      query: GetListByIssuerV1SrCertificatesIssuerGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetIssuerCertificateListResponse, HTTPValidationError>({
        path: `/v1/sr/certificates/issuer`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags bronid
     * @name GetVerificationStatusV1SrBronidGetVerificationStatusGet
     * @summary Get Verification Status
     * @request GET:/v1/sr/bronid/get-verification-status
     * @secure
     */
    getVerificationStatusV1SrBronidGetVerificationStatusGet: (
      query: GetVerificationStatusV1SrBronidGetVerificationStatusGetParams,
      params: RequestParams = {},
    ) =>
      this.request<BronIDGetVerificationStatusResponse, HTTPValidationError>({
        path: `/v1/sr/bronid/get-verification-status`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor, issuer, issuer_admin, super_admin
     *
     * @tags blockchain
     * @name GetBlockchainInfoV1BlockchainInfoGet
     * @summary Get Blockchain Info
     * @request GET:/v1/blockchain/info
     * @secure
     */
    getBlockchainInfoV1BlockchainInfoGet: (params: RequestParams = {}) =>
      this.request<GetBlockchainInfoResponse, HTTPValidationError>({
        path: `/v1/blockchain/info`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** investor, issuer, issuer_admin, super_admin
     *
     * @tags blockchain
     * @name GetBlockchainTransactionsV1BlockchainEventsGet
     * @summary Get Blockchain Transactions
     * @request GET:/v1/blockchain/events
     * @secure
     */
    getBlockchainTransactionsV1BlockchainEventsGet: (
      query: GetBlockchainTransactionsV1BlockchainEventsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetBlockchainEventResponse, HTTPValidationError>({
        path: `/v1/blockchain/events`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags webhook
     * @name BackChannelLogoutV1WebhookBackChannelLogoutPost
     * @summary Back Channel Logout
     * @request POST:/v1/webhook/back-channel-logout
     */
    backChannelLogoutV1WebhookBackChannelLogoutPost: (
      data: BackChannelLogoutRequest,
      params: RequestParams = {},
    ) =>
      this.request<BackChannelLogoutResponse, HTTPValidationError>({
        path: `/v1/webhook/back-channel-logout`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags webhook
     * @name KeycloakEventWebhookV1WebhookKeycloakEventPost
     * @summary Keycloak Event Webhook
     * @request POST:/v1/webhook/keycloak-event
     */
    keycloakEventWebhookV1WebhookKeycloakEventPost: (
      data: EntityPaymentInfoVerifiedRequest,
      params: RequestParams = {},
    ) =>
      this.request<WebhookEventsResponse, HTTPValidationError>({
        path: `/v1/webhook/keycloak-event`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags webhook
     * @name SnsTopicWebhookV1WebhookSnsTopicPost
     * @summary Sns Topic Webhook
     * @request POST:/v1/webhook/sns-topic
     */
    snsTopicWebhookV1WebhookSnsTopicPost: (
      data: EntityPaymentInfoVerifiedRequest,
      params: RequestParams = {},
    ) =>
      this.request<GetCorrespondencesResponse, HTTPValidationError>({
        path: `/v1/webhook/sns-topic`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer_admin
     *
     * @tags investor-edit
     * @name UpdateInvestorEditStatusV1InvestorEditStatusPatch
     * @summary Update Investor Edit Status
     * @request PATCH:/v1/investor-edit/status
     * @secure
     */
    updateInvestorEditStatusV1InvestorEditStatusPatch: (
      data: HandleInvestorEditsRequest,
      params: RequestParams = {},
    ) =>
      this.request<HandleInvestorEditsResponse, HTTPValidationError>({
        path: `/v1/investor-edit/status`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags investor-edit
     * @name CreateInvestorEditRequestV1InvestorEditPost
     * @summary Create Investor Edit Request
     * @request POST:/v1/investor-edit
     * @secure
     */
    createInvestorEditRequestV1InvestorEditPost: (
      data: CreateHolderDetailsRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateHolderDetailsResponse, HTTPValidationError>({
        path: `/v1/investor-edit`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags investor-edit
     * @name UpdateInvestorEditRequestV1InvestorEditPatch
     * @summary Update Investor Edit Request
     * @request PATCH:/v1/investor-edit
     * @secure
     */
    updateInvestorEditRequestV1InvestorEditPatch: (
      data: UpdateHolderDetailsRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateHolderDetailsResponse, HTTPValidationError>({
        path: `/v1/investor-edit`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags investor-edit
     * @name GetInvestorEditListV1InvestorEditGet
     * @summary Get Investor Edit List
     * @request GET:/v1/investor-edit
     * @secure
     */
    getInvestorEditListV1InvestorEditGet: (
      query: GetInvestorEditListV1InvestorEditGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetInvestorEditListResponse, HTTPValidationError>({
        path: `/v1/investor-edit`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags investor-edit
     * @name ChangeStatusToAwaitingApprovalV1InvestorEditAwaitingApprovalIdPatch
     * @summary Change Status To Awaiting Approval
     * @request PATCH:/v1/investor-edit/awaiting-approval/{id}
     * @secure
     */
    changeStatusToAwaitingApprovalV1InvestorEditAwaitingApprovalIdPatch: (
      {
        id,
      }: ChangeStatusToAwaitingApprovalV1InvestorEditAwaitingApprovalIdPatchParams,
      params: RequestParams = {},
    ) =>
      this.request<GetInvestorEditListResponse, HTTPValidationError>({
        path: `/v1/investor-edit/awaiting-approval/${id}`,
        method: "PATCH",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags investor-edit
     * @name GetInvestorEditRequestByIdV1InvestorEditIdGet
     * @summary Get Investor Edit Request By Id
     * @request GET:/v1/investor-edit/{id}
     * @secure
     */
    getInvestorEditRequestByIdV1InvestorEditIdGet: (
      { id }: GetInvestorEditRequestByIdV1InvestorEditIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetInvestorEditByIdResponse, HTTPValidationError>({
        path: `/v1/investor-edit/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags self-custody
     * @name CreatePortfolioV1SelfCustodyPortfolioPost
     * @summary Create Portfolio
     * @request POST:/v1/self-custody/portfolio
     * @secure
     */
    createPortfolioV1SelfCustodyPortfolioPost: (
      data: CreatePortfolioRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreatePortfolioResponse, HTTPValidationError>({
        path: `/v1/self-custody/portfolio`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags self-custody
     * @name UpdatePortfolioV1SelfCustodyPortfolioPatch
     * @summary Update Portfolio
     * @request PATCH:/v1/self-custody/portfolio
     * @secure
     */
    updatePortfolioV1SelfCustodyPortfolioPatch: (
      data: UpdatePortfolioRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdatePortfolioResponse, HTTPValidationError>({
        path: `/v1/self-custody/portfolio`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags self-custody
     * @name GetPortfolioListV1SelfCustodyPortfolioGet
     * @summary Get Portfolio List
     * @request GET:/v1/self-custody/portfolio
     * @secure
     */
    getPortfolioListV1SelfCustodyPortfolioGet: (
      query: GetPortfolioListV1SelfCustodyPortfolioGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetPortfolioListResponse, HTTPValidationError>({
        path: `/v1/self-custody/portfolio`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags self-custody
     * @name GetPortfolioByIdV1SelfCustodyPortfolioPortfolioIdGet
     * @summary Get Portfolio By Id
     * @request GET:/v1/self-custody/portfolio/{portfolio_id}
     * @secure
     */
    getPortfolioByIdV1SelfCustodyPortfolioPortfolioIdGet: (
      {
        portfolioId,
        ...query
      }: GetPortfolioByIdV1SelfCustodyPortfolioPortfolioIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetPortfolioByIdResponse, HTTPValidationError>({
        path: `/v1/self-custody/portfolio/${portfolioId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags self-custody
     * @name DeletePortfolioByIdV1SelfCustodyPortfolioPortfolioIdDelete
     * @summary Delete Portfolio By Id
     * @request DELETE:/v1/self-custody/portfolio/{portfolio_id}
     * @secure
     */
    deletePortfolioByIdV1SelfCustodyPortfolioPortfolioIdDelete: (
      {
        portfolioId,
      }: DeletePortfolioByIdV1SelfCustodyPortfolioPortfolioIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeletePortfolioByIdResponse, HTTPValidationError>({
        path: `/v1/self-custody/portfolio/${portfolioId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags self-custody
     * @name GetAssetListV1SelfCustodyAssetGet
     * @summary Get Asset List
     * @request GET:/v1/self-custody/asset
     * @secure
     */
    getAssetListV1SelfCustodyAssetGet: (
      query: GetAssetListV1SelfCustodyAssetGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetAssetListResponse, HTTPValidationError>({
        path: `/v1/self-custody/asset`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags self-custody
     * @name CreateAssetV1SelfCustodyAssetPost
     * @summary Create Asset
     * @request POST:/v1/self-custody/asset
     * @secure
     */
    createAssetV1SelfCustodyAssetPost: (
      data: CreateAssetRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateAssetResponse, HTTPValidationError>({
        path: `/v1/self-custody/asset`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags self-custody
     * @name UpdateAssetV1SelfCustodyAssetPatch
     * @summary Update Asset
     * @request PATCH:/v1/self-custody/asset
     * @secure
     */
    updateAssetV1SelfCustodyAssetPatch: (
      data: UpdateAssetRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateAssetResponse, HTTPValidationError>({
        path: `/v1/self-custody/asset`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags self-custody
     * @name GetAssetByIdV1SelfCustodyAssetAssetIdGet
     * @summary Get Asset By Id
     * @request GET:/v1/self-custody/asset/{asset_id}
     * @secure
     */
    getAssetByIdV1SelfCustodyAssetAssetIdGet: (
      { assetId, ...query }: GetAssetByIdV1SelfCustodyAssetAssetIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetAssetByIdResponse, HTTPValidationError>({
        path: `/v1/self-custody/asset/${assetId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags self-custody
     * @name DeleteAssetByIdV1SelfCustodyAssetAssetIdDelete
     * @summary Delete Asset By Id
     * @request DELETE:/v1/self-custody/asset/{asset_id}
     * @secure
     */
    deleteAssetByIdV1SelfCustodyAssetAssetIdDelete: (
      { assetId }: DeleteAssetByIdV1SelfCustodyAssetAssetIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteAssetByIdResponse, HTTPValidationError>({
        path: `/v1/self-custody/asset/${assetId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags self-custody
     * @name GetOutdatedAssetsV1SelfCustodyAssetsOutdatedGet
     * @summary Get Outdated Assets
     * @request GET:/v1/self-custody/assets/outdated
     * @secure
     */
    getOutdatedAssetsV1SelfCustodyAssetsOutdatedGet: (
      params: RequestParams = {},
    ) =>
      this.request<GetOutdatedAssetsResponse, HTTPValidationError>({
        path: `/v1/self-custody/assets/outdated`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags self-custody
     * @name RefreshAssetPriceV1SelfCustodyAssetAssetIdRefreshPricePost
     * @summary Refresh Asset Price
     * @request POST:/v1/self-custody/asset/{asset_id}/refresh-price
     * @secure
     */
    refreshAssetPriceV1SelfCustodyAssetAssetIdRefreshPricePost: (
      {
        assetId,
      }: RefreshAssetPriceV1SelfCustodyAssetAssetIdRefreshPricePostParams,
      params: RequestParams = {},
    ) =>
      this.request<UpdateAssetPricesResponse, HTTPValidationError>({
        path: `/v1/self-custody/asset/${assetId}/refresh-price`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags self-custody
     * @name CreatePortfolioTransactionV1SelfCustodyPortfolioTransactionPost
     * @summary Create Portfolio Transaction
     * @request POST:/v1/self-custody/portfolio-transaction
     * @secure
     */
    createPortfolioTransactionV1SelfCustodyPortfolioTransactionPost: (
      data: CreatePortfolioTransactionRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreatePortfolioTransactionResponse, HTTPValidationError>({
        path: `/v1/self-custody/portfolio-transaction`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags self-custody
     * @name UpdatePortfolioTransactionV1SelfCustodyPortfolioTransactionPatch
     * @summary Update Portfolio Transaction
     * @request PATCH:/v1/self-custody/portfolio-transaction
     * @secure
     */
    updatePortfolioTransactionV1SelfCustodyPortfolioTransactionPatch: (
      data: UpdatePortfolioTransactionRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdatePortfolioTransactionResponse, HTTPValidationError>({
        path: `/v1/self-custody/portfolio-transaction`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags self-custody
     * @name GetPortfolioTransactionListV1SelfCustodyPortfolioTransactionGet
     * @summary Get Portfolio Transaction List
     * @request GET:/v1/self-custody/portfolio-transaction
     * @secure
     */
    getPortfolioTransactionListV1SelfCustodyPortfolioTransactionGet: (
      query: GetPortfolioTransactionListV1SelfCustodyPortfolioTransactionGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetPortfolioTransactionListResponse, HTTPValidationError>({
        path: `/v1/self-custody/portfolio-transaction`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags self-custody
     * @name DeletePortfolioTransactionByIdV1SelfCustodyPortfolioTransactionTransactionIdDelete
     * @summary Delete Portfolio Transaction By Id
     * @request DELETE:/v1/self-custody/portfolio-transaction/{transaction_id}
     * @secure
     */
    deletePortfolioTransactionByIdV1SelfCustodyPortfolioTransactionTransactionIdDelete:
      (
        {
          transactionId,
        }: DeletePortfolioTransactionByIdV1SelfCustodyPortfolioTransactionTransactionIdDeleteParams,
        params: RequestParams = {},
      ) =>
        this.request<
          DeletePortfolioTransactionByIdResponse,
          HTTPValidationError
        >({
          path: `/v1/self-custody/portfolio-transaction/${transactionId}`,
          method: "DELETE",
          secure: true,
          format: "json",
          ...params,
        }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags self-custody
     * @name GetPortfolioTransactionByIdV1SelfCustodyPortfolioTransactionTransactionIdGet
     * @summary Get Portfolio Transaction By Id
     * @request GET:/v1/self-custody/portfolio-transaction/{transaction_id}
     * @secure
     */
    getPortfolioTransactionByIdV1SelfCustodyPortfolioTransactionTransactionIdGet:
      (
        {
          transactionId,
        }: GetPortfolioTransactionByIdV1SelfCustodyPortfolioTransactionTransactionIdGetParams,
        params: RequestParams = {},
      ) =>
        this.request<GetPortfolioTransactionByIdResponse, HTTPValidationError>({
          path: `/v1/self-custody/portfolio-transaction/${transactionId}`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags self-custody
     * @name CreatePortfolioNavsV1SelfCustodyNavsPost
     * @summary Create Portfolio Navs
     * @request POST:/v1/self-custody/navs
     * @secure
     */
    createPortfolioNavsV1SelfCustodyNavsPost: (
      data: CreatePortfolioNavsRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreatePortfolioNavsResponse, HTTPValidationError>({
        path: `/v1/self-custody/navs`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags self-custody
     * @name CreatePortfolioCashMovementV1SelfCustodyCashMovementPost
     * @summary Create Portfolio Cash Movement
     * @request POST:/v1/self-custody/cash-movement
     * @secure
     */
    createPortfolioCashMovementV1SelfCustodyCashMovementPost: (
      data: CreatePortfolioCashMovementRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreatePortfolioCashMovementResponse, HTTPValidationError>({
        path: `/v1/self-custody/cash-movement`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags self-custody
     * @name GetPortfolioCashMovementListV1SelfCustodyCashMovementGet
     * @summary Get Portfolio Cash Movement List
     * @request GET:/v1/self-custody/cash-movement
     * @secure
     */
    getPortfolioCashMovementListV1SelfCustodyCashMovementGet: (
      query: GetPortfolioCashMovementListV1SelfCustodyCashMovementGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetPortfolioCashMovementListResponse, HTTPValidationError>({
        path: `/v1/self-custody/cash-movement`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags self-custody
     * @name GetPortfolioCashMovementByIdV1SelfCustodyCashMovementCashMovementIdGet
     * @summary Get Portfolio Cash Movement By Id
     * @request GET:/v1/self-custody/cash-movement/{cash_movement_id}
     * @secure
     */
    getPortfolioCashMovementByIdV1SelfCustodyCashMovementCashMovementIdGet: (
      {
        cashMovementId,
        ...query
      }: GetPortfolioCashMovementByIdV1SelfCustodyCashMovementCashMovementIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetPortfolioCashMovementsByIdResponse, HTTPValidationError>({
        path: `/v1/self-custody/cash-movement/${cashMovementId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags self-custody
     * @name GetAssetsTreemapChartV1SelfCustodyChartsAssetsTreemapGet
     * @summary Get Assets Treemap Chart
     * @request GET:/v1/self-custody/charts/assets-treemap
     * @secure
     */
    getAssetsTreemapChartV1SelfCustodyChartsAssetsTreemapGet: (
      query: GetAssetsTreemapChartV1SelfCustodyChartsAssetsTreemapGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetAssetsTreemapChartResponse, HTTPValidationError>({
        path: `/v1/self-custody/charts/assets-treemap`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags self-custody
     * @name GetAssetsBreakdownChartV1SelfCustodyChartsAssetsBreakdownGet
     * @summary Get Assets Breakdown Chart
     * @request GET:/v1/self-custody/charts/assets-breakdown
     * @secure
     */
    getAssetsBreakdownChartV1SelfCustodyChartsAssetsBreakdownGet: (
      query: GetAssetsBreakdownChartV1SelfCustodyChartsAssetsBreakdownGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetAssetsBreakdownChartResponse, HTTPValidationError>({
        path: `/v1/self-custody/charts/assets-breakdown`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags self-custody
     * @name GetPnlOvertimeChartV1SelfCustodyChartsPnlOvertimeGet
     * @summary Get Pnl Overtime Chart
     * @request GET:/v1/self-custody/charts/pnl-overtime
     * @secure
     */
    getPnlOvertimeChartV1SelfCustodyChartsPnlOvertimeGet: (
      query: GetPnlOvertimeChartV1SelfCustodyChartsPnlOvertimeGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetPnlOvertimeChartResponse, HTTPValidationError>({
        path: `/v1/self-custody/charts/pnl-overtime`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags self-custody
     * @name GetTotalCashInOutChartV1SelfCustodyChartsCashInOutGet
     * @summary Get Total Cash In Out Chart
     * @request GET:/v1/self-custody/charts/cash-in-out
     * @secure
     */
    getTotalCashInOutChartV1SelfCustodyChartsCashInOutGet: (
      query: GetTotalCashInOutChartV1SelfCustodyChartsCashInOutGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetTotalCashInOutChartResponse, HTTPValidationError>({
        path: `/v1/self-custody/charts/cash-in-out`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags self-custody
     * @name GetValueOvertimeChartV1SelfCustodyChartsValueOvertimeGet
     * @summary Get Value Overtime Chart
     * @request GET:/v1/self-custody/charts/value-overtime
     * @secure
     */
    getValueOvertimeChartV1SelfCustodyChartsValueOvertimeGet: (
      query: GetValueOvertimeChartV1SelfCustodyChartsValueOvertimeGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetValueOvertimeChartResponse, HTTPValidationError>({
        path: `/v1/self-custody/charts/value-overtime`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags self-custody
     * @name GetOverallBalanceStatisticV1SelfCustodyOverallBalanceStatisticGet
     * @summary Get Overall Balance Statistic
     * @request GET:/v1/self-custody/overall-balance-statistic
     * @secure
     */
    getOverallBalanceStatisticV1SelfCustodyOverallBalanceStatisticGet: (
      query: GetOverallBalanceStatisticV1SelfCustodyOverallBalanceStatisticGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetPortfolioOverallBalanceResponse, HTTPValidationError>({
        path: `/v1/self-custody/overall-balance-statistic`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags self-custody
     * @name CreateBrokerV1SelfCustodyBrokersPost
     * @summary Create Broker
     * @request POST:/v1/self-custody/brokers
     * @secure
     */
    createBrokerV1SelfCustodyBrokersPost: (
      data: CreateBrokerRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateBrokerResponse, HTTPValidationError>({
        path: `/v1/self-custody/brokers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags self-custody
     * @name UpdateBrokerV1SelfCustodyBrokersPatch
     * @summary Update Broker
     * @request PATCH:/v1/self-custody/brokers
     * @secure
     */
    updateBrokerV1SelfCustodyBrokersPatch: (
      data: UpdateBrokerRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateBrokerResponse, HTTPValidationError>({
        path: `/v1/self-custody/brokers`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags self-custody
     * @name GetBrokerListV1SelfCustodyBrokersGet
     * @summary Get Broker List
     * @request GET:/v1/self-custody/brokers
     * @secure
     */
    getBrokerListV1SelfCustodyBrokersGet: (
      query: GetBrokerListV1SelfCustodyBrokersGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetBrokerListResponse, HTTPValidationError>({
        path: `/v1/self-custody/brokers`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags self-custody
     * @name GetBrokerByIdV1SelfCustodyBrokersBrokerIdGet
     * @summary Get Broker By Id
     * @request GET:/v1/self-custody/brokers/{broker_id}
     * @secure
     */
    getBrokerByIdV1SelfCustodyBrokersBrokerIdGet: (
      { brokerId }: GetBrokerByIdV1SelfCustodyBrokersBrokerIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetBrokerByIdResponse, HTTPValidationError>({
        path: `/v1/self-custody/brokers/${brokerId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags self-custody
     * @name DeleteBrokerByIdV1SelfCustodyBrokersBrokerIdDelete
     * @summary Delete Broker By Id
     * @request DELETE:/v1/self-custody/brokers/{broker_id}
     * @secure
     */
    deleteBrokerByIdV1SelfCustodyBrokersBrokerIdDelete: (
      { brokerId }: DeleteBrokerByIdV1SelfCustodyBrokersBrokerIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteBrokerByIdResponse, HTTPValidationError>({
        path: `/v1/self-custody/brokers/${brokerId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags register-banks
     * @name GetRegisterBankListV1SrRegisterBanksGet
     * @summary Get Register Bank List
     * @request GET:/v1/sr/register-banks
     * @secure
     */
    getRegisterBankListV1SrRegisterBanksGet: (
      query: GetRegisterBankListV1SrRegisterBanksGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetRegisterBankListResponse, HTTPValidationError>({
        path: `/v1/sr/register-banks`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags register-banks
     * @name CreateRegisterBankV1SrRegisterBanksPost
     * @summary Create Register Bank
     * @request POST:/v1/sr/register-banks
     * @secure
     */
    createRegisterBankV1SrRegisterBanksPost: (
      data: CreateRegisterBankRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateRegisterBankResponse, HTTPValidationError>({
        path: `/v1/sr/register-banks`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags register-banks
     * @name UpdateRegisterBankV1SrRegisterBanksPatch
     * @summary Update Register Bank
     * @request PATCH:/v1/sr/register-banks
     * @secure
     */
    updateRegisterBankV1SrRegisterBanksPatch: (
      data: UpdateRegisterBankRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateRegisterBankResponse, HTTPValidationError>({
        path: `/v1/sr/register-banks`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags register-banks
     * @name GetRegisterBankByIdV1SrRegisterBanksRegisterBankIdGet
     * @summary Get Register Bank By Id
     * @request GET:/v1/sr/register-banks/{register_bank_id}
     * @secure
     */
    getRegisterBankByIdV1SrRegisterBanksRegisterBankIdGet: (
      {
        registerBankId,
      }: GetRegisterBankByIdV1SrRegisterBanksRegisterBankIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetRegisterBankByIdResponse, HTTPValidationError>({
        path: `/v1/sr/register-banks/${registerBankId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description **Required roles:** issuer, issuer_admin
     *
     * @tags register-banks
     * @name DeleteRegisterBankV1SrRegisterBanksRegisterBankIdDelete
     * @summary Delete Register Bank
     * @request DELETE:/v1/sr/register-banks/{register_bank_id}
     * @secure
     */
    deleteRegisterBankV1SrRegisterBanksRegisterBankIdDelete: (
      {
        registerBankId,
      }: DeleteRegisterBankV1SrRegisterBanksRegisterBankIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteRegisterBankResponse, HTTPValidationError>({
        path: `/v1/sr/register-banks/${registerBankId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
